import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CommonService } from '../services/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, FormControl, FormGroup, Validators,ValidatorFn,AbstractControl } from '@angular/forms';
import { TryitoutComponent } from '../tryitout/tryitout.component';
import { XmlmappingsComponent } from '../xmlmappings/xmlmappings.component';
import { VarulesComponent } from '../varules/varules.component';
import { FaxVarulesComponent } from '../fax-varules/fax-varules.component';
import { FtpfilesComponent } from '../ftpfiles/ftpfiles.component';
import { RouteNotesComponent } from '../route-notes/route-notes.component';
import { ToastrService } from 'ngx-toastr';
declare const copyToClipboard: any;
declare const copyToClipboardtable: any;

import { ConfirmDialogModel, ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { VbjobsdisplayComponent } from '../vbjobsdisplay/vbjobsdisplay.component';
import { SavevendorComponent } from '../vendor/Savevendor/savevendor.component';
import { ConfigComponent } from '../config/config.component';
import { Subscription, firstValueFrom, forkJoin, Subject, of } from 'rxjs';
import { finalize, switchMap, map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MailComponent } from '../mail/mail.component';
import { NewauditComponent } from '../newaudit/newaudit.component';
import { HttpClient } from '@angular/common/http';
import {RuleConfigComponentComponent} from '../rule-config-component/rule-config-component.component';
import { RuleEngineService } from '../services/rule-engine.service';
import { TabChangeService } from '../services/tab-change.service';
import { ModalTabVisibilityService } from '../services/modal-tab-visibility.service';
import { InterfacemappingComponent } from '../interfacemapping/interfacemapping.component';

declare var $;

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']

})
export class CreateComponent implements OnInit, OnDestroy {


  createrulejsonvalues = environment.HandlerandRuleCreate.RulePostJson;
  isRuleConfigEmptyOrNull:boolean = true;
  lockdescription: string = '';
  languageMenuTrigger: MatMenuTrigger;
  public reactiveFormsource: FormGroup;
  public reactiveFormtarget: FormGroup;
  public reactiveFormprocess: FormGroup;
  public reactiveFormroute: FormGroup;
  public reactiveFormvbjob: FormGroup;
  public reactiveFormsourceagent: FormGroup;
  public reactiveFormTargetagent: FormGroup;
  public reactiveFormmode: FormGroup;
  public reactiveFormvbagent: FormGroup;
  public reactiveFormmsgtype: FormGroup;
  public reactiveFormroutepolicy: FormGroup;
  public reactiveFormprojectname: FormGroup;
  reactiveFormagent=this._fb.group({agentname:''});
  AgentNameList:any[]=[];
  isLoadingagent1:boolean;
  notfounddataagent:boolean;
  selectedAgentguid:string;

  btncolor = '#17a0b4'
  vpncustomerpath:string='';
  handlerSpinner: boolean;
  ruleSpinner: boolean;
  SourceAccountList = <any>[];
  TargetAccountList = <any>[];
  ProcessorList = <any>[];
  DeviceList = <any>[];
  isviewpasswordftp: boolean;
  isviewpasswordexftp: boolean;
  selectedsourceaccountid: string = "";
  selectedsourceaccountName: string = "";
  selectedtargetaccountid: string = "";
  selectedtargetaccountName: string = "";
  sourceIsTestOrganization: string = '';
  destinationIsTestOrganization: string = '';
  private testOrgFlagsLoadedForSourceGuid = '';
  private testOrgFlagsLoadedForDestGuid = '';
  selectedprocessagentid: string = "";
  selectedprocessdisplayname: string = "";
  selectedprocessapikey: string = "";
  selectedsourceorgid: string = "";
  selectedtargetorgid: string = "";
  envTarget: string = "";
  routingAgentId: string = "";
  sourceentitymnemonic: string = "";
  targetentitymnemonic: string = "";
  vendormnemonic: string = "";
  selectedrname: string = ''
  isShown: boolean;
  btnshowtryit: boolean = false;
  deploymentkey: string = '';
  sourceassociatedaccountids: string = '';
  targetassociatedaccountids: string = '';
  isvalidationack: boolean;
  isruleengineack: boolean = false;

  protected RouteNameSuggest: any = environment.RouteNameSuggest;
  outboundradioItems: Array<string>;
  vbradioItems: Array<string>;
  modelradio: any = {};
  outboundmodelradio: any = {};
  modelvbclient: any = {};
  modeSelected: string = '';
  rulebuttonshow: boolean = false;
  notfounddata: boolean;
  RouteConfigList: any[];
  formatType: string = "json";
  defaultFormatType: string = 'json';
  configjson: string = '';
  configid: string = '';
  Description: string = '';
  Descriptionflag: boolean = false;
  editorOptions = {
    theme: 'vs', language: this.formatType, readOnly: true, wordWrap: 'on', scrollBeyondLastLine: false
  };
  configagentid: string = "";
  isLoadingagent: boolean;
  SourceAgentNameList: any;
  messageTypeList: any[];
  RoutePolicyList = [
    { name: 'SA..', value: 'SA..' },
    { name: 'SA.SE.', value: 'SA.SE.' },
    { name: 'SA..DE', value: 'SA..DE' },
    { name: 'SA.SE.DE', value: 'SA.SE.DE' }];
  routepolicyselected: string = "Select";
  messagetypeselected: string = "Select";
  TargetAgentNameList: any[];
  selectedsourceagentid: any;
  selectedsourceapikey: any;
  isLoadingTargetagent: boolean;
  selectedtargetapikey: any;
  selectedtargetagentid: any;
  selectedsourceagentname: any;
  selectedtargetagentname: any;
  VendornameBackuplist: any;
  configguids: any;
  RouteConfigBackUpList: any[];
  filteragentlist = <any>[];
  filteragentlistbackup = <any>[];
  messageTypeAllList = <any>[];
  isLoadingstage: boolean = false;
  vpnflag: boolean = false;

  vpncreatedflag: boolean = false;
  configagentapikey: string = '';
  vendorid: any;
  configstatus: any;
  customftp = <CustomFTPDetails>{
    username: '',
    password: '',
    host: '',
    port: '',
    folder: '',
    id: ''
  };
  isLocked: boolean;
  selectRouteNameBackup: any;
  disableGeneratePDFButton: boolean;
  selecteddevice: string = ''
  customfield: boolean
  reqfieldslist: any[] = []
  jobschema: any = ''
  saveresultapiurl: any = ''
  handlerurl: string = ''
  vbagentlist: any = [];
  agentKeyword = 'AgentName';
  selectedvbagentname: string = ''
  selectedvbagentid: string = ''
  notfounddatavbagent: boolean
  savedjobdetails: any = ''
  vbagentlistbackup: any[] = []
  vbFTPFileJob: any = {};
  ipvpnout: string = ''
  portvpnout: any
  sourcepathvpnout: string = ''
  archivepathvpnout: string = ''
  jobres: any
  destinationinbound: any
  showdestin: boolean = false
  projectnamelist: any[] = []
  projectnameBackuplist: any[] = []
  isLoadingProject: boolean
  selectedprojectId: unknown
  id: string
  selectedprojectname: string
  pdf64responsebody: string
  ftpbase64: string
  filenamedisplay: string
  key: string
  Subject = new FormControl('')
  mainSubject = new FormControl('')
  alltoaddressid: any
  allCcid: any
  htmlContent: string
  inboundDeviceKeyword = 'DeviceName';
  devicenamelList = <any>[];
  DeviceListbackup: any[] = [];
  outboundDeviceKeyword = 'DeviceName';
  defaultjobjson: any
  isoutbounddevice: boolean = false
  isinbounddevice: boolean = false
  updateconfigflagftp: boolean = true;
  updateconfigflagvb: boolean = true;
  array_disableradiobuttons: string[] = [];
  vbfolderpathdisplay: string = '';
  vbfolderpathflag: boolean = false;
  ftpalreadycreated: boolean = false;
  vbjobalreadycreated: boolean = false;
  ftpcreatedflag: boolean = false;
  vbjobcreatedflag: boolean = false;
  handlercreatedflag: boolean = false;
  rulecreatedflag: boolean = false;
  ftpcreateddisplaylabel: boolean = false;
  handlercreateddisplaylabel: boolean = false;
  rulecreateddisplaylabel: boolean = false;
  additionalTextField: string = '';
  customFolderPath: string = '';
  selectedVBInstance: string = '';
  vbInstances: any[] = [];
  multiprocguid: string
  multiprocname: any
  multiprocfullname: any
  flag: boolean = true
  vpndetails: boolean;
  savpnconfig: any[] = [];
  selectedmessagetype: string = ""
  selectedtargetagentdisplayname: string = ""
  selectedsourceagentdisplayname: string = ""
  selectedsourcename: string = ""
  selectedtargetname: string = ""
  selectedprocessname: string = ""
  oneditftpradio: boolean
  disableexternalftp: boolean
  adtflag: boolean
  dftflag: boolean = false;
  dftcheck: boolean = false;
  connectivitytype: string = ''
  VBJobCurrentStatus: any;
  screeHeightforinput = window.innerHeight - 390;
  private createsubtab: Subscription = new Subscription();
  duplicatepipeline: any[] = []
  @ViewChild('duplicateModalRight') duplicateModalRight: any;
  
  // Modal tab management
  private tabChangeSubscription: Subscription;
  private componentName = 'create';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];
  private modalRefsTracked: Array<{ ref: any, windowClass: string }> = [];

  private trackModalRef(modalRef: any, windowClass: string = '') {
    this.currentModalRefs.push(modalRef);
    this.modalRefsTracked.push({ ref: modalRef, windowClass });
    this.modalTabVisibility.tagOwned('data-create-modal', windowClass || undefined);
    this.modalWasOpen = true;
  }

  private untrackModalRef(modalRef: any) {
    this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    this.modalRefsTracked = this.modalRefsTracked.filter(m => m.ref !== modalRef);
    if (this.currentModalRefs.length === 0) {
      this.modalWasOpen = false;
    }
  }
  
  keywordaccount = "LocationName";
  sourcedpkeydisplay: string = '';
  sourceentitytype: string = '';
  envSourceProxy: string = '';
  sourcetypedisplay: string = '';
  sourcetypedisplayid: string = '';
  sourcedeployementkey: string = '';
  sourceAgentDeploymentKey: string = '';
  targetAgentDeploymentKey: string = '';
  sourceentityaddress: string = '';
  sourceentityaddress1: string = '';
  sourceentityaddress2: string = '';
  sourcecity: string = '';
  sourcestate: string = '';
  sourcezip: string = '';
  sourcetype: string = '';
  sourceentityprimaryid: string = '';
  sourceorgguid: string = '';
  targetdpkeydisplay: string = '';
  targettypedisplay: string = '';
  targetentitytype: string = '';
  targettypedisplayid: string = '';
  targetdeployementkey: string = '';
  targetentityaddress: string = '';
  targetentityaddress1: string = '';
  targetentityaddress2: string = '';
  targetcity: string = '';
  targetstate: string = '';
  targetzip: string = '';
  targettype: string = '';
  targetentityprimaryid: string = '';
  targetorgguid: string = '';
  messagetype: string = '';
  isLoadingSource: boolean = false;
  isLoadingTarget: boolean = false;
  isLoadingProcesor: boolean = false;
  ftpcheckexsting: boolean = false;
  resultsftpchecknone: boolean = false;
  apiconnectivity: boolean = false;
  ftpexistingpath: string = '';
  vbjobList = <any>[];
  keywordjobname = 'JobName';
  isLoadingjob: boolean = false;
  selectedjobId: string = '';
  selectedjobName: string = '';
  show: boolean = false;
  myFlagForSlideToggle: boolean = false;
  backupmyFlagForSlideToggle: boolean = false;
  isDisabled: boolean = true;
  myFlagftpchecks: boolean = true;
  isftp: boolean = false
  selectedextensionItems: any = [];
  dropdownList: any = [
    { item_id: 1, item_text: ".hl7" },
    { item_id: 2, item_text: ".xml" },
    { item_id: 3, item_text: ".dot" },
    { item_id: 4, item_text: ".txt" },
    { item_id: 5, item_text: ".json" },
    { item_id: 6, item_text: ".pdf" }
  ];
  selectedItems = [];
  dropdownSettings = {
    singleSelection: false,
    idField: "item_id",
    textField: "item_text",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  UniqueID: any = '';
  suggestedroutename: string = ''
  oldmyFlagForSlideToggle: boolean = false;
  copypipelineflag: boolean = false;
  oldselectedrouteDisplayName: string = '';
  copyinterfacemappings: boolean = true;
  resetflag: boolean = false;
  copypiprlinrbutton: boolean = false;
  oldmodeSelected: any;
  oldUniqueID: any = '';
  oldvendarnamevalue: string = "";
  oldselectedprocessagentid: string = "";
  oldselectedprocessdisplayname: string = "";
  oldselectedprocessapikey: string = "";
  oldselectedrouteId: string = "";
  olddynamicJSON: inputField[] = [];
  oldvendorid: string;
  devicejobconfigid: any = ''
  deviceremoteip: any = ''
  deviceremoteport: any = ''
  jobschemadefault: any = {}
  selectedjobtemplateid: string = ''
  selectedjobSubType: string = ''
  dynamicJSON: inputField[] = [];

  keyword = 'name';
  public modeItemsList = [
    {
      id: 'Hold',
      name: 'Hold',
    },
    {
      id: 'Live',
      name: 'Live',
    },
    {
      id: 'Test Live',
      name: 'Test Live',
    }
  ];
  isLoadingvbagent: boolean = false;
  isView: boolean=false;
   isRuleEngine: boolean =false;
  originalValues: any
  isShow: boolean = false;
  UserName: any;
  UserID: any;
  ShowMessage: boolean = false;
  IsValidationAck: boolean = false;
  IsRuleEngineAck: boolean = false;
  /** True when Additional Settings should show Rule Engine Ack toggle (from PreValidation source flags). */
  showRuleEngineAckToggle: boolean = true;
  DuplicateFileFlag: boolean = true;
  ShowLog: boolean = false;
  routingConversionType: string = '';
  MultiInterfacesUser: boolean = false;
  MultiInterfacesName: any;
  FTPV2Flag:boolean=false;
  vbSpinner: boolean = false;
  ftpSpinner: boolean = false;
isRoutingInterface:boolean = false;

  editorInit(editor: any) {
    if (this.configjson) {
      if (this.configjson.startsWith("<")) {
        this.formatType = "xml";
      } else if (this.configjson.startsWith("{")) {
        this.formatType = "json";
      }
      if (this.defaultFormatType != this.formatType) {
        this.defaultFormatType = this.formatType;
        this.editorOptions = {
          ...this.editorOptions,
          language: this.formatType
        };
      }
    }
  }
  routeconfigflag: boolean = true;
  routeconfigflagbackup: boolean = true;
  enableconfig: boolean = false;
  additionalinfoflag: boolean = false;
  vendarnamevalue: string = '';
  messagesubtypevalue: string = '';
  additionalinfodataflag: boolean = false;
  private additionalInfoPending: number = 0;
  customFolderPathDataInputFlag: boolean = true;

  get additionalInfoLoading(): boolean {
    return this.additionalInfoPending > 0;
  }

  private beginAdditionalInfoLoad(): void {
    this.additionalInfoPending++;
  }

  private endAdditionalInfoLoad(): void {
    this.additionalInfoPending = Math.max(0, this.additionalInfoPending - 1);
  }

  public reactiveFormvendar: FormGroup;
  VendarsList: any[];
  isLoadingvendar: boolean = false;
  keywordsearchvendar = "name";
  public reactiveFormAgentFilter: FormGroup;
  isLoadingFilteredValue: boolean;
  selectedInterfacedescription: string = '';
  isShowncustomFTP: boolean = false;
  deploymentsConfigurations: any;
  isflasgSize: Subscription;
  modalconfig: Subscription;
  pipelineselectclass: string = '';
  pagerolepermisions: any = [];

  keywordsearch = 'displayname';
  keywordsearchProject = 'displayname';
  keywordsearchprocessor = 'displayname'
  isLoadingResult: boolean = false;
  RouteNameListPipeline = <any>[];
  selectedrouteId = "";
  selectedrouteDisplayName = "";
  Templatearray: any[];
  closeResult: string;
  processorurl: string = '';  modelvbftp: any = {};
  vbjobdisplayexftp: boolean = false;
  ftpisDisabled: boolean = false;
  vbjobnameftp: string = '';
  copytitle: string = '';
  remotepathdisplay: string = '';
  sourcepath: string = '';
  archivepath: string = '';
  errorpath: string = '';
  progresspath: string = '';
  ftpusername: string;
  ftppassword: string;
  ftphost: string;
  ftpport: string;
  vbjobname: string;
  vbtype: string;
  containername :string;
  vbreturndetails: any = {
    "status": "",
    "jobid": '',
    "jobname": ""
  };
  extensions: Array<string> = [];
  vbFileWatchUploadJob: any = {};
    RuleConfig: any;
    RuleConfigJson:any=[];
  /** Version list from GetRuleConfigVersions; passed to rule dialog when opening. */
  ruleConfigVersionsList: any[] = [];
  PreDeliveryFlag:boolean=false;
  // Version list from GetRuleConfigVersions ; passed to routingrule component
  routingRuleConfigVersionsList :any[] = [];

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private _fb: FormBuilder,
    public service: CommonService,
    private activeModal: NgbActiveModal,
    private router: Router,
    private ngxUiLoaderService: NgxUiLoaderService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private tabChangeService: TabChangeService,
    private modalTabVisibility: ModalTabVisibilityService,
    private _ruleEngineService: RuleEngineService
    ) {
    this.vbradioItems = ['FTPV2','VB Client', 'VPN', 'API', 'Device', 'Other'];
    this.outboundradioItems = ['FTPV2','VPN', 'API', 'Device'];
    if (this.ProcessorAllList.length == 0 && this.dynamicJSON.length == 0) {
      this.InitilizeProcessordata();
      this.setfirstcontrol();
    }
    this.reactiveFormsource = this._fb.group({ name: '' });
    this.reactiveFormtarget = this._fb.group({ namet: '' });
    this.reactiveFormprocess = this._fb.group({ namep: '' });
    this.reactiveFormroute = this._fb.group({ routename: ['', [Validators.required,this.noSpecialCharactersValidator()]] });
    this.reactiveFormvbjob = this._fb.group({ namejob: '' });
    this.reactiveFormvendar = this._fb.group({ namevendar: '', vendorid: '' });
    this.reactiveFormsourceagent = this._fb.group({ sourceagent: '' });
    this.reactiveFormTargetagent = this._fb.group({ targetagent: '' });
    this.reactiveFormmode = this._fb.group({ modename: '' });
    this.reactiveFormvbagent = this._fb.group({ vbagentnameauto: '' });
    this.reactiveFormAgentFilter = this._fb.group({ filteragent: '' });
    this.reactiveFormmsgtype = this._fb.group({ msgname: '' });
    this.reactiveFormroutepolicy = this._fb.group({ routepolicy: '' });
    this.reactiveFormprojectname = this._fb.group({ projectname: '' });
  }


  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
      this.modalRefsTracked = [];
    }
    
    // Also close modals opened from tryitout popup (myCustomModalViewfilehl7ViewerFromCreate)
    const tryitoutPopupModals = Array.from(document.querySelectorAll('.modal.myCustomModalViewfilehl7ViewerFromCreate')) as HTMLElement[];
    if (tryitoutPopupModals.length > 0) {
      // Remove all backdrops with data-create-modal (these belong to tryitout popup modals)
      const backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-create-modal="true"]')) as HTMLElement[];
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });
      // Remove the modals
      tryitoutPopupModals.forEach(modal => {
        modal.remove();
      });
    }
    
    // Remove modal-open class from body if present
    document.body.classList.remove('modal-open');
    
    this.createsubtab.unsubscribe();
    this.selectedrouteId='';
    this.isflasgSize.unsubscribe();
    this.Resetalldata();
    this.vpncheck = false
    this.oneditftpradio = false
    this.vpndetails = false
    this.dftcheck=false;
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }

  async ngOnInit() {
    this.createsubtab.add(this.service.pipelineName_2$.subscribe((id:string)=>{
      if(id!=null && id!=''){
          this.Resetalldata();
          this.reactiveFormprocess.patchValue({
            namep: ''
          });
        let obj=JSON.parse(id);
        this.selectedrouteId=obj.id;
        this.clearconfigdetails();
        this.reactiveFormroute.patchValue({
          routename: `${obj.name}`
        });
        this.getRouteDetails();
     }
    }));
    this.selectedrouteId='';
    this.deploymentsConfigurations = await this.getdeploymentconfiguration();
    sessionStorage.setItem('pipelineid','');
    this.dftcheck=false;
    this.selectedrname = ''
    this.projectnamelist = [];
    this.vpncheck = false;
    this.isftp = false;
    this.UniqueID = "";
    this.adtcheck = false;
    if (this.ProcessorAllList.length == 0 && this.dynamicJSON.length == 0) {
      await this.InitilizeProcessordata();
      if (this.UniqueID == 0) {
        await this.setfirstcontrol();
      }
    }
    this.loadCreatePipelineRolePermissions();
    this.getVendorname();
    this.getApiPollingJobFrequencies();
    this.GetMessageTypes('msgtype');
    if (this.isflasgSize) {
      this.isflasgSize.unsubscribe();
    }
    this.isflasgSize = this.service.ConfigJsonFlag.subscribe(data => {
      if (this.service.configModalOpening) return;
      if (this.service.openedModalConfig != '') return;
      const currentModule = this.router.url.split('/')[2];
      if (data["module"] !== 'pipelinelist') {
        this.service.configModalOpening = true;
        if (this.service.configDetails.operation == "Add") {
          this.openconfigpopup("big", 'create', '')
        }
        else {
          this.openconfigpopup("big", 'Edit', this.service.configDetails)
        }
      }
    })
    
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-create-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 100);
    });
  }

  copyToClip(data, message: any) {
    if (data != '' && data != undefined) {
      copyToClipboard(data);
      this.toastr.success(message + ' Copied', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
    else {
      this.toastr.warning(message + 'Invalid', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }
  copyToClipSE(id, name, message: any) {
    let SE
    if (message.includes('Target')) {
      SE = 'TargetName:' + name + '\r\n' + 'TargetID:' + id;
    } else {
      SE = 'SourceName:' + name + '\r\n' + 'SourceID:' + id;
    }
    copyToClipboard(SE);
    this.toastr.success(message + ' Copied', "", {
      timeOut: 500,
      positionClass: 'toast-bottom-right'
    });

  }


  getRouteName(event: any) {
    this.RouteNameSuggest.forEach(element => {
      element.value = '';
    });
    var val = event;
    if (val) {
      this.RouteNameSuggest[0]["value"] = val;
      this.suggestedroutename = val;
      if (Number(val.length) + Number(1) > 3) {
        this.isLoadingResult = true;
        var url = "api/Routes/GetByDisplayName?name=" + val + "&version=2";
        this.service.getapiurl(url).subscribe({
          next: data => {
            this.isLoadingResult = false;
            this.RouteNameListPipeline = data as any[];
            this.RouteNameListPipeline.map(obj => obj.displayname = `${obj.displayname} ${'(' + obj.id + ')(VA-'+obj.UniqueID+')'}`);
            this.selectedrouteDisplayName = val;
            if (data.length == 0) {
              this.notfounddata = true;
            } else {
              this.notfounddata = false
            }
          },
          error: error => {
            this.isLoadingResult = false;
            this.notfounddata = false
            this.toastr.error("Unable to fetch the Pipelines", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        });
      }
    }

  }

  async saveroute(mymodalinterfacedescription, MultiInterfacesUser) {
    this.popupflag = false;
    let validate = await this.validatedata();
    if (validate) {

      if (this.selectRouteNameBackup != this.reactiveFormroute.value.routename) {
        this.getDuplicateRoutes(mymodalinterfacedescription, MultiInterfacesUser)
      } else {
        if (this.backupmyFlagForSlideToggle !== this.myFlagForSlideToggle) {
          if (this.MultiInterfacesUser && !this.myFlagForSlideToggle) {
            const modalRef = this.modalService.open(MultiInterfacesUser, { windowClass: "interfacedescriptioncreate", backdrop: 'static', keyboard: false });
            this.trackModalRef(modalRef, "interfacedescriptioncreate");
            modalRef.result.then((result) => {
              this.untrackModalRef(modalRef);
            }, (reason) => {
              this.untrackModalRef(modalRef);
            });
          }
          else {
            this.notespopup(mymodalinterfacedescription);
          }
        }
        else {
          this.notespopup(mymodalinterfacedescription);
        }
      }

    }
  }

  yesnotepopup(mymodalinterfacedescription, c) {
    const modalRef = this.modalService.open(mymodalinterfacedescription, { windowClass: "interfacedescriptioncreate", backdrop: 'static', keyboard: false });
    this.trackModalRef(modalRef, "interfacedescriptioncreate");
    modalRef.result.then((result) => {
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.untrackModalRef(modalRef);
    });
    c('close modal');
  }
  notespopup(mymodalinterfacedescription) {
    const modalRef = this.modalService.open(mymodalinterfacedescription, { windowClass: "interfacedescriptioncreate", backdrop: 'static', keyboard: false });
    this.trackModalRef(modalRef, "interfacedescriptioncreate");
    modalRef.result.then((result) => {
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.untrackModalRef(modalRef);
    });
  }
  openDuplicateModal() {
    const modalRef = this.modalService.open(this.duplicateModalRight, { 
      windowClass: "drawer right-align duplicate-modal-rightcreate", 
      backdrop: 'static', 
      keyboard: false 
    });
    this.trackModalRef(modalRef, "duplicate-modal-rightcreate");
    modalRef.result.then((result) => {
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.untrackModalRef(modalRef);
    });
  }
  async getDuplicateRoutes(mymodalinterfacedescription,MultiInterfacesUser) {
    var apiname = 'api/Routes/GetDuplicateRoutes?RouteName=' + this.reactiveFormroute.get('routename').value;
    this.ngxUiLoaderService.start();
    let response = await this.service.searchduplgettapi(apiname);
    if (response.length > 0) {

      this.duplicatepipeline = response;
      for (let i = 0; i < this.duplicatepipeline.length; i++) {
        if (this.duplicatepipeline[i]['CORECONFIG'] !== '') {
          let connect = JSON.parse(this.duplicatepipeline[i]['CORECONFIG']);
          this.duplicatepipeline[i]['type'] = connect['ConnectivityType'];
        }
      }
      this.toastr.warning("Pipeline Name Already Exist", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
      this.openDuplicateModal();
    }
    else {
      this.SaveRouteDetails(mymodalinterfacedescription,MultiInterfacesUser)
    }
  }

  async SaveRouteDetails(mymodalinterfacedescription,MultiInterfacesUser) {
    this.ngxUiLoaderService.start();
    if (this.selectedrouteId != '') {
      this.popupflag = false;
    }
    else {
      this.popupflag = true;
    }

    if (this.reactiveFormroute.get('routename').value && !this.reactiveFormroute.get('routename').value.includes('(')) {
      this.selectedrouteDisplayName = this.reactiveFormroute.get('routename').value;
    }

    let validate = await this.validatedata();
    if (validate) {

      if (this.envSourceProxy == undefined || this.envSourceProxy == '' || this.envTarget == undefined || this.envTarget == '') {
        if (this.fromprossorSADA == 'DA') {
          this.envSourceProxy = '';
          if (this.envSourceProxy == undefined || this.envSourceProxy == '') {
            var response = this.deploymentsConfigurations;
            if (response !== undefined || response !== '') {
              this.envSourceProxy = response[this.sourcedeployementkey].SA;
            }
          }
        }
        else if (this.fromprossorSADA == 'SA') {
          this.envTarget = '';
          if (this.envTarget == undefined || this.envTarget == '') {
            var response = this.deploymentsConfigurations;
            if (response !== undefined || response !== '') {
              this.envTarget = response[this.targetdeployementkey].DA;
            }
          }
        }
      }
      //SA and DA check before create pipeline
      if (this.envSourceProxy == undefined || this.envSourceProxy == '' || this.envTarget == undefined || this.envTarget == '') {
        this.toastr.warning("Deployment Configurations are not found. Please Configure the Deployment", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
      else {
        /* VALIDATE PIPELINE BEFORE SAVE START*/

        if (this.selectedsourceaccountid == undefined || this.selectedsourceaccountid == '') {
          if (this.selectedsourceaccountid == '' && this.reactiveFormsource.get('name').value) {
            this.selectedsourceaccountid = this.reactiveFormsource.get('name').value.id;
          }
        }

        if (this.selectedtargetaccountid == undefined || this.selectedtargetaccountid == '') {
          if (this.selectedtargetaccountid == '' && this.reactiveFormtarget.get('namet').value) {
            this.selectedtargetaccountid = this.reactiveFormtarget.get('namet').value.id;
          }
        }

        if (this.selectedprocessagentid == undefined || this.selectedprocessagentid == '') {
          if (this.selectedprocessagentid == '' && this.reactiveFormprocess.get('namep').value) {
            this.selectedprocessagentid = this.reactiveFormprocess.get('namep').value.id;
          }
        }

        const pipelinedata = {
          "SEGUID": this.selectedsourceaccountid,
          "DEGUID": this.selectedtargetaccountid,
          "SOURCEPROXY": this.envSourceProxy,
          "TARGETPROXY": this.envTarget,
          "PAID": this.selectedprocessagentid,
          "UniqueID": this.UniqueID == '' ? 0 : Number(this.UniqueID),
          "SEDeploymentKey": this.sourcedeployementkey,
          "DEDeploymentKey": this.targetdeployementkey
        };

        var validateresponse = await this.service.postapi('api/Routes/PipelineValidate', pipelinedata);
        if (validateresponse['status'] && validateresponse['statusText']) {
          this.ngxUiLoaderService.stop();
          this.toastr.error("Failed to validate pipeline", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
        else {
          if (Number(validateresponse["Numberofrecords"]) > 0) {
            this.ngxUiLoaderService.stop();
            const message = `Pipeline already exists with same Source, Target and Processor. Do you want to continue?`;
            const dialogData = new ConfirmDialogModel("Confirm Action", message, 'confirm', '');
            const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: "500px", data: dialogData, disableClose: true });

           const dialogResult = await dialogRef.afterClosed().toPromise();
            if (dialogResult === false) {
              this.ngxUiLoaderService.stop();
              return; 
            }
        
            else {
            if (!this.UniqueID && this.ProcessorType !== undefined && this.ProcessorType !== 'L2L') {
              this.selectedInterfacedescription = "";
              if (this.backupmyFlagForSlideToggle !== this.myFlagForSlideToggle) {
                if (this.MultiInterfacesUser) {
                  const modalRef = this.modalService.open(MultiInterfacesUser, { windowClass: "interfacedescriptioncreate", backdrop: 'static', keyboard: false });
                  this.trackModalRef(modalRef, "interfacedescriptioncreate");
                  modalRef.result.then((result) => {
                    this.untrackModalRef(modalRef);
                  }, (reason) => {
                    this.untrackModalRef(modalRef);
                  });
                }
                else {
                  this.notespopup(mymodalinterfacedescription);
                }
              }
              else {
                this.notespopup(mymodalinterfacedescription);
              }
            } else {
              if (this.backupmyFlagForSlideToggle !== this.myFlagForSlideToggle) {
                if (this.MultiInterfacesUser) {
                  const modalRef = this.modalService.open(MultiInterfacesUser, { windowClass: "interfacedescriptioncreate", backdrop: 'static', keyboard: false });
                  this.trackModalRef(modalRef, "interfacedescriptioncreate");
                  modalRef.result.then((result) => {
                    this.untrackModalRef(modalRef);
                  }, (reason) => {
                    this.untrackModalRef(modalRef);
                  });
                }
                else {
                  this.notespopup(mymodalinterfacedescription);
                }
              }
              else {
                this.notespopup(mymodalinterfacedescription);
              }
            }
          }
          }
          else {
            // comment below  line for copy pipeline need description to be enable
            if ((!this.UniqueID || this.copypipelineflag) && this.ProcessorType !== undefined && this.ProcessorType !== 'L2L') {

              this.selectedInterfacedescription = "";
              if (this.backupmyFlagForSlideToggle !== this.myFlagForSlideToggle) {
                if (this.MultiInterfacesUser) {
                  const modalRef = this.modalService.open(MultiInterfacesUser, { windowClass: "interfacedescriptioncreate", backdrop: 'static', keyboard: false });
                  this.trackModalRef(modalRef, "interfacedescriptioncreate");
                  modalRef.result.then((result) => {
                    this.untrackModalRef(modalRef);
                  }, (reason) => {
                    this.untrackModalRef(modalRef);
                  });
                }
                else {
                  this.notespopup(mymodalinterfacedescription);
                }
              }
              else {
                this.notespopup(mymodalinterfacedescription);
              }
            }
            else {
              await this.SaveRouteDetailstoDB();
            }
          }
        }
        /* VALIDATE PIPELINE BEFORE SAVE END*/
      }
    }
    this.ngxUiLoaderService.stop();
  }



  async searchRouteNameCleared(event) {
    if (this.selectedrouteId !== "") {
      await this.Resetalldata();
      await this.setfirstcontrol();
    }
  }

  selectedinterfaceEvent(item) {
    this.selectedrouteId = item.id;
    this.selectedrouteDisplayName = item.displayname;
    this.pipelineselectclass = 'ng-autocompleteselect';
    this.getRouteDetails();
  }


  closematmenu() {
    this.languageMenuTrigger.closeMenu();
  }
  goLiveButton() {
    if (this.myFlagForSlideToggle === false) {
      this.toastr.warning('Action Cannot Performed Interface is Inactive', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }

  /**
   * Validates that at least one rule version with VersionStatus='live' exists before allowing route to be set active.
   * When user toggles to active: if there are no live rules at all, reverts toggle and shows error.
   * Only runs for routes that use the rule engine (isRuleEngine).
   */
  onActiveToggleChange(event: { checked: boolean }): void {
    if (!event.checked) {
      return; // Switching to inactive - no validation needed
    }
    // Only enforce "must have live rules" for rule-engine routes
    if (!this.isRuleEngine) {
      this.backupmyFlagForSlideToggle = true;
      return;
    }
    if (!this.UniqueID || this.UniqueID === '' || this.UniqueID === 0) {
      this.myFlagForSlideToggle = false;
      this.toastr.error('No Live rules found. Hence, not allowed to make active.', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }
    this._ruleEngineService.GetRuleConfigVersions(this.UniqueID, 'Validation').subscribe({
      next: (data: any) => {
        const list = Array.isArray(data) ? data : [];
        const hasLiveVersion = list.some(
          (v: any) => (v.VersionStatus ?? '').toString().toLowerCase() === 'live'
        );
        if (!hasLiveVersion) {
          this.myFlagForSlideToggle = false;
          this.backupmyFlagForSlideToggle = false;
          this.toastr.error('No Live rules found. Hence, not allowed to make active.', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        } else {
          this.backupmyFlagForSlideToggle = true;
        }
      },
      error: () => {
        this.myFlagForSlideToggle = false;
        this.backupmyFlagForSlideToggle = false;
        this.toastr.error('No Live rules found. Hence, not allowed to make active.', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }

  /**
   * Toggle display from PreValidation source flags (not routedefinition ACK flags):
   * Rule Engine mapping → Rule Ack; else legacy validationconfig → Validation Ack; else Rule Ack (new).
   */
  private async refreshAckToggleVisibility(): Promise<void> {
    if (!this.UniqueID || this.UniqueID === '' || this.UniqueID === 0) {
      this.showRuleEngineAckToggle = true;
      return;
    }
    try {
      const flags: any = await firstValueFrom(
        this._ruleEngineService.GetPreValidationSourceFlags(this.UniqueID, 'PreValidation')
      );
      const hasRuleEngine = !!(flags?.HasRuleEnginePreValidation ?? flags?.hasRuleEnginePreValidation);
      const hasLegacy = !!(flags?.HasLegacyPreValidation ?? flags?.hasLegacyPreValidation);
      this.showRuleEngineAckToggle = hasRuleEngine || !hasLegacy;
    } catch {
      this.showRuleEngineAckToggle = true;
    }
  }

  private parseAckFlag(value: any): boolean {
    if (value === true || value === 1) {
      return true;
    }
    const s = (value ?? '').toString().trim().toLowerCase();
    return s === 'true' || s === '1';
  }

  private getLiveCoreConfigFromMappingsResponse(response: any): any {
    const list = response?.CoreConfigVersionList;
    if (!Array.isArray(list)) {
      return null;
    }
    return list.find((c: any) => c?.islive === true) ?? null;
  }

  private isInboundPipelineForCreate(): boolean {
    const direction = String(this.interfacetype ?? '').toLowerCase();
    return direction.includes('inbound');
  }

  private isOutboundPipelineForCreate(): boolean {
    const direction = String(this.interfacetype ?? '').toLowerCase();
    return direction.includes('outbound');
  }

  /** Pre-Validation: inbound → HL7; outbound → XML (AP/CP). */
  private getPreValidationTemplateKeyForCreate(): string {
    return this.isInboundPipelineForCreate() ? 'RESULT_OUTBOUND' : 'DEFAULT';
  }

  /** Pre-Delivery: outbound → HL7; inbound → XML (AP/CP). */
  private getPreDeliveryTemplateKeyForCreate(): string {
    return this.isOutboundPipelineForCreate() ? 'RESULT_OUTBOUND' : 'DEFAULT';
  }

  /** Strict check: live processorconfig.validationconfig (not transform mappedxml). */
  private hasLegacyValidationConfig(response: any): boolean {
    const live = this.getLiveCoreConfigFromMappingsResponse(response);
    const vc = live?.json?.processorconfig?.validationconfig;
    if (!vc) {
      return false;
    }
    const mappedxml = (vc.mappedxml ?? '').toString().trim();
    const generatedxsl = (vc.generatedxsl ?? '').toString().trim();
    return !!(mappedxml || generatedxsl);
  }

  /**
   * SP5 deployments (Plus, Labs, Miraca): deployment keys that should not use the rule engine
   * on new pipeline creation (SavePipeline path). Extend the pattern list if API key names differ.
   */
  private matchesDeploymentKey(deploymentKey: string): boolean {
    const k = (deploymentKey || '').trim().toLowerCase();
    return k === 'plus' || k === 'labs' || k === 'miraca';
  }

  /** Suppress rule engine on create when both SE and DE are SP5 Plus/Labs/Miraca deployment keys. */
  private shouldSuppressRuleEngineForSp5Deployments(): boolean {
    return (
      this.matchesDeploymentKey(this.sourcedeployementkey)
    );
  }
  LockUnlock() {
    this.ngxUiLoaderService.start();
    this.service.requestUnlock(this.UniqueID, JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'], this.isLocked == true ? 1 : 0, this.isLocked == true ? 1 : 0, this.lockdescription, this.selectedrouteId, this.sourcedeployementkey).subscribe(response => {
      if (response) {
        this.ngxUiLoaderService.stop();
        if (response.status == 'Success') {
          this.getRouteDetails();
          this.lockdescription = "";
          this.languageMenuTrigger.closeMenu();
          this.toastr.success(response.statusmessage, "", {
            timeOut: 500,
            positionClass: 'toast-bottom-right'
          });
        }

      }
      else {
        this.ngxUiLoaderService.stop();
        this.toastr.warning(response.statusmessage, "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    }, error => {
      this.toastr.error("Something Went Wrong!", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right"
      });
      this.ngxUiLoaderService.stop();
    })
  }

  buildmultiproctitle(title: any, index: number) {
    let prop = title.formcontrolname
    this.multiprocfullname = title.formgroupname.value[prop]
    if (title.formgroupname.value[prop] !== undefined && title.formgroupname.value[prop] !== undefined && title.formgroupname.value[prop] !== '') {
      if (typeof title.formgroupname.value[prop] == 'string') {
        return title.formgroupname.value[prop];
      } else {
        return title.formgroupname.value[prop].displayname;

      }
    }

  }
  copymultiprocguid(value) {
    if (value !== undefined) {
      if (typeof value == "string") {
        let uniname = value.split('(')[1];
        let guid = uniname !== undefined ? uniname.split(')')[0] : '';
        copyToClipboard(guid);
      } else {
        copyToClipboard(value.id);
      }
    }

    this.toastr.success('Processor GUID' + " " + 'Copied', "", {
      timeOut: 500,
      positionClass: "toast-bottom-right",
    });
  }

  async getRouteDetails() {
    //for additional info start
    this.apiPollingJobFrequency = this.defaultApiPollJobFrequency;
    this.externalApiPollJob = null;
    this.apiPollingJobFrequencyLoaded = '';
    this.vbjobsdata=[];
    this.handlercreateddisplaylabel = false;
    this.rulecreateddisplaylabel = false;
    this.ftpcreateddisplaylabel = false;
    this.vbjobcreatedflag = false;
    this.ftpcreatedflag = false;
    this.handlercreatedflag = false;
    this.rulecreatedflag = false;
    this.vpndetails = false
    this.isShownorderinbound = false
    this.customFolderPathDataInputFlag = true;

    //for additional info end
    if (this.modelradio.option != 'FTP' || this.modelradio.option != 'External FTP') {
      this.oneditftpradio = true
    }
    else {
      this.oneditftpradio = false
    }
    this.updateconfigflagftp = true;
    this.updateconfigflagvb = true;
    this.array_disableradiobuttons = [];
    if (this.selectedrouteId != '' && this.selectedrouteId != null ) {
      var url = "api/Routes/get?id=" + this.selectedrouteId;
      this.ngxUiLoaderService.start();
      await this.service.getapiurl(url).subscribe({
        next: async data => {
          this.PreDeliveryFlag = data['PreDeliveryFlag'] === true || data['PreDeliveryFlag'] === 'True' || data['PreDeliveryFlag'] === '1';
          this.ShowMessage = data["ShowMessage"];
          this.IsValidationAck = this.parseAckFlag(data["IsValidationAck"]);
          this.IsRuleEngineAck = this.parseAckFlag(data["IsRuleEngineAck"] ?? data["ISRULEENGINEACK"]);
          this.refreshAckToggleVisibility();
          this.DuplicateFileFlag = data["DuplicateFileFlag"];
          this.ShowLog = data["ShowLog"];
          if (data["ProcessorType"] != '') {
            this.ProcessorType = data["ProcessorType"];
          }
          if (data["vendor"]) {
            this.reactiveFormvendar.patchValue({
              namevendar: data["vendor"],
              vendorid: data['vendorid']
            });
            this.vendarnamevalue = data["vendor"];
            this.vendorid = data['vendorid']
            this.RouteNameSuggest[3]["value"] = data["vendor"];
            this.vendarmsgdiv = true;
          }
          else {
            this.vendarmsgdiv = false;
          }
          this.handlerflag = false;
          this.ruleflag = false;
          this.notebuttonflag = true;
          this.auditbuttonflag = true;
          this.rulebuttonshow = false;
          this.routeflag = true;
          this.additionalinfoflag = true;

          if (data['IsLocked'] !== undefined && data['IsLocked'] == 'True') {
            this.isLocked = true
          } else {
            this.isLocked = false
          }

          if (data["SEDEPLOYMENTKEY"] != '') {
            this.sourcedeployementkey = data["SEDEPLOYMENTKEY"];
          }

          if (data["DEDEPLOYMENTKEY"] != '') {
            this.targetdeployementkey = data["DEDEPLOYMENTKEY"];
          }

          this.sourceAgentDeploymentKey = data["sourceagentdeployment"] || '';
          this.targetAgentDeploymentKey = data["targetagentdeployment"] || '';

          this.modeSelected = data["mode"] == '' ? 'Test Live' : data["mode"];
          this.reactiveFormmode.patchValue({
            modename: this.modeSelected
          });
          // Pre-Validation button: either ack flag
          this.isvalidationack = this.IsValidationAck;
          this.isruleengineack = this.IsRuleEngineAck;

          //entity address
          this.sourcetype = data["sourcetype"];
          this.sourceentityaddress1 = data["seaddress1"];
          this.sourceentityaddress2 = data["seaddress2"];
          this.sourceentityaddress = data["seaddress1"] + '' + (data["seaddress2"] == null ? '' : data["seaddress2"]);
          this.sourcecity = data["secity"];
          this.sourcestate = data["sestate"];
          this.sourcezip = data["sezip"];

          this.targettype = data["targettype"];
          this.targetentityaddress1 = data["deaddress1"];
          this.targetentityaddress2 = data["deaddress2"];
          this.targetentityaddress = data["deaddress1"] + '' + (data["deaddress2"] == null ? '' : data["deaddress2"]);
          this.targetcity = data["decity"];
          this.targetstate = data["destate"];
          this.targetzip = data["dezip"];

          this.envSourceProxy = data['sourceagentid'];
          this.modelvbclient.vbclientagnetid = this.envSourceProxy;
          this.envTarget = data['destinationagentid'];
          await this.applyRoutingConversionTypeFromAgentSearch(data);
          this.connectivitytype = data['Connectivity'].toLowerCase()=='none'?'API':data['Connectivity'];
          this.myFlagForSlideToggle = data['status'] == "active" ? true : false;
          this.backupmyFlagForSlideToggle = data['status'] == "active" ? true : false;
          this.MultiInterfacesUser=data['MultiInterfacesUser']
          this.MultiInterfacesName=data['MultiInterfacesName']
          this.FTPV2Flag=this.connectivitytype=='FTPV2'|| this.connectivitytype=='External FTPV2'? true:false;

          if (this.selectedrouteId != "") {
            this.UniqueID = data['UniqueID'];
            this.selectedrouteDisplayName = data['displayname'];
            this.selectRouteNameBackup = JSON.parse(JSON.stringify(data['displayname']))
            this.reactiveFormroute.patchValue({
              routename: `${this.selectedrouteDisplayName}`
            });

            this.RouteNameSuggest[0]["value"] = this.selectedrouteDisplayName.split(".")[0].trim().replace('-', '');
          }
          this.interfacetype = data["INTERFACETYPE"];
          
          if (data['SENAME'] != '') {
            if (data["SEDEPLOYMENTKEY"] != '') {
              this.sourcedpkeydisplay = data["SEDEPLOYMENTKEY"] + '|';
            }

            this.selectedsourceaccountid = data['SEGUID'];
            this.selectedsourceaccountName = data['SENAME'];
            this.RouteNameSuggest[1]["value"] = this.selectedsourceaccountName.split(" ")[0].trim().replace('-', '');
            this.sourceentitytype = data['SETYPE'];
            this.sourcetypedisplay = data['sourcetype'].charAt(0);

            this.sourcetypedisplayid = '|' + this.selectedsourceaccountid;
            this.selectedsourcename = this.selectedsourceaccountName + `(${this.selectedsourceaccountid})`
            this.reactiveFormsource.patchValue({
              name: this.selectedsourcename
            });
          }

          if (data['DENAME'] != '') {
            if (data["DEDEPLOYMENTKEY"] != '') {
              this.targetdpkeydisplay = data["DEDEPLOYMENTKEY"] + '|';
            }

            this.selectedtargetaccountid = data['DEGUID'];
            this.selectedtargetaccountName = data['DENAME'];
            this.RouteNameSuggest[2]["value"] = this.selectedtargetaccountName.split(" ")[0].trim().replace('-', '');
            this.targetentitytype = data['DETYPE'];
            this.targettypedisplay = data['DETYPE'].charAt(0);;

            this.targettypedisplayid = '|' + this.selectedtargetaccountid;
            this.selectedtargetname = this.selectedtargetaccountName + `(${this.selectedtargetaccountid})`
            this.reactiveFormtarget.patchValue({
              namet: this.selectedtargetname
            });
          }

          if (this.selectedsourceaccountid && this.selectedtargetaccountid) {
            await this.ensureTestOrganizationFlagsLoaded();
          }

          if (data['PANAME'] != '') {
            this.selectedprocessapikey = data['PAAPIKEY'];
            this.selectedprocessagentid = data['PAID'];
            this.selectedprocessdisplayname = data['PANAME'];
            this.selectedprocessname = this.selectedprocessdisplayname + `(${this.selectedprocessagentid})`
            this.reactiveFormprocess.patchValue({
              namep: this.selectedprocessname
            });

            this.isShown = true;
            this.btnshowtryit = true;
            this.copypiprlinrbutton = true;
            

            if (this.ProcessorType == 'Custom' || this.ProcessorType == 'None') {
              this.routeconfigflag = false;
            }
            this.gethandlerrulestatus();
            
            if (this.interfacetype.toLowerCase() == "outbound") {    
              this.RouteNameSuggest[5]["value"] = 'OutBound';
              // Commented: remapped External FTPV2 -> External FTP, so after save/reload the Target Connectivity label showed "External FTP" instead of "External FTPV2".
              // this.outboundmodelradio.option = this.connectivitytype=='External FTPV2'? 'External FTP':this.connectivitytype;
              // Keep connectivity type as stored (including External FTPV2) so the selected sub-option label displays correctly after save.
              this.outboundmodelradio.option = this.connectivitytype;
              // Use GetRuleConfigVersions to identify rule engine (no longer RuleConfig column)
              this.ruleConfigVersionsList = [];
              if (data["UniqueID"]!='') {
                this.beginAdditionalInfoLoad();
                this._ruleEngineService.GetRuleConfigVersions(data["UniqueID"], 'Validation').subscribe({
                  next: (versions: any) => {
                    const raw = Array.isArray(versions) ? versions : [];
                    this.ruleConfigVersionsList = raw;
                    if (raw.length > 0) {
                      this.isRuleEngine = true;
                      this.isRuleConfigEmptyOrNull = false;
                      const status = (v: any) => (v.VersionStatus ?? v.versionStatus ?? '').toString().toLowerCase();
                      const live = raw.find((v: any) => status(v) === 'live');
                      const versionToUse = (live?.RuleConfig != null)
                        ? live
                        : [...raw].reverse().find((v: any) => v?.RuleConfig != null);
                      if (versionToUse?.RuleConfig != null) {
                        this.RuleConfig = typeof versionToUse.RuleConfig === 'string' ? JSON.parse(versionToUse.RuleConfig) : versionToUse.RuleConfig;
                      }
                    } else {
                      this.isRuleEngine = false;
                      this.isRuleConfigEmptyOrNull = true;
                    }
                    this.endAdditionalInfoLoad();
                  },
                  error: () => {
                    this.isRuleEngine = false;
                    this.isRuleConfigEmptyOrNull = true;
                    this.endAdditionalInfoLoad();
                  }
                });
              } else {
                this.isRuleEngine = false;
                this.isRuleConfigEmptyOrNull = true;
              }
              this.rulebuttonshow = true;
              let jsonresponse
              this.isShownresultoutbound = false;
              if (this.ProcessorType !== 'L2L') {
                 if (this.connectivitytype != undefined && this.connectivitytype == "API") {
                  
                  this.array_disableradiobuttons.push("disable");
                  this.ftpexstingpathdiv = true;
                  this.apiconnectivity = true;
                }
                else{
                  if ((data["CORECONFIG"] === '[null]' || data["CORECONFIG"] === undefined)) {
                    this.toastr.warning("CORECONFIG is null or undefined", "", {
                      timeOut: 4000,
                      positionClass: 'toast-bottom-right'
                    });


                    if (this.connectivitytype == 'FTPV2') {
                      this.ftpcreateddisplaylabel = true;
                      this.ftpcreatedflag = false;
                      this.isShownresultoutbound = true;
                    }
                  }
                  else {
                    jsonresponse = JSON.parse(data["CORECONFIG"]);
                    if (jsonresponse != undefined && jsonresponse.length > 0 && Object.keys(jsonresponse[0]).length > 0) {
                      if ((jsonresponse[0].userName) ||
                        (this.connectivitytype == 'FTP' || this.connectivitytype == 'EXFTPPath' ||
                          this.connectivitytype == 'External FTP'
                        || this.connectivitytype == 'FTPV2'
                        || this.connectivitytype == 'External FTPV2')) {
                        this.array_disableradiobuttons.push("disable");
                        this.ftpusername = jsonresponse[0].userName;
                        this.ftppassword = jsonresponse[0].password;
                        this.ftphost = this.ensureSftpPrefix(jsonresponse[0].host);
                        this.ftpport = jsonresponse[0].port;
                        this.suffixfromprocessor = jsonresponse[0].suffix;
                        this.sourcepath = jsonresponse[0].sourcePath;
                        this.archivepath = jsonresponse[0].archivePath;
                        this.progresspath = jsonresponse[0].progressPath;
                        this.errorpath = jsonresponse[0].errorPath;
                        this.isShownresultoutbound = true;
                        this.updateconfigflagftp = false;
                        this.remotepathdisplay = jsonresponse[0].remotePath;
                        this.ftpexstingpathdiv = false;
                        this.ftpflag = true;
                        this.ftpalreadycreated = true;
                        this.ftpcreatedflag = true;
                        this.ftpcreateddisplaylabel = true;
                        this.customFolderPath = jsonresponse[0].CustomerFolderPath;
                        this.selectedVBInstance = jsonresponse[0].VBAgent;
                        
                        if (this.outboundmodelradio.option == "External FTP" || this.outboundmodelradio.option == "External FTPV2") {
                          this.disableexternalftp = true;
                          this.customftp.username = jsonresponse[1] !== undefined ? jsonresponse[1].userName : '';
                          this.customftp.password = jsonresponse[1] !== undefined ? jsonresponse[1].password : '';
                          this.customftp.host = jsonresponse[1] !== undefined ? this.ensureSftpPrefix(jsonresponse[1].host) : '';
                          this.customftp.port = jsonresponse[1] !== undefined ? jsonresponse[1].port : '';
                          this.customftp.folder = jsonresponse[1] !== undefined ? jsonresponse[1].remotePath : '';
                          this.customftp.archivepath = jsonresponse[1] !== undefined ? jsonresponse[1].archivePath : '';
                          this.customftp.id = jsonresponse[1] !== undefined ? jsonresponse[1].id : '';
                        }
                      } else {
                        this.vpncheck = false
                        this.vpndetails = false
                        this.vpnflag = true;
                      }


                      if (this.connectivitytype == 'VPN') {
                        if (jsonresponse != undefined && jsonresponse.length > 0) {
                          this.ipvpnout = jsonresponse[0]['vpnIp'];
                          this.portvpnout = jsonresponse[0]['vpnPort'];
                          this.vpncustomerpath = jsonresponse[0]['vpncustomerpath'];
                          this.sourcepathvpnout = jsonresponse[0]['sourcePath']
                          this.archivepathvpnout = jsonresponse[0]['archivePath']
                          this.vpncheck = true
                          this.vpndetails = true
                          this.vpncreatedflag = true
                          this.vpnflag = true;
                        }
                        else {
                          this.vpncreatedflag = false;
                          this.vpncheck = true
                          this.vpndetails = false
                          this.vpnflag = true;
                        }
                      }
                    }

                    else {
                      this.ftpcreatedflag = false;
                      this.ftpalreadycreated = false;
                      this.ftpflag = false;
                      this.ftpexstingpathdiv = true;
                      this.updateconfigflagftp = true;
                      this.toastr.warning("Pipeline is of type Outbound, Save the pipeline to create the FTP user", "", {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                      });
                    }
                  }
                }
              }
              else {
                this.array_disableradiobuttons.push("disable");
                this.outboundmodelradio.option = "API";
              }
              if ( this.vendarnamevalue.toLowerCase() == 'ellkay') {
                this.rulebuttonshow = true;
                this.isshownellkykeys = true;
                this.handlercreatedflag = true;
                this.array_disableradiobuttons.push("disable");
                jsonresponse = JSON.parse(data["CORECONFIG"]);
                if (jsonresponse != undefined && jsonresponse.length > 0 && Object.keys(jsonresponse[0]).length > 0) {
                this.modelelk.subscriberkey = jsonresponse[0].subscriberKey;
                this.modelelk.servicekey = jsonresponse[0].serviceKey;
                }
              }
              else {
                this.isshownellkykeys = false;
              } 
              if (this.interfacetype == "EllkayOutbound") {
                this.array_disableradiobuttons.push("disable");
              }
            }
            else {
              this.isShownresultoutbound = false;
            }

            if (this.interfacetype.toLowerCase() == "inbound") {
              
              this.RouteNameSuggest[5]["value"] = 'InBound';
              this.rulebuttonshow = false;
              if (this.connectivitytype != undefined && this.connectivitytype == "API") {
                this.modelradio.option = this.connectivitytype;
                this.array_disableradiobuttons.push("disable");
              }
              else {
                let jsonresponse = JSON.parse(data["CORECONFIG"]);
                if (jsonresponse != undefined && jsonresponse.length > 0) {
                  if (jsonresponse[0] != undefined && Object.keys(jsonresponse[0]).length > 0 && (this.connectivitytype && this.connectivitytype == "VPN")) {
                    this.modelradio.option = this.connectivitytype;
                    this.array_disableradiobuttons.push("disable");
                    if (jsonresponse != undefined && jsonresponse.length > 0) {
                      this.isShownorderinbound = false
                      this.modelvpn.ip = jsonresponse[0]['vpnIp'];
                      this.modelvpn.port = jsonresponse[0]['vpnPort'];
                      this.modelvpn.vpninputdisabled = true;
                      this.vpncreatedflag = true;
                      this.vpnflag = true;
                      this.showdestin = true
                    }
                    else {
                      this.vpncreatedflag = false;
                      this.vpnflag = false;
                    }
                  }
                  else if (jsonresponse[0] != undefined && Object.keys(jsonresponse[0]).length > 0 && (this.connectivitytype &&  this.connectivitytype != "API")) {
                    this.vbjobalreadycreated = true;
                    this.vbflag = true;
                    this.modelradio.option = this.connectivitytype;
                    this.array_disableradiobuttons.push("disable");
                    if (this.modelradio.option == 'Other') {
                      this.vbjobdisplayexftp = true;
                      if (jsonresponse[0] != undefined && Object.keys(jsonresponse[0]).length > 0) {
                        this.ftpisDisabled = true;
                        this.modelvbftp.sourcepath = jsonresponse[0].sourcePath;
                        this.modelvbftp.archivepath = jsonresponse[0].archivePath;
                        this.modelvbftp.progresspath = jsonresponse[0].progressPath;
                        this.modelvbftp.errorpath = jsonresponse[0].errorPath;
                        this.ftpalreadycreated = true;
                      }
                    }
                    else {
                      this.isShownorderinboundvb = true;
                      this.isShownorderinbound = true;
                      this.updateconfigflagvb = false;
                      if (this.modelradio.option == 'VB Client') {
                        this.ngxUiLoaderService.start();
                        var jobdata = await this.getJobName(this.selectedrouteDisplayName);
                        this.ngxUiLoaderService.stop();
                        if (jobdata.length > 0) {
                          this.vbfolderpathflag = true;
                          this.vbfolderpathdisplay = jobdata[0].SourcePath.replace("\\source", "").replace(/\//g, "\\");
                        }
                        else {
                          this.vbfolderpathdisplay = '';
                        }
                      }
                      else {
                        this.vbfolderpathflag = false;
                      }
                    }
                  }
                  else {
                    this.modelradio.option = this.connectivitytype;
                    if (this.modelradio.option !== "FTPV2") {
                      this.vbjobalreadycreated = false;
                      this.vbflag = false;
                      this.updateconfigflagvb = true;
                      this.isShownorderinboundvb = false;
                    }
                    if (this.modelradio.option === 'FTPV2') {
                      this.isShownorderinboundftp = false;
                      this.ftpcreatedflag = false;
                      this.ftpalreadycreated = false;
                      this.ftpflag = false;
                      this.ftpcreateddisplaylabel = true;
                    }

                  }
                  if (this.modelradio.option == 'FTP/VPN' || this.modelradio.option == 'FTP' || this.modelradio.option == 'External FTP' || this.modelradio.option == 'FTPV2'|| this.modelradio.option == 'External FTPV2') {
                    if (jsonresponse[0] != undefined && Object.keys(jsonresponse[0]).length > 0 && jsonresponse[0].userName) {
                      this.ftpusername = jsonresponse[0].userName;
                      this.ftppassword = jsonresponse[0].password;
                      this.ftphost = this.ensureSftpPrefix(jsonresponse[0].host);
                      this.ftpport = jsonresponse[0].port;
                      this.sourcepath = jsonresponse[0].sourcePath;
                      this.archivepath = jsonresponse[0].archivePath;
                      this.progresspath = jsonresponse[0].progressPath;
                      this.errorpath = jsonresponse[0].errorPath;
                      if ((this.modelradio.option == "External FTP"||this.modelradio.option == 'External FTPV2') && jsonresponse.length > 1) {
                        this.disableexternalftp = true
                        this.customftp.username = jsonresponse[1].userName;
                        this.customftp.password = jsonresponse[1].password;
                        this.customftp.host = this.ensureSftpPrefix(jsonresponse[1].host);
                        this.customftp.port = jsonresponse[1].port;
                        this.customftp.folder = jsonresponse[1].remotePath;
                        this.customftp.archivepath = jsonresponse[1].archivePath;
                        this.customftp.id = jsonresponse[1].id;
                      }
                      this.isShownorderinboundftp = true;
                      this.isShownorderinbound = true;
                      //to show only remote site path
                      //we are not holding saparatly value
                      this.remotepathdisplay = jsonresponse[0].remotePath;
                      this.updateconfigflagftp = false;
                      this.ftpflag = true;
                      this.ftpalreadycreated = true;
                      this.ftpcreatedflag = true;
                      this.ftpcreateddisplaylabel = true;
                      this.customFolderPath = jsonresponse[0].customFolderPath || '';
                      this.selectedVBInstance = jsonresponse[0].selectedVBInstance || '';
                      this.modelradio.option = this.modelradio.option === 'External FTP' ? "External FTP"
                        : this.modelradio.option == 'FTPV2' ? "FTPV2"
                          :this.modelradio.option == 'External FTPV2' ? "External FTPV2": "FTP";
                    }
                    else {
                      this.ftpalreadycreated = false;
                      this.ftpflag = false;
                      this.updateconfigflagftp = true;
                      this.isShownorderinboundftp = false;
                      this.toastr.warning("Pipeline is of type Inbound, Save the pipeline to create the FTP user", "", {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                      });
                    }
                  }
                  else {
                    this.ftpalreadycreated = false;
                    this.updateconfigflagftp = true;
                    this.isShownorderinboundftp = false;
                  }
                }
              }
                if (data["messagetype"].toLowerCase() == 'adt') {
                  this.adtcheck = true;
                  this.selectedrname = this.selectedrouteDisplayName;
                  this.ADTinterfaces(false);
                }
                if (this.modelradio["option"] == 'VB Client') {
                  this.copytitle = 'Copy Job Name';
                }
                else if (this.modelradio["option"] == 'FTP/VPN' || this.modelradio["option"] == "FTP" || this.modelradio["option"] == "External FTP") {
                  this.copytitle = 'Copy FTP Details';
                }
            }
            else {
              this.isShownorderinbound = false;
            }
            this.ngxUiLoaderService.stop();
             

            if (data["RouteProcessorData"] != '') {
              this.dynamicJSON = [];
              data["RouteProcessorData"].forEach(element => {
                let controlname = '';
                let reactiveFormprocess: FormGroup;
                if (this.dynamicJSON.length == 0) {
                  controlname = "prop";
                  reactiveFormprocess = this._fb.group({ ["prop"]: `${element.displayname} ${'(' + element.id + ')'}` });
                }
                else {
                  controlname = "prop" + (this.dynamicJSON[this.dynamicJSON.length - 1].sequence + 1);
                  reactiveFormprocess = this._fb.group({ ["prop" + (this.dynamicJSON[this.dynamicJSON.length - 1].sequence + 1)]: `${element.displayname} ${'(' + element.id + ')'}` });
                }

                let inputcnt: inputField = {
                  data: this.ProcessorAllList,
                  formcontrolname: controlname,
                  formgroupname: reactiveFormprocess,
                  sequence: this.dynamicJSON.length + 1,
                  mapicon: true,
                  islive: element.ISLIVE
                }
                this.dynamicJSON.push(inputcnt);
              });
              if (this.dynamicJSON.length > 0) {
                let exists = this.dynamicJSON.filter(ele => ele.islive === false);
                if (exists.length > 0) {
                  this.routeconfigflag = true;
                }
                else {
                  this.routeconfigflag = false;
                }
              }
            }

          }
          else {
            this.btnshowtryit = false;
            this.isShown = false;
            this.copypiprlinrbutton = false;
            
            await this.gethandlerrulestatus();

            // Initialize outboundmodelradio.option to prevent undefined errors
            // Commented: remapped External FTPV2 -> External FTP, so after save/reload the Target Connectivity label showed "External FTP" instead of "External FTPV2".
            // this.outboundmodelradio.option = this.connectivitytype=='External FTPV2'? 'External FTP':this.connectivitytype;
            // Keep connectivity type as stored (including External FTPV2) so the selected sub-option label displays correctly after save.
            this.outboundmodelradio.option = this.connectivitytype;
            
            // Use GetRuleConfigVersions to identify rule engine (no longer RuleConfig column)
            this.ruleConfigVersionsList = [];
            if (this.UniqueID) {
              this.beginAdditionalInfoLoad();
              this._ruleEngineService.GetRuleConfigVersions(this.UniqueID, 'Validated').subscribe({
                next: (versions: any) => {
                  const raw = Array.isArray(versions) ? versions : [];
                  this.ruleConfigVersionsList = raw;
                  if (raw.length > 0) {
                    this.isRuleEngine = true;
                    this.isRuleConfigEmptyOrNull = false;
                    const isLive = (v: any) => v.isLive === 1 || v.islive === 1 || v.IsLive === 1;
                    const live = raw.find((v: any) => isLive(v));
                    const versionToUse = (live?.RuleConfig != null)
                      ? live
                      : [...raw].reverse().find((v: any) => v?.RuleConfig != null);
                    if (versionToUse?.RuleConfig != null) {
                      this.RuleConfig = typeof versionToUse.RuleConfig === 'string' ? JSON.parse(versionToUse.RuleConfig) : versionToUse.RuleConfig;
                    }
                  } else {
                    this.isRuleEngine = false;
                    this.isRuleConfigEmptyOrNull = true;
                  }
                  this.endAdditionalInfoLoad();
                },
                error: () => {
                  this.isRuleEngine = false;
                  this.isRuleConfigEmptyOrNull = true;
                  this.endAdditionalInfoLoad();
                }
              });
            } else {
              this.isRuleEngine = false;
              this.isRuleConfigEmptyOrNull = true;
            }
          }
          this.RouteNameSuggest[4]["value"] = data['messagetype'];
         

          
          if (data["messagetype"].toLowerCase() == 'dft') {
            this.DFTinterface(false);
          }

          if(data["messagetype"].toLowerCase() == 'networkprinting' ||data['Connectivity'].toLowerCase()=='vpn'|| data['Connectivity'].toLowerCase()=='ftp' || data['Connectivity'].toLowerCase()=='external ftp' || (this.interfacetype.toLowerCase() == "inbound" && data['Connectivity']=='Other')){
            this.vbjobcreatedflag= await this.getvbjobslist();
          }else if(data['Connectivity'].toLowerCase() == "device" && this.interfacetype.toLowerCase() != "outbound") {
            this.modelradio.option = data['Connectivity'];
            this.array_disableradiobuttons.push("disable");
            this.isShownorderinbound = true;
            await this.getdevicejobdetails();
          }

          //set copy tab title


          //for audit purpose
          if (data['messagetype']) {
            this.messagetype = data['messagetype'];
            this.selectedmessagetype = data['messagetype'];
            this.reactiveFormmsgtype.patchValue({
              msgname: this.messagetype
            });
          }
          if (data['routepolicy']) {
            this.routepolicyselected = data['routepolicy'];
            this.reactiveFormroutepolicy.patchValue({
              routepolicy: this.routepolicyselected
            })
          }
          if (data['senderapikey']) {
            this.selectedsourceagentid = data['senderID'] ? data['senderID'] : '';
            this.selectedsourceagentname = data['senderdisplayname'] ? data['senderdisplayname'] : '';
            this.selectedsourceagentdisplayname = this.selectedsourceagentname + `(${this.selectedsourceagentid})`
            this.reactiveFormsourceagent.patchValue({
              sourceagent: this.selectedsourceagentdisplayname
            });
          }
          if (data['recieverapikey']) {
            this.selectedtargetagentid = data['recieverID'] ? data['recieverID'] : '';
            this.selectedtargetagentname = data['recieverdisplayname'] ? data['recieverdisplayname'] : '';
            this.selectedtargetagentdisplayname = this.selectedtargetagentname + `(${this.selectedtargetagentid})`
            this.reactiveFormTargetagent.patchValue({
              targetagent: this.selectedtargetagentdisplayname
            });
          }
          this.oldvalue = {
            "ROUTENAME": this.selectedrouteDisplayName,
            "STATUS": this.myFlagForSlideToggle == true ? 'active' : 'passive',
            "VENDORNAME": this.vendarnamevalue,
            "MODE": this.modeSelected
          }
          await this.loadApiConnectivityDetailsIfRequired();
          this.ngxUiLoaderService.stop();
        },
        error: error => {
          this.ngxUiLoaderService.stop();
          this.service.copyableToastError('Unable to fetch Pipeline details with ID:' + this.selectedrouteId);
        }
      });
    }
  }



  async clearAll() {
    this.connectivitytypemsg = '';
    await this.Resetalldata();
    this.searchSourceNameCleared();
    this.searchTargetNameCleared();
    await this.Resetalldata();
    await this.setfirstcontrol();
    this.reactiveFormmode.setValue({ "modename": '' });
    this.modeItemsList = [
      {
        id: 'Live',
        name: 'Live',
      },
      {
        id: 'Test Live',
        name: 'Test Live',
      },
      {
        id: 'Hold',
        name: 'Hold',
      }
    ];
    this.reactiveFormmode.patchValue(this.modeItemsList);
  }


  sourceCustomFilter = function (SourceAccountList: any[], query: string): any[] {
    return SourceAccountList;
  };
  async getSourceAccountName(event: any) {
    var valuesa = event;
    if (event.includes(":")) {

      let splitValues = event.split(':')
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        event = splitValues.join(":")
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = " " + splitValues[2];
        event = splitValues.join(":")
      }
    }
    this.selectedsourceaccountid = '';
    this.reactiveFormsource.patchValue({ name: event })


    if (valuesa != '' && !valuesa.endsWith(":") && !valuesa.endsWith(": ")) {
      ;
      let valueToSendToApiWithOutWhiteSpace = valuesa.replaceAll(": ", ":");
      this.isLoadingSource = true;
      let obj = {
        lsearch: valueToSendToApiWithOutWhiteSpace,
        LocationGUID: this.selectedtargetaccountid,
        deploymentkey: this.targetdeployementkey,
        associatedaccountids: this.targetassociatedaccountids
      }
      this.service.GetAccountNamesListAsync(obj).subscribe((response: any) => {

        if (response['status'] && response['statusText']) {
          this.SourceAccountList = [];
          this.notfounddata = true;
          this.isLoadingSource = false;
          this.toastr.error("Unable to fetch Source Details", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });

        } else {
          if (response.length > 0) {
            this.SourceAccountList = response as any[];
            this.SourceAccountList.map(obj => obj.LocationName = obj.UniqueID !== null && obj.UniqueID !== undefined ? `${obj.LocationName} ${'(' + obj.LocationGUID + ')'} ${'(' + obj.UniqueID + ')'}` : `${obj.LocationName} ${'(' + obj.LocationGUID + ')'}`);
          }
          if (response.length == 0) {
            this.SourceAccountList = [];
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
          this.selectedsourceaccountid = '';
          this.isLoadingSource = false;
        }
      })


    }
    else {
      this.SourceAccountList = [];
      this.notfounddata = true;
    }
  }
  targetCustomFilter = function (TargetAccountList: any[], query: string): any[] {
    return TargetAccountList;
  };
  async getTargetAccountName(event: any) {
    var valueta = event;
    if (event.includes(":")) {
      let splitValues = event.split(':')
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        event = splitValues.join(":")
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = " " + splitValues[2];
        event = splitValues.join(":")
      }
    }
    this.selectedtargetaccountid = '';
    this.reactiveFormtarget.patchValue({ namet: event })
    if (valueta != '' && !valueta.endsWith(":") && !valueta.endsWith(": ")) {
      let valueToSendToApiWithOutWhiteSpace = valueta.replaceAll(": ", ":");
      this.isLoadingTarget = true;
      let obj = {
        lsearch: valueToSendToApiWithOutWhiteSpace,
        LocationGUID: this.selectedsourceaccountid,
        deploymentkey: this.sourcedeployementkey,
        associatedaccountids: this.sourceassociatedaccountids
      }
      this.service.GetAccountNamesListAsync(obj).subscribe((response: any) => {
        if (response['status'] && response['statusText']) {
          this.TargetAccountList = [];
          this.notfounddata = true;
          this.isLoadingTarget = false;
          this.toastr.error("Unable to fetch Target Details", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });

        } else {
          if (response.length > 0) {
            this.TargetAccountList = response as any[];
            this.TargetAccountList.map(obj => obj.LocationName = obj.UniqueID !== null && obj.UniqueID !== undefined ? `${obj.LocationName} ${'(' + obj.LocationGUID + ')'} ${'(' + obj.UniqueID + ')'}` : `${obj.LocationName} ${'(' + obj.LocationGUID + ')'}`);
          }
          if (response.length == 0) {
            this.TargetAccountList = [];
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
          this.selectedtargetaccountid = '';
          this.isLoadingTarget = false;
        }
      })


    }
    else {
      this.TargetAccountList = [];
      this.notfounddata = true;

    }
  }

  async selectedsourceaccountEvent(item) //source agent selected Event
  {
    this.connectivitytypemsg = '';
    if (this.fromprossorSADA == 'DA') {
      this.envSourceProxy = '';
    }
    this.sourceorgguid = item.orgguid
    if (item.Type == "A" || item.Type == 'E-A') {
      this.sourcetype = "Account";
      this.sourceentityprimaryid = item.entityid;
      this.selectedsourceorgid = item.organizationid;
      this.RouteNameSuggest[1]["value"] = item.mnemonic == '' ? this.selectedsourceaccountName.split(' ').join('').split('.').join('').split('-').join('').slice(0, 3) : item.mnemonic;
      this.sourceentitymnemonic = item.mnemonic == '' ? this.selectedsourceaccountName.split(' ').join('').split('.').join('').split('-').join('').slice(0, 3) : item.mnemonic;
    }
    else if (item.Type == "O" || item.Type == 'E-O') {
      this.sourcetype = "Organization";
      this.sourceentityprimaryid = item.organizationid;
      this.selectedsourceorgid = item.organizationid;
      this.RouteNameSuggest[1]["value"] = item.orgmnemonic == '' ? this.selectedsourceaccountName.split(' ').join('').split('.').join('').split('-').join('').slice(0, 3) : item.orgmnemonic;
      this.sourceentitymnemonic = item.orgmnemonic == '' ? this.selectedsourceaccountName.split(' ').join('').split('.').join('').split('-').join('').slice(0, 3) : item.orgmnemonic;
    }
    else {
      this.sourcetype = item.Type;
      this.sourceentityprimaryid = item.entityid;
      this.selectedsourceorgid = item.organizationid;
    }
    this.selectedsourceaccountid = item.LocationGUID;
    this.sourceIsTestOrganization = this.normalizeTestOrgFlagValue(item?.istestorganization);
    this.testOrgFlagsLoadedForSourceGuid = item.LocationGUID;
    this.sourceassociatedaccountids = item.associatedaccountids;
    this.selectedsourceaccountName = item.Displayname;
    this.sourcedeployementkey = item.deploymentkey;
    this.sourcedpkeydisplay = item.deploymentkey + '|';

    this.sourceentityaddress = (item.Address1 == null ? '' : item.Address1) + ' ' + (item.Address2 == null ? '' : item.Address2);
    this.sourceentityaddress1 = item.Address1 == null ? '' : item.Address1;
    this.sourceentityaddress2 = item.Address2 == null ? '' : item.Address2;
    this.sourcecity = item.city == null ? '' : item.city;
    this.sourcestate = item.state == null ? '' : item.state;
    this.sourcezip = item.zip == null ? '' : item.zip;
    this.sourceentitytype = item.EntityType;
    this.getDevicelistbyentity();
    if (this.interfacetype == 'Outbound' && this.selectedsourceaccountid && this.vendorid && this.outboundmodelradio['option'] == 'Project') {
      this.getprojectname();
    }
    if (this.envSourceProxy == undefined || this.envSourceProxy == '') {
      var response = this.deploymentsConfigurations;
      if (response == undefined || response == '') {
        this.toastr.warning(item.deploymentkey + ' Deployment Configurations are not found. Please Configure the Deployment', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
      else {
        this.envSourceProxy = response[item.deploymentkey].SA;
      }
    }

    this.sourcetypedisplay = item.Type;
    this.sourcetypedisplayid = '|' + this.selectedsourceaccountid;


    let myArray = [];
    this.RouteNameSuggest.forEach(element => {
      if (element.value != '') {
        myArray.push(element.value);
      }
    });

    this.reactiveFormroute.patchValue({
      routename: myArray.map(element => element).join(".")
    });
    this.suggestedroutename = this.reactiveFormroute.value.routename;
    this.array_disableradiobuttons = [];
    this.selecteedvbtype(this.modelradio.option);

    if (this.selectedprocessdisplayname.includes('L2L Result')) {
      this.outboundmodelradio.option = 'Device';
      this.modelradio.option = 'Device';
    }
    else if (this.interfacetype == "Outbound" && this.ProcessorType == 'None') {
      this.outboundmodelradio.option = 'None';
    }
    else if (this.interfacetype == "Inbound" && this.ProcessorType == 'None') {
      this.modelradio.option = 'None';
    } 
  }

  async selectedtargetaccountEvent(item) //target agent selected Event
  {
    if (this.fromprossorSADA == 'SA') {
      this.envTarget = '';
    }
    this.targetorgguid = item.orgguid;
    if (item.Type == "A" || item.Type == 'E-A') {
      this.targettype = "Account";
      this.targetentityprimaryid = item.entityid;
      this.selectedtargetorgid = item.organizationid;
      this.RouteNameSuggest[2]["value"] = item.mnemonic == '' ? this.selectedtargetaccountName.split(' ').join('').split('.').join('').split('-').join('').slice(0, 3) : item.mnemonic;
      this.targetentitymnemonic = item.mnemonic == '' ? this.selectedtargetaccountName.split(' ').join('').split('.').join('').split('-').join('').slice(0, 3) : item.mnemonic;
    }
    else if (item.Type == "O" || item.Type == 'E-O') {
      this.targettype = "Organization";
      this.targetentityprimaryid = item.organizationid;
      this.selectedtargetorgid = item.organizationid;
      this.RouteNameSuggest[2]["value"] = item.orgmnemonic == '' ? this.selectedtargetaccountName.split(' ').join('').split('.').join('').split('-').join('').slice(0, 3) : item.orgmnemonic;
      this.targetentitymnemonic = item.orgmnemonic == '' ? this.selectedtargetaccountName.split(' ').join('').split('.').join('').split('-').join('').slice(0, 3) : item.orgmnemonic;
    }
    else {
      this.targetentityprimaryid = item.entityid;
      this.targettype = item.Type;
      this.selectedtargetorgid = item.organizationid;
    }
    this.selectedtargetaccountid = item.LocationGUID;
    this.destinationIsTestOrganization = this.normalizeTestOrgFlagValue(item?.istestorganization);
    this.testOrgFlagsLoadedForDestGuid = item.LocationGUID;
    this.selectedtargetaccountName = item.Displayname;
    this.targetdeployementkey = item.deploymentkey;
    this.targetassociatedaccountids = item.associatedaccountids;

    this.targetdpkeydisplay = item.deploymentkey + '|';
    this.targetentityaddress = (item.Address1 == null ? '' : item.Address1) + ' ' + (item.Address2 == null ? '' : item.Address2);
    this.targetentityaddress1 = item.Address1 == null ? '' : item.Address1;
    this.targetentityaddress2 = item.Address2 == null ? '' : item.Address2;
    this.targetcity = item.city == null ? '' : item.city;
    this.targetstate = item.state == null ? '' : item.state;
    this.targetzip = item.zip == null ? '' : item.zip;
    this.targetentitytype = item.EntityType;
    this.getDevicelistbyentity();
    if (this.interfacetype == 'Inbound' && this.selectedtargetaccountid && this.vendorid && this.modelradio['option'] == 'Project') {
      this.getprojectname();
    }

    if (this.envTarget == undefined || this.envTarget == '') {
      var response = this.deploymentsConfigurations;
      if (response == undefined || response == '') {
        this.toastr.warning(item.deploymentkey + ' Deployment Configurations are not found. Please Configure the Deployment', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });

      }
      else {
        this.envTarget = response[item.deploymentkey].DA
      }
    }

    this.targettypedisplay = item.Type;
    this.targettypedisplayid = '|' + this.selectedtargetaccountid;

    let myArray = [];
    this.RouteNameSuggest.forEach(element => {
      if (element.value != '') {
        myArray.push(element.value);
      }
    });
    this.reactiveFormroute.patchValue({
      routename: myArray.map(element => element).join(".")
    });
    this.suggestedroutename = this.reactiveFormroute.value.routename;
   
    if(this.messagetype.toLowerCase()=="networkprinting"){
      this.Getvbagentsdetails();
    }
  }

  ProcessorAllList: any = [];
  async getProcessorName(event: any) {
    this.selectedprocessagentid = '';
    this.isLoadingProcesor = true;
    var apiname = '';
    if (event !== 'pipeline') {
      apiname = "api/Agents/GetByDisplayName?name=" + event + '&agentid=0&type=Processor&filterflag=true';
      this.ProcessorList = this.ProcessorAllList.filter(t => t.name.toLowerCase().includes(event.toLowerCase()));
      if (this.ProcessorList.length == 0) {
        this.notfounddata = true;
      } else {
        this.notfounddata = false;
      }
      this.isLoadingProcesor = false;
    }
    else {
      apiname = "api/Agents/GetByDisplayName?name=" + '&agentid=0&type=Processor&filterflag=false';

      await this.service.getapiurl(apiname).subscribe({
        next: async data => {
          this.ProcessorList = data as any[];
          this.ProcessorList.map(obj => { obj.name = obj.displayname, obj.displayname = `${obj.displayname} ${'(' + obj.id + ')'}` });
          this.ProcessorAllList = this.ProcessorList;
          this.selectedprocessagentid = '';
          this.isLoadingProcesor = false;
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.notfounddata = true;
          this.isLoadingProcesor = false;
          this.toastr.error("Unable to fetch Processor details", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      });
    }
  }

  IsOrderInbound: boolean = false;
  IsResultOutbound: boolean = false;
  vbagentid: string = '';
  interfacetype: string;
  ftpremotepath: string = '';
  isshownellkykeys: boolean = false;
  isShownorderinbound: boolean = false;
  isShownorderinboundvb: boolean = false;
  isShownorderinboundftp: boolean = false;
  isShownresultoutbound: boolean = false;
  modelelk: any = {};
  modelvpn: any = {};
  modelapi: any = {};
  apiContractConfig: any = null;
  apiContractInitialData: any = null;
  apiAuthenticationType: 'token' | 'basic' = 'token';
  /** Stored slug in DB: poll | webhook | push */
  apiConnectivityModeSlug: 'poll' | 'webhook' | 'push' | null = null;
  /** UI mode options: VA-API(webhook) | External-API(poll/push by direction) */
  apiConnectivityModeType: 'va-api' | 'external-api' | null = null;
  readonly apiConnectivityModeOptions: Array<{ type: 'va-api' | 'external-api'; label: string }> = [
    { type: 'va-api', label: 'VA-API' },
    { type: 'external-api', label: 'External-API' }
  ];
  apiContractResetVersion: number = 0;
  apiHeadersBulkEditActive = false;
  /** Job trigger lookup (`jobtrigger`); string values e.g. fiveminutes — not persisted in VA connectivity rows. */
  apiPollingJobFrequencyList: string[] = [];
  apiPollingJobFrequency: string = 'fiveminutes';
  readonly defaultApiPollJobFrequency = 'fiveminutes';
  /** Full poll job row from getJobSearch; used for SaveJob updates on edit. */
  externalApiPollJob: any | null = null;
  /** frequencydisplayname last loaded from the poll job (or after create/update). */
  apiPollingJobFrequencyLoaded: string = '';
  vendarmsgdiv: boolean = false;
  ftpexstingpathdiv: boolean = false;
  suffixfromprocessor: string = '*';
  fromprossorSADA: string = '';
  eventtype: number;
  ProcessorType: string = '';
  adtcheck: boolean
  async selectedProcessEvent(item, datarow, mymodal) //Processor selected Event
  {
    if (datarow !== null && datarow.formcontrolname === 'prop') {
      this.oneditftpradio = false
      await this.searchProcesorNameCleared(item, datarow);
      this.selectedprocessagentid = item.id;
      this.selectedprocessdisplayname = item.displayname;
      this.selectedprocessapikey = item.apikey;
      this.ProcessorType = item.processortype;

      var apiname = "api/CoreConfig/GetProcessorUIConfig?agentid=" + item.id + '&apikey=' + item.apikey;
      this.ngxUiLoaderService.start();
      var responseconfig = await this.service.getapi(apiname);
      this.ngxUiLoaderService.stop();
      let jsonresponse = JSON.parse(responseconfig.responsebody);

      if (this.isVaApiSelected() && !this.isProcessorEligibleForVaApi(item, jsonresponse?.processoragentconfig)) {
        this.toastr.warning('Processor is not eligible for VA-API interface creation.', '', {
          timeOut: 6000,
          positionClass: 'toast-bottom-right'
        });
        this.selectedprocessagentid = '';
        this.selectedprocessdisplayname = '';
        this.selectedprocessapikey = '';
        this.ProcessorType = '';
        this.reactiveFormprocess.patchValue({ namep: '' });
        return;
      }

      this.reactiveFormvendar.setValue({ "namevendar": '', "vendorid": '' });
      if (jsonresponse?.processorconfig?.xslconfig['suffix']) {
        this.suffixfromprocessor = jsonresponse.processorconfig.xslconfig['suffix'];
      }
      else {
        this.suffixfromprocessor = '*';
      }

      if (jsonresponse?.processoragentconfig) {
        if (jsonresponse?.processoragentconfig['eventtype']) {
          this.eventtype = jsonresponse?.processoragentconfig['eventtype'];
        }
        if (jsonresponse?.processoragentconfig['messagetype']) {
          this.messagetype = jsonresponse?.processoragentconfig['messagetype'];

          this.envSourceProxy = jsonresponse?.processoragentconfig['sourceagentid'];
          this.envTarget = jsonresponse?.processoragentconfig['destinationagentid'];

          //SA and DA values not clearing after changing entity
          if (this.envSourceProxy == '' && this.envTarget == '') {
            this.fromprossorSADA = 'SADA';
          }
          else if (this.envSourceProxy == '') {
            this.fromprossorSADA = 'DA';
          }
          else if (this.envTarget == '') {
            this.fromprossorSADA = 'SA';
          }
          this.RouteNameSuggest[4]["value"] = this.messagetype;

          this.interfacetype = jsonresponse?.processorconfig["interfacetype"];
          if (this.interfacetype == "EllkayOutbound") {
            this.isshownellkykeys = true;
            this.outboundmodelradio.option='API';
            this.array_disableradiobuttons.push("disable");
            this.oneditftpradio=true;
          }
          else {
            this.isshownellkykeys = false;
          }
          //vendar and message subtype div show
          if (this.interfacetype == "EllkayInbound") {
            this.vendarmsgdiv = false;
            this.modelradio.option='API';
            this.array_disableradiobuttons.push("disable");
            this.oneditftpradio=true;
          }
          else {
            this.vendarmsgdiv = true;
          }

          if (this.interfacetype == "EllkayOutbound" || this.interfacetype == "Outbound") {
            this.RouteNameSuggest[5]["value"] = 'OutBound';
          }

          if (this.interfacetype == "EllkayInbound" || this.interfacetype == "Inbound") {
            this.RouteNameSuggest[5]["value"] = 'InBound';
          }

          if ((this.interfacetype || '').toLowerCase() === 'outbound' &&
            (this.messagetype || '').toLowerCase() === 'networkprinting') {
            await this.selectedoutboundtype('FTP');
          }

          if(this.messagetype.toLowerCase()=="networkprinting"){
            this.customFolderPathDataInputFlag = false;
            
            // Load VB instances when target account is selected
            this.Getvbagentsdetails();
          }
        }
      }
      else {
        this.isshownellkykeys = false;
        this.messagetype = '';
      }

      let myArray = [];

      this.RouteNameSuggest.forEach(element => {
        if (element.value != '') {
          myArray.push(element.value);
        }
      });

      this.reactiveFormroute.patchValue({
        routename: myArray.map(element => element).join(".")
      });
      this.suggestedroutename = this.reactiveFormroute.value.routename;
      if (this.interfacetype == "Outbound" && this.ProcessorType == 'None') {
        this.outboundmodelradio.option = 'None';
      }
      else if (this.interfacetype == "Inbound" && this.ProcessorType == 'None') {
        this.modelradio.option = 'None';
      }
      else if (this.interfacetype == "Outbound") {
        this.ftpexstingpathdiv = true;
        this.ftpcheckexsting = false;
      }
      else {
        this.ftpexstingpathdiv = false;
      }
    }

    if (this.modeSelected != '') {
      this.modeItemsList = [
        {
          id: 'Live',
          name: 'Live',
        },
        {
          id: 'Test Live',
          name: 'Test Live',
        },
        {
          id: 'Hold',
          name: 'Hold',
        }
      ];
      this.reactiveFormmode.patchValue(this.modeItemsList);
    }
    if (this.messagetype.toLowerCase() == 'adt' && mymodal != '') {
      this.adtcheck = true;
      const modalRef = this.modalService.open(mymodal, { windowClass: "interfacedescriptioncreate", backdrop: 'static', keyboard: false });
      this.trackModalRef(modalRef, "interfacedescriptioncreate");
      modalRef.result.then((result) => {
        this.untrackModalRef(modalRef);
      }, (reason) => {
        this.untrackModalRef(modalRef);
      });
    }
  }

  isApiContractBuilderVisible(): boolean {
    const selectedConnectivity = this.getSelectedConnectivityOption();
    return !this.isEllkayApiConnectivityContext()
      && selectedConnectivity === 'api'
      && this.vendorid !== null
      && this.vendorid !== '';
  }

  onApiContractSave(payload: any): void {
    this.apiContractConfig = payload;
  }

  onApiHeadersBulkEditActiveChange(active: boolean): void {
    this.apiHeadersBulkEditActive = !!active;
  }

  getApiDirection(): 'inbound' | 'outbound' {
    return (this.interfacetype || '').toLowerCase().includes('outbound') ? 'outbound' : 'inbound';
  }

  private getSelectedConnectivityOption(connectivityOption?: string): string {
    return (
      connectivityOption
      || (this.getApiDirection() === 'outbound' ? this.outboundmodelradio?.option : this.modelradio?.option)
      || this.connectivitytype
      || ''
    ).toLowerCase();
  }

  private getProcessorDisplayName(): string {
    const fromForm = this.reactiveFormprocess?.get('namep')?.value;
    if ((this.selectedprocessdisplayname || '').trim()) {
      return this.selectedprocessdisplayname.trim();
    }
    if (typeof fromForm === 'string') {
      return fromForm.split('(')[0].trim();
    }
    return ((fromForm?.displayname as string) || '').trim();
  }

  /** Ellkay API when processor name, vendor name, and connectivity are all Ellkay + API. */
  isEllkayApiConnectivityContext(connectivityOption?: string): boolean {
    const processorName = this.getProcessorDisplayName().toLowerCase();
    const vendorName = (
      this.vendarnamevalue
      || this.reactiveFormvendar?.get('namevendar')?.value
      || ''
    ).toString().toLowerCase();
    const connectivity = this.getSelectedConnectivityOption(connectivityOption);
    return processorName.includes('ellkay')
      && vendorName.includes('ellkay')
      && connectivity === 'api';
  }

  shouldShowTargetConnectivityCard(): boolean {
    const it = (this.interfacetype || '').toLowerCase();
    return this.isShownresultoutbound || this.ftpexstingpathdiv ||
      (it === 'outbound'|| it === 'ellkayoutbound')
  }

  shouldShowEllkayKeysOnSource(): boolean {
    return this.isEllkayApiConnectivityContext() && this.getApiDirection() === 'inbound';
  }

  shouldShowEllkayKeysOnTarget(): boolean {
    return this.isEllkayApiConnectivityContext() && this.getApiDirection() === 'outbound';
  }

  isOutboundInterfaceType(): boolean {
    const it = (this.interfacetype || '').toLowerCase();
    return it === 'outbound' || it === 'ellkayoutbound';
  }

  isVaApiSelected(): boolean {
    return this.apiConnectivityModeType === 'va-api';
  }

  /** Matches usp_SaveProjectPipeline webhook processor filters. */
  private isProcessorEligibleForVaApi(item: any, processorAgentConfig?: any): boolean {
    if (!item) {
      return false;
    }

    const type = String(item.type || '').trim().toLowerCase();
    const processorType = String(item.processortype || item.ProcessorType || '').trim().toLowerCase();
    const mode = String(item.Mode || item.mode || '').trim().toLowerCase();
    const status = String(item.status || '').trim().toLowerCase();
    const displayName = String(item.displayname || item.name || '').trim().toLowerCase();

    if (type && type !== 'processor') {
      return false;
    }
    if (processorType !== 'general') {
      return false;
    }
    if (mode !== 'live') {
      return false;
    }
    if (status !== 'active') {
      return false;
    }
    if (displayName.includes('ellkay')) {
      return false;
    }

    const direction = String(processorAgentConfig?.direction || '').trim().toLowerCase();
    if (direction && direction !== 'inbound' && direction !== 'outbound') {
      return false;
    }

    const messageType = String(
      processorAgentConfig?.messagetype || processorAgentConfig?.MessageType || item.messagetype || ''
    ).trim().toLowerCase();
    if (messageType === 'instrumentresult' || messageType === 'instrumentorder') {
      return false;
    }

    return true;
  }

  isExternalApiSelected(): boolean {
    return this.apiConnectivityModeType === 'external-api';
  }

  getEffectiveConnectivityModeSlug(): 'poll' | 'webhook' | 'push' | null {
    if (this.apiConnectivityModeType === 'va-api') {
      return 'webhook';
    }
    if (this.apiConnectivityModeType === 'external-api') {
      return this.getApiDirection() === 'inbound' ? 'poll' : 'push';
    }
    return this.apiConnectivityModeSlug;
  }

  private inferConnectivityModeTypeFromSlug(slug: 'poll' | 'webhook' | 'push' | null): 'va-api' | 'external-api' | null {
    if (!slug) {
      return null;
    }
    return slug === 'webhook' ? 'va-api' : 'external-api';
  }

  /** Same lookup as Jobs UI (`job.component.ts` getJobFrequencies). */
  getApiPollingJobFrequencies(): void {
    const apiname = 'api/Lookup/GetLookUpId?lookuptype=jobtrigger';
    this.service.getapiurl(apiname).subscribe({
      next: (data: any) => {
        this.apiPollingJobFrequencyList = [];
        if (data && Array.isArray(data)) {
          data.forEach((element: string) => {
            this.apiPollingJobFrequencyList.push(element);
          });
        }
        this.applyDefaultApiPollingJobFrequency();
      },
      error: () => {
        this.apiPollingJobFrequencyList = [];
      }
    });
  }

  /** Load frequency list when inbound external poll fields become visible. */
  onApiPollFrequencyFieldContextChanged(): void {
    this.applyDefaultApiAuthAgentIfEmpty();
    this.syncApiAgentFieldDisabledState();
    if (!this.shouldShowApiPollJobFrequencyField()) {
      return;
    }
    if (!(this.apiPollingJobFrequency || '').trim()) {
      this.apiPollingJobFrequency = this.defaultApiPollJobFrequency;
    }
    if (this.apiPollingJobFrequencyList.length === 0) {
      this.getApiPollingJobFrequencies();
    } else {
      this.applyDefaultApiPollingJobFrequency();
    }
  }

  private applyDefaultApiPollingJobFrequency(): void {
    const current = (this.apiPollingJobFrequency || '').trim();
    if (current) {
      return;
    }
    this.apiPollingJobFrequency = this.defaultApiPollJobFrequency;
  }

  private getApiPollJobFrequencyDisplayName(): string {
    const v = (this.apiPollingJobFrequency || '').trim();
    return v || this.defaultApiPollJobFrequency;
  }

  private hasInterfaceUniqueId(): boolean {
    const u = this.UniqueID;
    if (u === null || u === undefined) {
      return false;
    }
    if (typeof u === 'number') {
      return u > 0;
    }
    const s = String(u).trim();
    return s !== '' && s !== '0';
  }

  /** True when creating a new pipeline (no UniqueID yet). Agent → proxy mapping applies only in this case. */
  isCreatePipelineContext(): boolean {
    return !this.hasInterfaceUniqueId();
  }

  private loadCreatePipelineRolePermissions(): void {
    try {
      const roleData = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(
        x => x.RoleName === sessionStorage.getItem('SelectedUserRole')
      );
      if (!roleData?.menuslist) {
        return;
      }
      ['createpipeline', 'tryitout'].forEach(parentMenuName => {
        const menuid = roleData.menuslist.find(y => y.MenuName === parentMenuName)?.MenuId;
        if (!menuid) {
          return;
        }
        roleData.menuslist
          .filter(y => y.ParentMenuId === menuid)
          .forEach(element => {
            this.pagerolepermisions[element.MenuName] = true;
          });
      });
    } catch {
      // role permissions unavailable; fields stay read-only after save
    } finally {
      this.syncApiAgentFieldDisabledState();
    }
  }

  /** Saved non-Ellkay API fields editable only when role includes edittryitout (or copy/new pipeline). */
  get canEditApiConnectivityFields(): boolean {
    if (this.copypipelineflag) {
      return true;
    }
    if (!this.hasInterfaceUniqueId()) {
      return true;
    }
    return !!this.pagerolepermisions?.edittryitout;
  }

  get isApiConnectivityUiReadOnly(): boolean {
    if (!this.isApiContractBuilderVisible()) {
      return false;
    }
    if (this.isLocked) {
      return true;
    }
    return !this.canEditApiConnectivityFields;
  }

  /** ng-autocomplete + formControlName ignores template [disabled]; sync via FormControl instead. */
  private syncApiAgentFieldDisabledState(): void {
    const ctrl = this.reactiveFormagent?.get('agentname');
    if (!ctrl) {
      return;
    }
    if (this.isApiConnectivityUiReadOnly) {
      if (ctrl.enabled) {
        ctrl.disable({ emitEvent: false });
      }
    } else if (ctrl.disabled) {
      ctrl.enable({ emitEvent: false });
    }
  }

  /** Inbound external API poll; hidden after save unless user may edit API connectivity. */
  shouldShowApiPollJobFrequencyField(): boolean {
    if (!this.isInboundExternalPollApiJobContext()) {
      return false;
    }
    if (this.hasInterfaceUniqueId() && !this.canEditApiConnectivityFields) {
      return false;
    }
    return true;
  }

  /** VA-API agent is auto-created (inbound) or resolved by deployment (outbound); picker removed. */
  shouldShowApiAgentField(): boolean {
    return false;
  }

  navigateToAgentById(agentId: string): void {
    const id = (agentId || '').trim();
    if (!id) {
      return;
    }
    this.service.navigateToAgentTabWithAgentId(id);
  }

  private getApiAuthAgentId(): string {
    return (this.selectedAgentguid || '').trim();
  }

  private applyDefaultApiAuthAgentIfEmpty(): void {
    if (!this.isVaApiSelected()) {
      return;
    }
    if (this.getApiAuthAgentId()) {
      return;
    }
    const routeAgentId = this.getAgentIdForApiConnectivityDetailsQuery();
    if (!this.isGuidString(routeAgentId)) {
      return;
    }
    this.selectedAgentguid = routeAgentId;
    this.syncApiAgentAutocompleteDisplay();
  }

  private syncApiAgentAutocompleteDisplay(): void {
    const id = this.getApiAuthAgentId();
    if (!id) {
      return;
    }
    const direction = this.getApiDirection();
    if (direction === 'inbound' && this.selectedsourceagentid === id && this.selectedsourceagentdisplayname) {
      this.reactiveFormagent.patchValue({ agentname: this.selectedsourceagentdisplayname });
      return;
    }
    if (direction === 'outbound' && this.selectedtargetagentid === id && this.selectedtargetagentdisplayname) {
      this.reactiveFormagent.patchValue({ agentname: this.selectedtargetagentdisplayname });
      return;
    }
    this.reactiveFormagent.patchValue({ agentname: id });
    this.syncApiAgentFieldDisabledState();
  }

  /** When `connectivityOption` is passed (e.g. from save), use it so mode matches the connectivity being saved. */
  private isInboundExternalPollApiJobContext(connectivityOption?: string): boolean {
    if (!this.isApiConnectivityNonEllkay(connectivityOption)) {
      return false;
    }
    if (!this.isExternalApiSelected()) {
      return false;
    }
    if (this.getApiDirection() !== 'inbound') {
      return false;
    }
    return this.getEffectiveConnectivityModeSlug() === 'poll';
  }

  private buildExternalApiPollJobDisplayName(): string {
    const raw = (this.selectedroutename || this.reactiveFormroute?.value?.routename || this.selectedrouteDisplayName || 'interface').trim();
    const safe = raw.replace(/[\\/:*?"<>|\s]+/g, '_').replace(/_+/g, '_');
    return `${safe}_ExternalAPI_poll_${this.UniqueID}`;
  }

  private getExternalApiPollJobDisplayNameSearchSuffix(): string {
    if (!this.hasInterfaceUniqueId()) {
      return '';
    }
    return `_ExternalAPI_poll_${String(this.UniqueID).trim()}`;
  }

  shouldShowExternalApiPollJobInAdditionalInfo(): boolean {
    return this.hasInterfaceUniqueId() && this.isInboundExternalPollApiJobContext();
  }

  async loadExternalApiPollJobForInterface(): Promise<void> {
    this.externalApiPollJob = null;
    if (!this.shouldShowExternalApiPollJobInAdditionalInfo()) {
      return;
    }
    const suffix = this.getExternalApiPollJobDisplayNameSearchSuffix();
    if (!suffix) {
      return;
    }
    try {
      const jobs: any = await firstValueFrom(this.service.getJobSearch({
        agentid: '',
        jobid: '',
        displayname: suffix,
        frequencydisplayname: '',
        status: ''
      }));
      if (jobs && ((jobs['status'] && jobs['statusText']) || jobs['statusText'] === 'Unknown Error')) {
        return;
      }
      if (!Array.isArray(jobs) || jobs.length === 0) {
        return;
      }
      const normalizedSuffix = suffix.toLowerCase();
      const match = jobs.find((j: any) =>
        (j?.displayname || '').toLowerCase().endsWith(normalizedSuffix)
      ) || jobs[0];
      const jobid = (match?.jobid || '').trim();
      if (!jobid) {
        return;
      }
      this.externalApiPollJob = { ...match };
      const freq = (match?.frequencydisplayname || '').trim();
      if (freq) {
        this.apiPollingJobFrequency = freq;
      }
      this.apiPollingJobFrequencyLoaded = this.getApiPollJobFrequencyDisplayName();
    } catch {
      this.externalApiPollJob = null;
      this.apiPollingJobFrequencyLoaded = '';
    }
  }

  private buildExternalApiPollJobUpdatePayload(existingJob: any, frequencydisplayname: string): any {
    return {
      uniqueid: existingJob.uniqueid,
      jobid: existingJob.jobid,
      agentid: existingJob.agentid,
      agentname: existingJob.agentname,
      createdby: existingJob.createdby,
      createddate: existingJob.createddate,
      frequency: existingJob.frequency,
      frequencyinmins: existingJob.frequencyinmins,
      lastjobtrigger: existingJob.lastjobtrigger,
      jobversion: existingJob.jobversion,
      lastrun: existingJob.lastrun,
      lastrundata: existingJob.lastrundata,
      modifieddate: existingJob.modifieddate,
      modifierdescription: existingJob.modifierdescription,
      userid: existingJob.userid,
      jobtype: existingJob.jobtype,
      content: existingJob.content,
      processingparam: existingJob.processingparam,
      joburl: existingJob.joburl ?? '',
      runstatus: existingJob.runstatus,
      frequencydisplayname,
      displayname: existingJob.displayname,
      status: existingJob.status,
      monitoring: existingJob.monitoring ?? '',
      modifierid: this.getSessionModifierId()
    };
  }

  private async trySaveInboundExternalApiPollJobAfterSave(
    connectivityOption: string,
    hadInterfaceUniqueIdBeforeSave: boolean,
    apiDetailsSaved: boolean
  ): Promise<void> {
    if (!apiDetailsSaved) {
      return;
    }
    if (hadInterfaceUniqueIdBeforeSave) {
      await this.tryUpdateInboundExternalApiPollJobAfterSave(connectivityOption);
    } else {
      await this.tryCreateInboundExternalApiPollJobAfterSave(connectivityOption, apiDetailsSaved);
    }
  }

  private async tryUpdateInboundExternalApiPollJobAfterSave(connectivityOption: string): Promise<void> {
    if (!this.isInboundExternalPollApiJobContext(connectivityOption)) {
      return;
    }
    if (!this.canEditApiConnectivityFields) {
      return;
    }
    const newFreq = this.getApiPollJobFrequencyDisplayName();
    const loadedFreq = (this.apiPollingJobFrequencyLoaded || this.externalApiPollJob?.frequencydisplayname || '').trim();
    if (loadedFreq && loadedFreq.toLowerCase() === newFreq.toLowerCase()) {
      return;
    }
    if (!this.externalApiPollJob?.jobid) {
      await this.loadExternalApiPollJobForInterface();
    }
    const existingJob = this.externalApiPollJob;
    const uniqueid = Number(existingJob?.uniqueid);
    if (!existingJob?.jobid || !uniqueid) {
      return;
    }
    const jobPayload = this.buildExternalApiPollJobUpdatePayload(existingJob, newFreq);
    try {
      const data: any = await firstValueFrom(this.service.createJob(jobPayload));
      if (data && ((data['status'] && data['statusText']) || data['statusText'] === 'Unknown Error')) {
        this.toastr.error('Failed to update external API poll job frequency.', '', { timeOut: 5000, positionClass: 'toast-bottom-right' });
      } else {
        this.toastr.success('External API poll job frequency updated successfully.', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
        this.externalApiPollJob = data?.jobid ? { ...existingJob, ...data } : { ...existingJob, frequencydisplayname: newFreq };
        this.apiPollingJobFrequencyLoaded = newFreq;
      }
    } catch (err: any) {
      const msg = err?.statusText || err?.message || 'Unknown error';
      this.toastr.error('Unable to update external API poll job frequency: ' + msg, '', { timeOut: 6000, positionClass: 'toast-bottom-right' });
    }
  }

  openExternalApiPollJobInJobsTab(): void {
    const jobId = this.externalApiPollJob?.jobid;
    if (!jobId) {
      return;
    }
    this.service.navigateToJobsTabWithJobId(jobId);
  }

  private getSessionModifierId(): string {
    try {
      return JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
    } catch {
      return '';
    }
  }

  /** Loads sourceagentid / destinationagentid from api/Routes/get (same as getRouteDetails). */
  private async loadRouteAgentIdsFromGetRoute(): Promise<{ sourceAgentId: string; destinationAgentId: string }> {
    const routeId = (this.selectedrouteId || '').trim();
    if (!routeId) {
      return { sourceAgentId: '', destinationAgentId: '' };
    }
    try {
      const data: any = await firstValueFrom(this.service.getapiurl(`api/Routes/get?id=${encodeURIComponent(routeId)}`));
      const sourceAgentId = (data?.sourceagentid || '').trim();
      const destinationAgentId = (data?.destinationagentid || '').trim();
      this.envSourceProxy = sourceAgentId;
      this.envTarget = destinationAgentId;
      return { sourceAgentId, destinationAgentId };
    } catch {
      return { sourceAgentId: '', destinationAgentId: '' };
    }
  }

  private async tryCreateInboundExternalApiPollJobAfterSave(
    connectivityOption: string,
    apiDetailsSaved: boolean
  ): Promise<void> {
    if (!apiDetailsSaved) {
      return;
    }
    if (!this.isInboundExternalPollApiJobContext(connectivityOption)) {
      return;
    }
    const { sourceAgentId } = await this.loadRouteAgentIdsFromGetRoute();
    if (!this.isGuidString(sourceAgentId)) {
      this.toastr.warning(
        'External API poll job was not created because the route source agent is not set.',
        '',
        { timeOut: 6000, positionClass: 'toast-bottom-right' }
      );
      return;
    }
    const freq = this.getApiPollJobFrequencyDisplayName();
    const contentObj = {
      interfaceId: this.selectedrouteId,
      sourceEntity: this.selectedsourceaccountid,
      destinationEntity: this.selectedtargetaccountid,
      agentId: sourceAgentId,
      messageType: (this.messagetype || 'order').toString().toLowerCase(),
      connectivityType: 'api'
    };
    const content = JSON.stringify(contentObj);
    const processingparam = '{}';
    if (!this.service.IsJsonString(content) || !this.service.IsJsonString(processingparam)) {
      this.toastr.error('Poll job payload is invalid JSON.', '', { timeOut: 6000, positionClass: 'toast-bottom-right' });
      return;
    }
    const jobPayload: any = {
      uniqueid: 0,
      jobid: '',
      agentid: sourceAgentId,
      jobtype: 'async',
      content,
      processingparam,
      joburl: '',
      runstatus: 'success',
      frequencydisplayname: freq,
      displayname: this.buildExternalApiPollJobDisplayName(),
      status: 'active',
      monitoring: '',
      modifierid: this.getSessionModifierId()
    };
    try {
      const data: any = await firstValueFrom(this.service.createJob(jobPayload));
      if (data && ((data['status'] && data['statusText']) || data['statusText'] === 'Unknown Error')) {
        this.toastr.error('Failed to create external API poll job.', '', { timeOut: 5000, positionClass: 'toast-bottom-right' });
      } else {
        this.toastr.success('External API poll job created successfully.', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
        const jobid = (data?.jobid || '').toString().trim();
        if (jobid) {
          this.externalApiPollJob = { ...jobPayload, ...data };
          this.apiPollingJobFrequencyLoaded = freq;
        } else {
          await this.loadExternalApiPollJobForInterface();
        }
      }
    } catch (err: any) {
      const msg = err?.statusText || err?.message || 'Unknown error';
      this.toastr.error('Unable to create external API poll job: ' + msg, '', { timeOut: 6000, positionClass: 'toast-bottom-right' });
    }
  }

  private isApiConnectivityNonEllkay(connectivityOption?: string): boolean {
    const connectivity = this.getSelectedConnectivityOption(connectivityOption);
    return connectivity === 'api' && !this.isEllkayApiConnectivityContext(connectivityOption);
  }

  private isGuidString(value: string): boolean {
    const v = (value || '').trim();
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(v);
  }

  /** Route agents from getRouteDetails: inbound uses source agent, outbound uses destination agent (GetApiConnectivityDetails cache key). */
  private getAgentIdForApiConnectivityDetailsQuery(): string {
    const it = (this.interfacetype || '').toLowerCase();
    if (it.includes('outbound')) {
      return (this.selectedtargetagentid || '').trim();
    }
    return (this.selectedsourceagentid || '').trim();
  }

  private normalizeConnectivitySlug(value: string): 'poll' | 'webhook' | 'push' | null {
    const s = (value || '').trim().toLowerCase();
    if (s === 'poll' || s === 'webhook' || s === 'push') {
      return s;
    }
    return null;
  }

  private buildApiConnectivityDetailRows(contractConfig: any): Array<{ name: string; value: string }> {
    const rows: Array<{ name: string; value: string }> = [];
    const effectiveMode = this.getEffectiveConnectivityModeSlug();
    const isVaApi = this.isVaApiSelected();
    if (isVaApi) {
      rows.push({ name: 'auth.agent', value: this.getApiAuthAgentId() });
    }
    rows.push({ name: 'auth.type', value: isVaApi ? '' : (this.apiAuthenticationType || 'token') });
    rows.push({ name: 'auth.connectivitymode', value: effectiveMode || '' });

    if (isVaApi) {
      return rows;
    }

    const cards = Array.isArray(contractConfig?.apiCards) ? contractConfig.apiCards : [];
    cards.forEach((card: any) => {
      const cardKey = ((card?.cardKey as string) || '').trim().toLowerCase();
      if (!cardKey) {
        return;
      }

      rows.push({ name: `${cardKey}.method`, value: card?.method || '' });
      rows.push({ name: `${cardKey}.url`, value: card?.url || '' });
      rows.push({ name: `${cardKey}.bodyType`, value: card?.bodyType || '' });
      rows.push({ name: `${cardKey}.body`, value: card?.body || '' });
      rows.push({ name: `${cardKey}.contentType`, value: card?.contentType || '' });
      if (cardKey === 'push') {
        rows.push({
          name: `${cardKey}.issendbase64`,
          value: card?.isSendBase64 === true || String(card?.isSendBase64 || '').toLowerCase() === 'true' ? 'true' : 'false'
        });
      }
      rows.push({ name: `${cardKey}.auth.username`, value: card?.authUsername || '' });
      rows.push({ name: `${cardKey}.auth.password`, value: card?.authPassword || '' });

      (card?.headers || []).forEach((item: any) => {
        const h = (item?.key || '').trim();
        if (h) {
          rows.push({ name: `${cardKey}.header.${h}`, value: item?.value || '' });
        }
      });

      (card?.queryParams || []).forEach((item: any) => {
        const p = (item?.key || '').trim();
        if (p) {
          rows.push({ name: `${cardKey}.param.${p}`, value: item?.value || '' });
        }
      });
    });

    return rows;
  }

  private mapApiConnectivityDetailsToContract(details: Array<{ Name: string; Value: string }>): any {
    const contract: any = { apiCards: [] };
    const cardMap: Record<string, any> = {};
    const headerMaps: Record<string, Record<string, string>> = {};
    const paramMaps: Record<string, Record<string, string>> = {};

    const ensureCard = (cardKey: string) => {
      const k = (cardKey || '').toLowerCase();
      if (!cardMap[k]) {
        cardMap[k] = {
          cardKey: k,
          method: '',
          url: '',
          bodyType: 'none',
          body: '',
          contentType: '',
          isSendBase64: false,
          authUsername: '',
          authPassword: ''
        };
        headerMaps[k] = {};
        paramMaps[k] = {};
      }
      return cardMap[k];
    };

    (details || []).forEach(item => {
      const key = (item?.Name || '').trim();
      const value = item?.Value ?? '';
      if (!key) {
        return;
      }
      const lower = key.toLowerCase();

      if (lower === 'auth.type') {
        const typeValue = (value || '').toLowerCase();
        this.apiAuthenticationType = typeValue === 'basic' ? 'basic' : 'token';
        return;
      }
      if (lower === 'auth.agent') {
        this.selectedAgentguid = (value || '').trim();
        this.syncApiAgentAutocompleteDisplay();
        return;
      }
      if (lower === 'auth.connectivitymode') {
        this.apiConnectivityModeSlug = this.normalizeConnectivitySlug(value);
        this.apiConnectivityModeType = this.inferConnectivityModeTypeFromSlug(this.apiConnectivityModeSlug);
        return;
      }

      const parts = key.split('.');
      if (parts.length < 2) {
        return;
      }

      const cardKey = (parts[0] || '').toLowerCase();
      const c = ensureCard(cardKey);

      if (parts.length === 2) {
        const field = parts[1].toLowerCase();
        if (field === 'method') {
          c.method = value;
        }
        if (field === 'url') {
          c.url = value;
        }
        if (field === 'bodytype') {
          c.bodyType = value;
        }
        if (field === 'body') {
          c.body = value;
        }
        if (field === 'contenttype') {
          c.contentType = value;
        }
        if (field === 'issendbase64') {
          c.isSendBase64 = String(value || '').trim().toLowerCase() === 'true';
        }
        return;
      }

      if (parts.length >= 3) {
        const section = parts[1].toLowerCase();
        if (section === 'auth' && parts.length === 3) {
          const prop = parts[2].toLowerCase();
          if (prop === 'username') {
            c.authUsername = value;
          }
          if (prop === 'password') {
            c.authPassword = value;
          }
          return;
        }
        if (section === 'header') {
          const headerName = parts.slice(2).join('.');
          if (headerName) {
            headerMaps[cardKey][headerName] = value;
          }
          return;
        }
        if (section === 'param') {
          const paramName = parts.slice(2).join('.');
          if (paramName) {
            paramMaps[cardKey][paramName] = value;
          }
        }
      }
    });

    const toKeyValueList = (m: Record<string, string>) =>
      Object.keys(m || {}).map(k => ({
        key: k,
        value: m[k] ?? ''
      }));

    Object.keys(cardMap).forEach(k => {
      cardMap[k].headers = toKeyValueList(headerMaps[k] || {});
      cardMap[k].queryParams = toKeyValueList(paramMaps[k] || {});
    });

    const orderKeys = (keys: string[]): string[] => {
      const modeKeys = keys.filter(x => x === 'poll' || x === 'webhook' || x === 'push');
      const mode = modeKeys[0];
      const ordered: string[] = [];
      if (keys.includes('token')) {
        ordered.push('token');
      }
      if (keys.includes('refreshtoken')) {
        ordered.push('refreshtoken');
      }
      if (mode) {
        ordered.push(mode);
      }
      keys.forEach(k => {
        if (!ordered.includes(k)) {
          ordered.push(k);
        }
      });
      return ordered;
    };

    const keys = orderKeys(Object.keys(cardMap));
    contract.apiCards = keys.map(k => cardMap[k]);
    return contract;
  }

  private hasLegacyApiConnectivityKeys(details: Array<{ Name: string; Value: string }>): boolean {
    return (details || []).some(row => /\.(param|header)\.\d+\.(key|value)$/i.test((row?.Name || '').trim()));
  }

  private validateLoadedApiConnectivityDetails(details: Array<{ Name: string; Value: string }>): boolean {
    if (!details || details.length === 0) {
      return true;
    }
    if (this.hasLegacyApiConnectivityKeys(details)) {
      return false;
    }
    const byName: Record<string, string> = {};
    details.forEach(r => {
      const n = (r?.Name || '').trim().toLowerCase();
      if (n) {
        byName[n] = (r?.Value ?? '').toString();
      }
    });
    const agent = (byName['auth.agent'] || '').trim();
    const mode = this.normalizeConnectivitySlug(byName['auth.connectivitymode'] || '');
    const authType = (byName['auth.type'] || '').trim().toLowerCase();
    if (!agent || !this.isGuidString(agent)) {
      return false;
    }
    if (!mode) {
      return false;
    }
    const isVaApi = mode === 'webhook';
    if (!isVaApi && authType !== 'token' && authType !== 'basic') {
      return false;
    }
    if (isVaApi) {
      return true;
    }
    const hasModeBlock = details.some(
      r => new RegExp(`^${mode}\\.(method|url|body|bodytype|contenttype|param\\.|header\\.)`, 'i').test((r?.Name || '').trim())
    );
    if (!hasModeBlock) {
      return false;
    }
    if (authType === 'token') {
      const hasToken = details.some(r => /^token\./i.test((r?.Name || '').trim()));
      if (!hasToken) {
        return false;
      }
    }
    return true;
  }

  private hasValidApiAuthForSave(): boolean {
    if (!this.apiConnectivityModeType) {
      this.toastr.error('Please select a connectivity mode (VA-API or External-API).', '', {
        timeOut: 6000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
    this.apiConnectivityModeSlug = this.getEffectiveConnectivityModeSlug();
    if (this.isVaApiSelected()) {
      return true;
    }
    const t = (this.apiAuthenticationType || '').toLowerCase();
    if (t !== 'token' && t !== 'basic') {
      this.toastr.error('Please select authentication type (Token or Basic).', '', {
        timeOut: 6000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
    return true;
  }

  /** Agent, connectivity mode, auth type, and contract cards (used before pipeline save and before API details POST). */
  private validateApiContractForSave(connectivityOption: string): boolean {
    if (!this.isApiConnectivityNonEllkay(connectivityOption)) {
      return true;
    }
    if (!this.hasValidApiAuthForSave()) {
      return false;
    }
    if (this.isVaApiSelected()) {
      return true;
    }
    if (this.apiHeadersBulkEditActive) {
      this.toastr.error('Headers are in Bulk Edit mode. Switch to Key-Value Edit before saving.', '', {
        timeOut: 6000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
    if (!this.apiContractConfig || !Array.isArray(this.apiContractConfig.apiCards) || this.apiContractConfig.apiCards.length === 0) {
      this.toastr.error('API contract details are incomplete. Please configure all API cards before saving.', '', {
        timeOut: 6000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
    if (this.shouldShowApiPollJobFrequencyField()) {
      const f = this.getApiPollJobFrequencyDisplayName();
      if (!f) {
        this.toastr.error('Please select a poll job frequency.', '', {
          timeOut: 6000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }
    }
    if (!this.validateRequiredPollOrPushUrl()) {
      return false;
    }
    return true;
  }

  /** Inbound external-API requires poll URL; outbound external-API requires push URL. */
  private validateRequiredPollOrPushUrl(): boolean {
    const mode = this.getEffectiveConnectivityModeSlug();
    if (mode !== 'poll' && mode !== 'push') {
      return true;
    }
    const cards = Array.isArray(this.apiContractConfig?.apiCards) ? this.apiContractConfig.apiCards : [];
    const modeCard = cards.find((c: any) => (c?.cardKey || '').toLowerCase() === mode);
    const url = (modeCard?.url || '').trim();
    if (url) {
      return true;
    }
    const label = mode === 'poll' ? 'Poll' : 'Push';
    this.toastr.error(`Please enter a ${label} URL before saving.`, '', {
      timeOut: 6000,
      positionClass: 'toast-bottom-right'
    });
    return false;
  }

  private async saveApiConnectivityDetailsIfRequired(connectivityOption: string): Promise<boolean> {
    if (!this.isApiConnectivityNonEllkay(connectivityOption)) {
      return true;
    }

    if (!this.UniqueID) {
      return true;
    }

    if (!this.validateApiContractForSave(connectivityOption)) {
      return false;
    }

    if (this.apiContractInitialData && !this.hasApiConnectivityContractChanged()) {
      return true;
    }

    const detailRows = this.buildApiConnectivityDetailRows(this.apiContractConfig);
    const payload = {
      interfaceId: String(this.UniqueID),
      routeGuid: (this.selectedrouteId || '').trim(),
      userId: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
      details: detailRows
    };

    const response = await this.service.postapi('api/VAIntConnectivityDetails/SaveApiConnectivityDetails', payload);
    return !!response && (response.status || '').toLowerCase() === 'success';
  }

  private hasApiConnectivityContractChanged(): boolean {
    const current = this.normalizeApiDetailRows(this.buildApiConnectivityDetailRows(this.apiContractConfig));
    const initial = this.normalizeApiDetailRows(this.buildApiConnectivityDetailRows(this.apiContractInitialData));
    return current !== initial;
  }

  private normalizeApiDetailRows(rows: Array<{ name: string; value: string }>): string {
    const sorted = (rows || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    return JSON.stringify(sorted);
  }

  private async loadApiConnectivityDetailsIfRequired(): Promise<void> {
    this.apiContractInitialData = null;
    this.apiContractConfig = null;
    this.apiHeadersBulkEditActive = false;
    this.apiConnectivityModeType = null;
    this.apiConnectivityModeSlug = null;
    try {
      if (!this.isApiConnectivityNonEllkay()) {
        return;
      }
      if (!this.UniqueID) {
        return;
      }

      const agentIdForGet = this.getAgentIdForApiConnectivityDetailsQuery();
      if (!this.isGuidString(agentIdForGet)) {
        return;
      }

      try {
        const response = await this.service.getapi(
          `api/VAIntConnectivityDetails/GetApiConnectivityDetails?interfaceId=${this.selectedrouteId}&agentId=${encodeURIComponent(agentIdForGet)}`
        );
        if (Array.isArray(response) && response.length > 0) {
          if (!this.validateLoadedApiConnectivityDetails(response)) {
            this.toastr.warning(
              'Saved API connectivity details do not match the expected format or are incomplete. Please review agent, mode, authentication, and contract fields.',
              '',
              { timeOut: 8000, positionClass: 'toast-bottom-right' }
            );
          }
          const mapped = this.mapApiConnectivityDetailsToContract(response);
          this.apiContractInitialData = mapped;
          this.apiContractConfig = mapped;
        }
      } catch {
        this.apiContractInitialData = null;
        this.apiContractConfig = null;
      }
    } finally {
      await this.loadExternalApiPollJobForInterface();
      this.syncApiAgentFieldDisabledState();
    }
  }

  ftprouteremotepath: string;
  popupflag: boolean = false;
  oldvalue: any = '';
  newvalue: any = '';
  lisfiledownloadurl: string = '';
  notebuttonflag: boolean = false;
  auditbuttonflag: boolean = false;

  vpnconn: any;
  routeflag: boolean = false;
  vbflag: boolean = false;
  ftpflag: boolean = false;
  handlerflag: boolean = false;
  ruleflag: boolean = false;
  interfaceflag: boolean = false;
  vpncheck: boolean = false;
  newvaluestring: string = ''
  oldvaluestring: string = ''
  param: any = ''
  selectedrstatus: string = ''
  selectedroutename: string = ''

  private async getIsRuleEngineForSave():  Promise<boolean>{
    if(await this.isRuleEngineEnabledByLookup() && !this.rulecreateddisplaylabel){
        return true;
    }
    // if (this.isRuleEngine) {
    //   return true;
    // }
    if (this.rulecreateddisplaylabel) {
      return false;
    }
    return false;
  }

 

  private isRuleEngineLookupCandidate(): string {

    const interfaceType =
      this.interfacetype === 'EllkayOutbound' ? 'Outbound'
      : this.interfacetype === 'EllkayInbound' ? 'Inbound'
      : this.interfacetype;
    return `${(this.messagetype || '').toLowerCase()} ${(interfaceType || '').toLowerCase()}`;
  }

  private async isRuleEngineEnabledByLookup(): Promise<boolean> {
    if (this.shouldSuppressRuleEngineForSp5Deployments()) {
      return false;
    }
    const allowedInterfaceAndMessageTypes = await firstValueFrom(
      this.service.getAllowedInterfaceAndMessageTypes()
    );
    const candidate = this.isRuleEngineLookupCandidate();
    return Array.isArray(allowedInterfaceAndMessageTypes)
      ? allowedInterfaceAndMessageTypes.some((item: any) => {
          const val = (item.lookupvalue ?? item.lookUpValue ?? item.LookupValue ?? '').toString().toLowerCase();
          return val === candidate;
        })
      : false;
  }

  //Click on Add button event triggered
  async SaveRouteDetailstoDB() {
    try {
      // const isRuleEngineForSave = await this.isRuleEngineEnabledByLookup();
      const isRuleEngineForSave = await this.getIsRuleEngineForSave();
      this.isRuleEngine = isRuleEngineForSave;

      this.handlercreateddisplaylabel = false;
      this.rulecreateddisplaylabel = false;
      this.ftpcreateddisplaylabel = false;

      this.ngxUiLoaderService.start();
      let connectivityOption=this.interfacetype == "Inbound" || this.interfacetype == "EllkayInbound"?this.modelradio["option"]:this.outboundmodelradio["option"];
      this.UniqueID = this.UniqueID == undefined ? '' : this.UniqueID;
      const hadInterfaceUniqueIdBeforeSave = this.hasInterfaceUniqueId();

      if (!this.validateApiContractForSave(connectivityOption)) {
        this.ngxUiLoaderService.stop();
        return;
      }

      /* Get agent configuration */
      var deploymentleveconfigs = this.deploymentsConfigurations;
      /* Get the lisfiledownloadurl start */

      if (this.interfacetype == "Outbound" || this.interfacetype == "EllkayOutbound" || this.interfacetype == "ResultOutbound") {
        var lisfiledownloadurl = deploymentleveconfigs[this.targetdeployementkey];
        this.lisfiledownloadurl = lisfiledownloadurl.apidetails["lisfiledownloadurl"];
      }
      else {
        var lisfiledownloadurl = deploymentleveconfigs[this.sourcedeployementkey];
        this.lisfiledownloadurl = lisfiledownloadurl.apidetails["lisfiledownloadurl"];
      }

      const processorlist = [];
      this.dynamicJSON.forEach(element => {
        if (element.mapicon) {
          if (element.formgroupname.controls[element.formcontrolname].value.UniqueID == undefined) {
            var objdata = this.ProcessorAllList.find(x => x.id == element.formgroupname.controls[element.formcontrolname].value.split('(')[1].split(')')[0]);
            processorlist.push({
              "UniqueID": objdata.UniqueID,
              "Guid": objdata.id,
              "sequence": element.sequence
            });
          }
          else {
            processorlist.push({
              "UniqueID": element.formgroupname.controls[element.formcontrolname].value.UniqueID,
              "Guid": element.formgroupname.controls[element.formcontrolname].value.id,
              "sequence": element.sequence
            });
          }
        }
        else {
          processorlist.push({
            "UniqueID": element.formgroupname.controls[element.formcontrolname].value.UniqueID,
            "Guid": element.formgroupname.controls[element.formcontrolname].value.id,
            "sequence": element.sequence
          });
        }
      });
      let vendarnameobj = this.VendarsList.find(t => t['Id'] == this.vendorid);
      let connobj = {};
      let vpnobj = {};
      if(this.interfacetype == "Inbound" || this.interfacetype == "EllkayInbound"){
        if(connectivityOption.toLowerCase() == 'ftp'||connectivityOption.toLowerCase() == 'ftpv2')
        {
          if ((this.UniqueID == undefined || this.UniqueID == null || this.UniqueID == '') && connectivityOption.toLowerCase() == 'ftp') {
            connectivityOption = 'FTP'
          }
          else if ((this.UniqueID == undefined || this.UniqueID == null || this.UniqueID == '') && connectivityOption.toLowerCase() == 'ftpv2') {
            connectivityOption = 'FTPV2'
          }       
        }
        if (connectivityOption.toLowerCase() == 'vpn') {
          connobj = {
            "vpnIp": this.modelvpn.ip,
            "vpnPort": this.modelvpn.port,
          }
        }
        else if (connectivityOption.toLowerCase() == 'external ftp') {
          connobj = {
            "externalFtpUsername": this.customftp.username,
            "externalFtpPassowrd": this.customftp.password,
            "externalFtpHost": this.customftp.host,
            "externalFtpPort": this.customftp.port,
            "externalFtpFolderPath": this.customftp.folder,
            "externalFtpArchivePath": this.customftp.archivepath,
          };
        }
        else if (this.isCreatePipelineContext() && connectivityOption == 'API' && !this.isEllkayApiConnectivityContext(connectivityOption)) {
          // VA-API: agent set in Routes/SavePipeline. External-API: clear for ApiProxyAgent.
          this.envSourceProxy = '';
        }
        else if (this.isCreatePipelineContext() && connectivityOption == 'API' && this.isEllkayApiConnectivityContext(connectivityOption)) {
          const agentId = (this.selectedAgentguid || '').trim();
          if (agentId) {
            this.envSourceProxy = agentId;
          }
        }
        else if (connectivityOption == 'VB Client') {
          this.envSourceProxy = this.modelvbclient.vbclientagnetid;
        }
        if(this.selectedvbagentid != ''){
          this.envSourceProxy=this.selectedvbagentid;
        }
      }else if(this.interfacetype == "Outbound" || this.interfacetype == "EllkayOutbound" ){
        if (vendarnameobj['name'].toLowerCase() == 'ellkay' && connectivityOption=='API') {
          connobj = {
            "subscriberKey": this.modelelk.subscriberkey,
            "serviceKey": this.modelelk.servicekey,
          }
        }else if (connectivityOption.toLowerCase() == 'vpn') {
          connobj = {
            "vpnIp": this.ipvpnout,
            "vpnPort": this.portvpnout,
            "vpncustomerpath": this.vpncustomerpath,
          }
        }else if (connectivityOption.toLowerCase() == 'external ftp') {
          connobj = {
            "externalFtpUsername": this.customftp.username,
            "externalFtpPassowrd": this.customftp.password,
            "externalFtpHost": this.customftp.host,
            "externalFtpPort": this.customftp.port,
            "externalFtpRemotePath": this.customftp.folder,
          };
        }
        else if (this.messagetype.toLowerCase() == 'networkprinting') {
          connobj = {
            "CustomerFolderPath": this.customFolderPath,
            "VBAgent": this.selectedVBInstance
          }
        }
        else if (this.isCreatePipelineContext() && connectivityOption == 'API' && !this.isEllkayApiConnectivityContext(connectivityOption)) {
          // VA-API: agent set in Routes/SavePipeline. External-API: clear for ApiProxyAgent.
          this.envTarget = '';
        }


        if(connectivityOption.toLowerCase() == 'ftp'|| connectivityOption.toLowerCase() == 'ftpv2')
        {
          if ((this.UniqueID==undefined|| this.UniqueID==null||this.UniqueID=='') && connectivityOption.toLowerCase() == 'ftp')  {
            connectivityOption = 'FTP'
          }
          else if ((this.UniqueID==undefined|| this.UniqueID==null||this.UniqueID=='') && connectivityOption.toLowerCase() == 'ftpv2') {
            connectivityOption = 'FTPV2'
          }
        }

        if (connectivityOption.toLowerCase() == 'external ftp'||connectivityOption.toLowerCase() == 'external ftpv2') {
          if ((this.UniqueID==undefined|| this.UniqueID==null||this.UniqueID=='')&&connectivityOption.toLowerCase() == 'external ftp')  {
            connectivityOption = 'External FTP'
          }
          else if ((this.UniqueID==undefined|| this.UniqueID==null||this.UniqueID=='') &&connectivityOption.toLowerCase() == 'external ftpv2') {
            connectivityOption = 'External FTPV2'
          }
        }
      }
      const insertorupdatepipelineentity = {
        "projectId": this.id,
        "connectivitytype": this.interfacetype.toLowerCase().includes('ellkay') ? 'API' : connectivityOption,
        "ROUTEID": this.copypipelineflag == true ? '' : this.selectedrouteId,
        "ROUTENAME": this.selectedrouteDisplayName.trimLeft().trimRight(),
        "SEGUID": this.selectedsourceaccountid,
        "SENAME": this.selectedsourceaccountName,
        "SETYPE": this.sourceentitytype,
        "DEGUID": this.selectedtargetaccountid,
        "DENAME": this.selectedtargetaccountName,
        "DETYPE": this.targetentitytype,
        "SOURCEPROXY": this.envSourceProxy,
        "TARGETPROXY": this.envTarget,
        "ROUTEPOLICY": 'SA.SE.DE',
        "MESSAGETYPE": this.messagetype,
        "PAID": this.selectedprocessagentid,
        "MODIFIERID": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
        "STATUS": this.myFlagForSlideToggle == true ? 'active' : 'passive',
        "VERSION": "2",
        "SEDEPLOYMENTKEY": this.sourcedeployementkey,
        "DEDEPLOYMENTKEY": this.targetdeployementkey,
        "VENDORID": this.UniqueID == '' ? ((this.vendorid == '' || this.vendorid == undefined) ? this.reactiveFormvendar.get('vendorid').value : this.vendorid) :
          (this.vendorid == '' || this.vendorid == undefined) ? this.reactiveFormvendar.get('vendorid').value : this.vendorid,
        "copyinterfacemappingsflag": this.copyinterfacemappings,
        "copypipelineflag": this.copypipelineflag,
        "UniqueID": Number(this.UniqueID),
        "seaddress1": this.sourceentityaddress1,
        "seaddress2": this.sourceentityaddress2,
        "secity": this.sourcecity,
        "sestate": this.sourcestate,
        "sezip": this.sourcezip,
        "deaddress1": this.targetentityaddress1,
        "deaddress2": this.targetentityaddress2,
        "decity": this.targetcity,
        "destate": this.targetstate,
        "dezip": this.targetzip,
        "filedownloadurl": this.lisfiledownloadurl,
        "MODE": this.modeSelected,
        "sourcetype": this.sourcetype,
        "targettype": this.targettype,
        "Processorlist": processorlist,
        "interfacetype": this.interfacetype == 'EllkayOutbound' ? 'Outbound' : this.interfacetype == 'EllkayInbound' ? 'Inbound' : this.interfacetype,
        "description": this.selectedInterfacedescription,
        "assigneduserid": (this.UniqueID === 0 || this.UniqueID === '' || this.copypipelineflag == true) ? JSON.parse(sessionStorage.getItem('rolewithmenus'))[0].uniqueId : '',
        "VENDORNAME": vendarnameobj['name'],
        "IsRuleEngine": isRuleEngineForSave,
        "connectivitydetails": connobj,
        "apiConnectivityMode": this.isVaApiSelected() ? 'webhook' : null,
      };
      this.ngxUiLoaderService.start();
      var responseroutedata = await this.service.postapi('api/Routes/SavePipeline', insertorupdatepipelineentity);
      if ((responseroutedata['status'] && responseroutedata['statusText']) || responseroutedata['statusText'] === "Unknown Error") {
        this.ngxUiLoaderService.stop();
        const apiErr = (responseroutedata?.error?.message
          || responseroutedata?.error?.title
          || responseroutedata?.message
          || '').toString().trim();
        this.toastr.error(apiErr || "Unable to create Pipeline", "", {
          timeOut: 6000,
          positionClass: 'toast-bottom-right'
        });
        this.routeflag = false;
      }
      else {
        if (responseroutedata["ROUTEID"] != '') {
          this.dynamicJSON.forEach(element => {
            element.mapicon = true;
          });
          this.auditbuttonflag = true;
          this.notebuttonflag = true;

          this.routeflag = true;
          this.RouteNameSuggest.forEach(element => {
            element.value = '';
          });

          this.selectedrouteId = responseroutedata["ROUTEID"];
          this.selectedroutename = responseroutedata["ROUTENAME"];
          this.UniqueID = responseroutedata['UniqueID'];
          if (this.isVaApiSelected()) {
            const rawVaAgentId = this.getApiDirection() === 'inbound'
              ? (responseroutedata['SOURCEPROXY'] || this.envSourceProxy)
              : (responseroutedata['TARGETPROXY'] || this.envTarget);
            const vaAgentId = (rawVaAgentId || '').toString().trim();
            if (vaAgentId) {
              this.selectedAgentguid = vaAgentId;
              if (this.getApiDirection() === 'inbound') {
                this.selectedsourceagentid = vaAgentId;
                this.envSourceProxy = vaAgentId;
              } else {
                this.selectedtargetagentid = vaAgentId;
                this.envTarget = vaAgentId;
              }
            }
          }
          const apiDetailsSaved = await this.saveApiConnectivityDetailsIfRequired(connectivityOption);
          if (!apiDetailsSaved) {
            this.toastr.error('Pipeline saved successfully but failed to save API connectivity details', "", {
              timeOut: 6000,
              positionClass: 'toast-bottom-right'
            });
          }
          await this.trySaveInboundExternalApiPollJobAfterSave(connectivityOption, hadInterfaceUniqueIdBeforeSave, apiDetailsSaved);
          let vendarnameobj = this.VendarsList.find(t => t['Id'] == responseroutedata['VENDORID']);
          this.selectedrstatus = responseroutedata["STATUS"];
          {
            // Existing: Dynamically validate Rule Engine enablement via lookup API
            // const isLookupMatch = await this.isRuleEngineEnabledByLookup();
            // const isValidForRuleEngine = !!responseroutedata["IsRuleEngine"] && isLookupMatch;
            // if (isValidForRuleEngine && !this.shouldSuppressRuleEngineForSp5Deployments()) {
            //   this.isRuleEngine = true;
            //   this.ngxUiLoaderService.stop();
            //   if (this.isRuleConfigEmptyOrNull) {
            //     await this.openRuleConfigDialog();
            //   }
            //   this.ngxUiLoaderService.start();
            // }

            const apiIsRuleEngine = !!(responseroutedata["IsRuleEngine"] ?? responseroutedata["isRuleEngine"]);
            if (this.isRuleEngine && apiIsRuleEngine && !this.shouldSuppressRuleEngineForSp5Deployments()) {
              this.ngxUiLoaderService.stop();
              if (this.isRuleConfigEmptyOrNull) {
                await this.openRuleConfigDialog();
              }
              this.ngxUiLoaderService.start();
            }
          }
          if ((this.interfacetype == "Inbound" || this.interfacetype == "EllkayInbound") && Object.keys(this.modelradio).length != 0) {
            if (connectivityOption == 'Other') {
              this.updateconfigflagftp = false;
              this.isShownorderinboundftp = false;
              await this.createvbjobexistingftp();//create job 
              this.ngxUiLoaderService.start();
            }
            else if (connectivityOption == 'VB Client') {
              this.updateconfigflagftp = false;
              this.isShownorderinboundftp = false;
            }
            else if (connectivityOption == 'Project') {
              let ftpprojobj = {
                "projectcontextid": this.id.toString(),
                "routeUniqueid": this.UniqueID,
                "routeMessageType": this.messagetype,
                "routeSourceAgent": this.envSourceProxy,
                "suffix": null,
                "createdBy": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
                "direction": this.interfacetype,
                "context": "Pipeline",
                "connectivityType": "FTP"
              }
              this.saveprojectftp(ftpprojobj);
              this.ngxUiLoaderService.start();
            }
            else {
              if (this.updateconfigflagftp) {
                if (this.ftpusername == '' || this.ftppassword == '' || this.ftpport == '' || this.ftpremotepath == '' || this.ftphost == ''
                  || this.ftpusername == undefined || this.ftppassword == undefined || this.ftpport == undefined || this.ftpremotepath == undefined || this.ftphost == undefined
                  || this.modelvpn.ip == undefined || this.modelvpn.ip == ''|| this.modelvpn.port == undefined || this.modelvpn.port == ''
                ) {
                  if (['FTP', 'External FTP', 'FTPV2', 'External FTPV2', 'VPN'].includes(connectivityOption)) {
                    if (this.modelradio["option"] == 'FTP') {
                    }
                    await this.createFTP(false);
                    this.ngxUiLoaderService.start();
                  }

                }
              }

              if (this.updateconfigflagvb) {
                //create vb job and get job id and set
                if (this.selectedjobName == '' && this.selectedjobId == '') {
                  if (connectivityOption == 'VB Client') {
                    await this.getftppaths(this.modelvbclient.vbclientpath + '/');
                  }
                  else if (connectivityOption == 'FTP') {
                    var createjobresponse = await this.createvbjob();
                    await this.SaveVbJobConfig(createjobresponse)
                    this.ngxUiLoaderService.start();
                  }
                }
                else {
                  this.isShownorderinbound = true;
                  this.isShownorderinboundvb = true;
                  if (connectivityOption == 'VB Client') {
                    this.vbfolderpathflag = true;
                    this.vbfolderpathdisplay = this.modelvbclient.vbclientpath;
                  }
                  else {
                    this.vbfolderpathflag = false;
                  }
                }
              }


              if (['FTP', 'External FTP', 'Project', 'FTPV2', 'External FTPV2'].includes(connectivityOption)) {
                this.isShownorderinboundftp = true;
              }
              if (['External FTP', 'External FTPV2'].includes(connectivityOption) && (this.UniqueID == 0 || this.UniqueID != '')) {
                await this.savecustomFTPDetails();
                this.ngxUiLoaderService.start();
                if (connectivityOption == 'External FTP') {
                  await this.SaveUploadOrDownloadVBJob('FTP5FileWatchDownload', connectivityOption);
                  this.ngxUiLoaderService.start();
                }
              }


              this.array_disableradiobuttons.push("disable");
            }

            //create handlers and rule
            
            if (this.popupflag && (this.UniqueID == 0 || this.UniqueID != '') && !this.isRuleEngine) {
              await this.createhandlerandrule(deploymentleveconfigs, this.targetdeployementkey, false);
            }
            else if (!this.popupflag && this.UniqueID >0 && this.RuleConfigJson.length==0) {
              await this.updatehandlerandrule(deploymentleveconfigs, this.targetdeployementkey);
            }
            this.ngxUiLoaderService.start();
          
            if (this.messagetype.toLowerCase() == 'adt') {
              await this.ADTinterfaces(true);
            }
            if (this.messagetype.toLowerCase() == 'dft') {
              this.DFTinterface(true);
            }
         if (connectivityOption == 'VPN'){
          this.CreateSenderListener();
         }
         this.ngxUiLoaderService.start();
          }
          else if (this.interfacetype == "Outbound" || this.interfacetype == "EllkayOutbound") {
            if (Object.keys(this.outboundmodelradio).length != 0) {
              if (['FTP', 'Other', 'VPN', 'External FTP', 'FTPV2', 'External FTPV2'].includes(connectivityOption)) {
                if (this.updateconfigflagftp) {
                  this.array_disableradiobuttons.push("disable");
                  var deployementconfig = deploymentleveconfigs[this.sourcedeployementkey];
                  await this.getrandamusernamepassword();
                  // call create FTP credentials and update ftp config
                  const postentity: any = {
                    "UserName": this.ftpusername,
                    "Password": this.ftppassword,
                    "RemoteSitePath": this.selectedrouteDisplayName, //will create ftp folder with route name
                    "FTPpath": this.modelvbftp.sourcepath,
                    "Deploymentkey": this.targetdeployementkey,
                    "ContextId": this.UniqueID,
                    "AgentId": this.envSourceProxy,
                    "ConnectivityType": connectivityOption,
                    "Context": "pipeline",
                    "ModifierID": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
                    "Suffix": this.suffixfromprocessor,
                    "FolderWatchFlag": true,
                    "MessageTypes": this.messagetype,
                    "Directions": this.interfacetype,
                    "TypeFlag": "Interface"
                  }
                  this.ngxUiLoaderService.start();
                  var ftpresponse = await this.service.postapi("api/FTP/CreateAndSaveFTP", postentity);
                  if (ftpresponse['statusmessage'] == 'Success') {
                    this.ftpflag = true;
                    this.ftpalreadycreated = false;
                    this.ftpusername = ftpresponse['UserName'];
                    this.ftphost = ftpresponse['ServerDomain'];
                    this.ftpport = ftpresponse['Port'];
                    this.ftppassword = ftpresponse['Password'];  
                    if (connectivityOption == 'FTPV2') {
                      this.ftppassword = ftpresponse['Password']
                      this.ftphost = this.ensureSftpPrefix(ftpresponse['ServerDomain']);
                    }
                    this.containername = ftpresponse['containername'];
                    this.remotepathdisplay = connectivityOption == 'Other' ? ftpresponse['FullPath'] : ftpresponse['RemoteSitePath'];
                    await this.getftppaths(ftpresponse['FullPath']);


                    this.ftpexstingpathdiv = false;
                    this.isShownorderinbound = false;
                    this.isShownresultoutbound = true;
                  }
                  else {
                    this.ftpflag = false;
                    this.toastr.error('Pipeline saved successfully but failed to create FTP user', "", {
                      timeOut: 4000,
                      positionClass: 'toast-bottom-right'
                    });
                    return;
                  }

                  if (connectivityOption == 'External FTP' || connectivityOption == 'External FTPV2') {
                    await this.savecustomFTPDetails();
                    if (connectivityOption == 'External FTP') {
                      await this.SaveUploadOrDownloadVBJob('FTP5FileWatchUpload', connectivityOption);
                    }
                    this.updateconfigflagftp = false;
                    this.ftpflag = true;
                    this.ngxUiLoaderService.start();
                  }
                  this.updateconfigflagftp = false;

                }
                if(connectivityOption.toLowerCase() == 'vpn'){
                  this.CreateSenderListener();
                }
                this.ngxUiLoaderService.start();
              }
              else if (this.outboundmodelradio['option'] == 'Project') {
                let ftpprojobj = {
                  "projectcontextid": this.id.toString(),
                  "routeUniqueid": this.UniqueID,
                  "routeMessageType": this.messagetype,
                  "routeSourceAgent": this.envSourceProxy,
                  "suffix": null,
                  "createdBy": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
                  "direction": this.interfacetype,
                  "context": "Pipeline",
                  "connectivityType": "FTP"
                }
                this.saveprojectftp(ftpprojobj);
              }
            }

            if(this.messagetype.toLowerCase()=="networkprinting"){
              //create vbjob
              await this.SaveUploadOrDownloadVBJob('FTP5FileWatchDownload', connectivityOption);
            }
            
            //create handlers and rule 
            if (this.popupflag && (this.UniqueID == 0 || this.UniqueID != '') && !this.isRuleEngine) {
              await this.createhandlerandrule(deploymentleveconfigs, this.sourcedeployementkey, false);
            }
            else if (!this.popupflag && this.UniqueID >0 && this.RuleConfigJson.length==0) {
              await this.updatehandlerandrule(deploymentleveconfigs, this.sourcedeployementkey);
            }
            this.ngxUiLoaderService.start();
          
            if (this.messagetype.toLowerCase() == 'dft') {
              this.DFTinterface(true);
            }
          }

          this.vbjobname = this.selectedjobName;
          this.btnshowtryit = true;

          /*copypipeline start*/
          this.copypipelineflag = false;
          this.oldselectedrouteDisplayName = '';
          this.resetflag = false;
          this.copypiprlinrbutton = true;
          /*copypipeline end*/

          if (this.ProcessorType.toLowerCase() == 'general') {
            await this.gethandlerrulestatus();
          }
          this.isShown = true;
          if (this.popupflag) {
            let filterdata = { "sequence": 1 }
            this.open(filterdata);
          }
          //notifications start
          if (this.routeflag) {
            this.toastr.success('Pipeline saved Successfully with Pipeline Id : ' + this.selectedrouteId, "", { timeOut: 500, positionClass: 'toast-bottom-right' });
            this.getRouteDetails();
          }

          if (!this.routeflag) {
            this.toastr.error('Unable to save the Pipeline', "", { timeOut: 6000, positionClass: 'toast-bottom-right' });
          }

          if (this.popupflag && this.ProcessorType != 'L2L' && this.ProcessorType.toLowerCase() != 'splitter' && this.ProcessorType.toLowerCase() != 'batch') {
            if (this.handlerflag) {
              this.handlercreateddisplaylabel = true;
              this.handlercreatedflag = true;
              this.toastr.success('Handler created Successfully ', "", { timeOut: 500, positionClass: 'toast-bottom-right' });
            }

            if (!this.handlerflag && !this.isRuleEngine) {
              this.handlercreateddisplaylabel = true;
              this.handlercreatedflag = false;
              this.toastr.error('Failed to create Handler', "", { timeOut: 6000, positionClass: 'toast-bottom-right' });
            }

            if (this.interfaceflag && !this.isRuleEngine) {
              this.toastr.success('Interface Details created Successfully ', "", { timeOut: 500, positionClass: 'toast-bottom-right' });
            }
            if (!this.interfaceflag && !this.isRuleEngine) {
              this.toastr.error('Interface Details not created ', "", { timeOut: 6000, positionClass: 'toast-bottom-right' });
            }
          }
          if (this.interfacetype == 'Inbound' || this.interfacetype == 'EllkayInbound') {
            if (!['None', 'API', 'Device'].includes(connectivityOption)) {
              if (this.vbflag && !this.vbjobalreadycreated && connectivityOption != 'FTPV2' && connectivityOption != 'External FTPV2') {
                this.toastr.success('VitalBridge Job created Successfully ', "", { timeOut: 500, positionClass: 'toast-bottom-right' });
              }
              if (!['Other', 'API', 'VPN'].includes(connectivityOption)) {
                if (this.ftpflag && !this.ftpalreadycreated && connectivityOption != 'FTPV2' && connectivityOption != 'External FTPV2') {
                  this.toastr.success('FTP User created Successfully ', "", { timeOut: 500, positionClass: 'toast-bottom-right' });
                  this.ftpcreateddisplaylabel = true;
                  this.ftpcreatedflag = true;
                }
                if (this.ftpflag && !this.ftpalreadycreated && (connectivityOption == 'FTPV2'||connectivityOption=='External FTPV2')&& connectivityOption !== 'VPN' ) {
                  this.toastr.success('SFTP User created Successfully ', "", { timeOut: 500, positionClass: 'toast-bottom-right' });
                  this.ftpcreateddisplaylabel = true;
                  this.ftpcreatedflag = true;
                }
                if (!this.ftpflag&& connectivityOption !== 'VPN' ) {
                  this.ftpcreateddisplaylabel = true;
                  this.ftpcreatedflag = false;
                  this.toastr.error('Failed to create FTP User', "", { timeOut: 6000, positionClass: 'toast-bottom-right' });
                }
              }
              if (!this.vbflag && !['FTPV2', 'External FTPV2', 'VPN'].includes(connectivityOption)) {
                this.toastr.error('Failed to create VitalBridge Job', "", { timeOut: 6000, positionClass: 'toast-bottom-right' });
              }
            }
            if (connectivityOption == 'VB Client') {
              this.copytitle = 'Copy Job Name';
            }
            else if (connectivityOption == 'FTP' || connectivityOption == 'FTP/VPN') {
              this.copytitle = 'Copy FTP Details';
            }
          }
          else if (this.interfacetype == 'Outbound' || this.interfacetype == 'EllkayOutbound') {
            if (connectivityOption === 'FTP' || connectivityOption === 'Other') {
              if (this.ftpflag && !this.ftpalreadycreated && connectivityOption != 'FTPV2') {
                this.ftpcreateddisplaylabel = true;
                this.ftpcreatedflag = true;
                this.toastr.success('FTP User created Successfully ', "", { timeOut: 500, positionClass: 'toast-bottom-right' });
              }
              if (this.ftpflag && !this.ftpalreadycreated && connectivityOption === 'FTPV2') {
                this.ftpcreateddisplaylabel = true;
                this.ftpcreatedflag = true;
                this.toastr.success('SFTP User created Successfully ', "", { timeOut: 500, positionClass: 'toast-bottom-right' });
              }


              if (!this.ftpflag) {
                this.ftpcreateddisplaylabel = true;
                this.ftpcreatedflag = false;
                this.toastr.error('Failed to create FTP User', "", { timeOut: 6000, positionClass: 'toast-bottom-right' });
              }
            }
            // this.isshownellkykeys
            if (this.popupflag && this.ProcessorType != 'L2L' && this.ProcessorType.toLowerCase() != 'splitter' && this.ProcessorType.toLowerCase() != 'batch') {
              if (this.ruleflag) {
                this.rulecreateddisplaylabel = true;
                this.rulecreatedflag = true;
                this.toastr.success('Rule created Successfully ', "", { timeOut: 500, positionClass: 'toast-bottom-right' });
              }
              if (!this.ruleflag && !this.isRuleEngine) {
                this.rulecreateddisplaylabel = true;
                this.rulecreatedflag = false;
                this.toastr.error('Failed to create Rule', "", { timeOut: 6000, positionClass: 'toast-bottom-right' });
              }
            }
          }

          //notifications end
          this.UpdateConnectivityDetails();
          //set copy tab title
          
        }
        else {
          this.ngxUiLoaderService.stop();
          this.toastr.warning('Unable to save the pipeline', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      }

    }
    catch (e) {
      this.ngxUiLoaderService.stop();
      this.toastr.warning(e.message, 'Unable to save the pipeline due to - ', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }


  }

  async reinitiatehandler(mymodalinterfacedescription) {
    this.ruleSpinner = false;
    this.handlerSpinner = true;

    this.selectedInterfacedescription = "";
    await this.createhandlerandrule(this.deploymentsConfigurations, this.sourcedeployementkey, true);
    await this.gethandlerrulestatus();
  }
  async reinitiateFTP() {
    this.ftpSpinner = true;
    if (this.modelradio["option"] == 'FTPV2') {
      this.isShownorderinboundftp = true;
      this.isShownorderinbound = true;
    }
    if (this.outboundmodelradio["option"] == 'FTPV2') {
      this.isShownresultoutbound = true;
      this.modelradio["option"] = this.outboundmodelradio["option"];
    }
    await this.createFTP(true);
    await this.gethandlerrulestatus();
  }
  async reinitiateVBjobs() {
    this.vbSpinner = true;
    if(this.outboundmodelradio["option"]?.toLowerCase() == 'vpn' || this.modelradio["option"]?.toLowerCase() == 'vpn'){
      this.CreateSenderListener();
    }
    else if(this.modelradio["option"] == 'FTP'){
      var createjobresponse = await this.createvbjob();
      await this.SaveVbJobConfig(createjobresponse);
    }
    else if(this.outboundmodelradio["option"] == 'External FTP' || this.modelradio["option"] == 'External FTP'){
      this.SaveUploadOrDownloadVBJob(this.modelradio["option"] == 'External FTP'?'FTP5FileWatchDownload':'FTP5FileWatchUpload', this.outboundmodelradio["option"])
    }
  }
  async reinitiateRules(mymodalinterfacedescription) {
    this.ruleSpinner = true;
    this.handlerSpinner = false;
    this.selectedInterfacedescription = "";
    await this.createhandlerandrule(this.deploymentsConfigurations, this.sourcedeployementkey, true);
    await this.gethandlerrulestatus();
  }




  private findAccountMatchInList(list: any[], guid: string, dpkey?: string): any | null {
    if (!list?.length || !guid) {
      return null;
    }
    if (dpkey) {
      const strictMatch = list.find(s => s.deploymentkey === dpkey && s.LocationGUID === guid);
      if (strictMatch) {
        return strictMatch;
      }
    }
    return list.find(item => this.entityMatchesGuidForTestOrg(item, guid)) ?? null;
  }

  private async getAccountByGuid(guid: string, dpkey: string): Promise<any | null> {
    if (!guid || !dpkey) {
      return null;
    }
    const obj = {
      lsearch: guid,
      deploymentkey: dpkey,
    };
    try {
      const response: any = await firstValueFrom(this.service.GetAccountNamesListAsync(obj));
      if (response?.['status'] && response?.['statusText']) {
        return null;
      }
      return this.findAccountMatchInList(this.toEntitySearchList(response), guid, dpkey);
    } catch {
      return null;
    }
  }

  private applySourceEntityIdsFromAccount(item: any): void {
    if (!item) {
      return;
    }
    const type = item.Type ?? this.sourcetypedisplay;
    if (type === 'A' || type === 'E-A') {
      this.sourceentityprimaryid = item.entityid;
      this.selectedsourceorgid = item.organizationid;
    } else if (type === 'O' || type === 'E-O') {
      this.sourceentityprimaryid = item.organizationid;
      this.selectedsourceorgid = item.organizationid;
    } else {
      this.sourceentityprimaryid = item.entityid;
      this.selectedsourceorgid = item.organizationid;
    }
  }

  private applyTargetEntityIdsFromAccount(item: any): void {
    if (!item) {
      return;
    }
    const type = item.Type ?? this.targettypedisplay;
    if (type === 'A' || type === 'E-A') {
      this.targetentityprimaryid = item.entityid;
      this.selectedtargetorgid = item.organizationid;
    } else if (type === 'O' || type === 'E-O') {
      this.targetentityprimaryid = item.organizationid;
      this.selectedtargetorgid = item.organizationid;
    } else {
      this.targetentityprimaryid = item.entityid;
      this.selectedtargetorgid = item.organizationid;
    }
  }

  private async ensureSourceEntityIds(deploymentkey: string): Promise<void> {
    if (!this.selectedsourceaccountid || !deploymentkey) {
      return;
    }
    if (this.sourceentityprimaryid && this.selectedsourceorgid) {
      return;
    }
    const match = await this.getAccountByGuid(this.selectedsourceaccountid, deploymentkey);
    this.applySourceEntityIdsFromAccount(match);
  }

  private async ensureTargetEntityIds(deploymentkey: string): Promise<void> {
    if (!this.selectedtargetaccountid || !deploymentkey) {
      return;
    }
    if (this.targetentityprimaryid && this.selectedtargetorgid) {
      return;
    }
    const match = await this.getAccountByGuid(this.selectedtargetaccountid, deploymentkey);
    this.applyTargetEntityIdsFromAccount(match);
  }

  async getorgid(guid: string, dpkey: string): Promise<string> {
    const match = await this.getAccountByGuid(guid, dpkey);
    return match ? match.organizationid : '';
  }



  async createhandlerandrule(deployementconfig: any, deployementkey: string, reprocess: boolean) {

    if (deployementconfig != undefined && this.ProcessorType != undefined && this.ProcessorType != 'L2L' && this.ProcessorType.toLowerCase() != 'batch' && this.ProcessorType.toLowerCase() != 'splitter') {

      await this.ensureSourceEntityIds(deployementkey);
      await this.ensureTargetEntityIds(deployementkey);

      if (this.selectedrouteDisplayName.includes("(")) {
        this.selectedrouteDisplayName = this.selectedrouteDisplayName.split("(")[0].trim()
      }
      const createhandlerjsonvalues = environment.HandlerandRuleCreate.HandlerPostJson;

      createhandlerjsonvalues.deploymentkey = deployementkey;
      createhandlerjsonvalues.handler = this.selectedrouteDisplayName;
      createhandlerjsonvalues.description = this.selectedInterfacedescription;
      createhandlerjsonvalues.groupID = this.selectedrouteId;
      if (this.interfacetype == 'EllkayOutbound' || this.interfacetype == 'Outbound') {
        createhandlerjsonvalues.direction = "Out Bound";
        if (this.selectedsourceorgid == '' || this.selectedsourceorgid == undefined) {
          await this.getorgid(this.selectedsourceaccountid, deployementkey).then((response) => {
            this.selectedsourceorgid = response;
          });
        }
        createhandlerjsonvalues.ownerLabOrgID = this.selectedsourceorgid;
        createhandlerjsonvalues.localOutboundFolder = this.sourcepath;
        createhandlerjsonvalues.localOutboundBckFolder = this.archivepath;
        createhandlerjsonvalues.localSourceFolder = '';
        createhandlerjsonvalues.localProcessingFolder = '';
        createhandlerjsonvalues.localFailedFolder = '';
        createhandlerjsonvalues.localSuccessFolder = '';
      }
      else {
        createhandlerjsonvalues.localOutboundFolder = 'NA';
        createhandlerjsonvalues.localOutboundBckFolder = 'NA';
        createhandlerjsonvalues.direction = "In Bound";
        if (this.selectedtargetorgid == '' || this.selectedtargetorgid == undefined) {
          await this.getorgid(this.selectedtargetaccountid, deployementkey).then((response) => {
            this.selectedtargetorgid = response;
          });
        }
        createhandlerjsonvalues.ownerLabOrgID = this.selectedtargetorgid;
        createhandlerjsonvalues.localSourceFolder = this.sourcepath;
        createhandlerjsonvalues.localProcessingFolder = this.progresspath;
        createhandlerjsonvalues.localFailedFolder = this.errorpath;
        createhandlerjsonvalues.localSuccessFolder = this.archivepath;
      }

      if (this.suffixfromprocessor == "*" || this.suffixfromprocessor == "") {
        createhandlerjsonvalues.fileTypes = ".xml";
      }
      else {
        createhandlerjsonvalues.fileTypes = this.suffixfromprocessor;
      }
      //message type
      createhandlerjsonvalues.message = this.messagetype
      var MessageTypeslist = deployementconfig["MessageTypes"];

      if (MessageTypeslist != undefined) {
        MessageTypeslist.forEach(element => {
          if (element.from.toLowerCase() == this.messagetype.toLowerCase()) {
            createhandlerjsonvalues.message = element.to;
          }
        });
      }
      //messagesubtype
      if (this.vendarnamevalue !== '') {
        createhandlerjsonvalues.vendorName = this.vendarnamevalue;
      }

      var MessageSubTypeslist = deployementconfig["MessageSubTypes"];
      MessageSubTypeslist.forEach(element => {
        if (element.Source.includes((this.sourceentitytype + this.sourcetype)) && element.Target.includes((this.targetentitytype + this.targettype))) {
          createhandlerjsonvalues.messageSubtype = element.Value;
        }
      });

      //active and inactive based on status of passive or active
      if (this.myFlagForSlideToggle) {
        createhandlerjsonvalues.isActive = 1;
      }
      else {
        createhandlerjsonvalues.isActive = 0;
      }
      // if (reprocess) {
      //   this.ngxUiLoaderService.start()
      // }
      createhandlerjsonvalues["contextid"] = this.UniqueID;
      createhandlerjsonvalues["username"] = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
      createhandlerjsonvalues['handlerrecreation'] = this.handlerSpinner;
      if(!this.isRuleEngine)
      {
      let handlerresponse = await this.service.dxpostapi("api/VitalHubDXAPI/createhandler", createhandlerjsonvalues);
      if (handlerresponse['status'] !== 'success') {
        this.handlerflag = false;
        this.ngxUiLoaderService.stop();
        this.service.copyableToastError('Failed to create Handler' + handlerresponse['statusText']);
        return false;
      }
      else {
        if (handlerresponse['status'] == 'success') {
          this.handlerflag = true;
          let newvalue = 'Handler created'
          if (reprocess && this.handlerSpinner) {
            this.handlerSpinner = false;
            newvalue = 'Handler ReCreated'
            this.toastr.success('Handler ReCreation ' + "  " + handlerresponse['statusmessage'], "", {
              timeOut: 500,
              positionClass: 'toast-bottom-right'
            });
            let obj = {
              id: this.selectedrouteId,
              displayname: this.selectedrouteDisplayName
            }
            //this.selectedinterfaceEvent(obj)
          }
        }
        else {
          this.handlerflag = false;
          //audit here
          let newvalue = 'Handler not created'
          if (reprocess && this.handlerSpinner) {
            this.handlerSpinner = false;
            this.service.copyableToastError('Handler ReCreation ' + handlerresponse['statusmessage']);
            newvalue = 'Handler not recreated'
          }
        }
        if (this.interfacetype == 'EllkayOutbound' || this.interfacetype == 'Outbound') {


          this.createrulejsonvalues.deploymentkey = deployementkey;
          this.createrulejsonvalues.RuleName = this.selectedrouteDisplayName;
          this.createrulejsonvalues.RuleDesc = this.selectedrouteDisplayName;
          this.createrulejsonvalues.Mode = this.eventtype ? this.eventtype : 102;

          if (this.sourcetypedisplay == 'O') {
            this.createrulejsonvalues.LabId = '-1';
            this.createrulejsonvalues.LabOrgId = this.sourceentityprimaryid;
          }
          else if (this.sourcetypedisplay == 'A') {
            this.createrulejsonvalues.LabId = this.sourceentityprimaryid;
            this.createrulejsonvalues.LabOrgId = this.selectedsourceorgid;
          }

          if (this.targettypedisplay == 'O') {
            this.createrulejsonvalues.OrdFacilityId = '-1';
            this.createrulejsonvalues.OrdFacOrgId = this.targetentityprimaryid;
          }
          else if (this.targettypedisplay == 'A') {
            this.createrulejsonvalues.OrdFacilityId = this.targetentityprimaryid;
            this.createrulejsonvalues.OrdFacOrgId = this.selectedtargetorgid;
          }

          //active and inactive based on status of passive or active 
          if (this.myFlagForSlideToggle) {
            this.createrulejsonvalues.Status = 1;
          }
          else {
            this.createrulejsonvalues.Status = 2;
          }

          this.createrulejsonvalues["contextid"] = this.UniqueID;
          this.createrulejsonvalues["username"] = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
          this.createrulejsonvalues['rulerecreation'] = this.ruleSpinner
          var rulesresponse = await this.service.postapi("api/VitalHubDXAPI/CreateVaRule", this.createrulejsonvalues);
          if (rulesresponse['status'] !== 'success') {
            this.ruleflag = false;
            this.rulebuttonshow = false;
            return false;
          }
          if (rulesresponse['status'] == 'success') {
            this.ruleflag = true;
            this.rulebuttonshow = true;
            let newvalue = 'Rule created'
            if (reprocess && this.ruleSpinner) {
              this.ruleSpinner = false;
              this.toastr.success('Rule ReCreation ' + "  " + rulesresponse['statusmessage'], "", {
                timeOut: 500,
                positionClass: 'toast-bottom-right'
              });
              let obj = {
                id: this.selectedrouteId,
                displayname: this.selectedrouteDisplayName
              }
              newvalue = 'Rule ReCreated'
              //this.selectedinterfaceEvent(obj)
            }
            //audit here
          }
          else {
            this.ruleflag = false;
            //audit here
            let newvalue = 'Rule not created'
            if (reprocess && this.ruleSpinner) {
              this.ruleSpinner = false;
              this.service.copyableToastError('Rule ReCreation ' + "  " + rulesresponse['statusmessage']);
              newvalue = 'Rule not recreated'
            }
          }

          const createinterfacejsonvalues = environment.HandlerandRuleCreate.InterfacePostJson;
          createinterfacejsonvalues.deploymentkey = deployementkey;
          createinterfacejsonvalues.Handler = this.selectedrouteDisplayName;
          createinterfacejsonvalues.InterFaceName = this.selectedrouteDisplayName;
          createinterfacejsonvalues.Description = this.selectedrouteDisplayName;

          let interfaceresponse = await this.service.dxpostapi("api/VitalHubDXAPI/CreateInterfaceDetails", createinterfacejsonvalues);

          if (interfaceresponse['status'] !== 'success') {
            this.interfaceflag = false;
            return false;
          }
          if (interfaceresponse['status'] == 'success') {
            this.interfaceflag = true;

            //audit here
            let auditresponse = await this.service.auditsave("Add", "", "Interface Details created ", "Pipeline", this.UniqueID, "Interface Details created Sucessfully")
            if (auditresponse['status'] && auditresponse['statusText']) {
              this.toastr.error("Unable to Audit the transaction", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
            }
          }
          else {
            this.interfaceflag = false;
            //audit here
            let auditresponse = await this.service.auditsave("Add", "", "Interface Details not created ", "Pipeline", this.UniqueID, "Interface Details not created ")
            if (auditresponse['status'] && auditresponse['statusText']) {
              this.toastr.error("Unable to Audit the transaction", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
            }
          }

          return true;
        }
        else {
          this.interfaceflag = true;
          return true;
        }
      }
    }
    }

  }

  async updatehandlerandrule(deployementconfig: any, deployementkey: string) {
    if (deployementconfig != undefined) {
      await this.ensureSourceEntityIds(deployementkey);
      await this.ensureTargetEntityIds(deployementkey);

      const createhandlerjsonvalues = environment.HandlerandRuleCreate.HandlerPostJson;
      createhandlerjsonvalues.handler = this.selectedrouteDisplayName.trimLeft().trimRight();
      createhandlerjsonvalues.description = this.selectedInterfacedescription;
      createhandlerjsonvalues.groupID = this.selectedrouteId;
      createhandlerjsonvalues.deploymentkey = deployementkey;
      if (this.interfacetype == 'EllkayOutbound' || this.interfacetype == 'Outbound') {
        createhandlerjsonvalues.direction = "Out Bound";
        createhandlerjsonvalues.ownerLabOrgID = this.selectedsourceorgid;
        createhandlerjsonvalues.localOutboundFolder = this.sourcepath;
        createhandlerjsonvalues.localOutboundBckFolder = this.archivepath;
        createhandlerjsonvalues.localSourceFolder = '';
        createhandlerjsonvalues.localProcessingFolder = '';
        createhandlerjsonvalues.localFailedFolder = '';
        createhandlerjsonvalues.localSuccessFolder = '';
      }
      else {
        createhandlerjsonvalues.localOutboundFolder = 'NA';
        createhandlerjsonvalues.localOutboundBckFolder = 'NA';
        createhandlerjsonvalues.direction = "In Bound";
        createhandlerjsonvalues.ownerLabOrgID = this.selectedtargetorgid;
        createhandlerjsonvalues.localSourceFolder = this.sourcepath;
        createhandlerjsonvalues.localProcessingFolder = this.progresspath;
        createhandlerjsonvalues.localFailedFolder = this.errorpath;
        createhandlerjsonvalues.localSuccessFolder = this.archivepath;
      }

      if (this.suffixfromprocessor == "*" || this.suffixfromprocessor == "") {
        createhandlerjsonvalues.fileTypes = ".xml";
      }
      else {
        createhandlerjsonvalues.fileTypes = this.suffixfromprocessor;
      }
      //message type
      createhandlerjsonvalues.message = this.messagetype
      var MessageTypeslist = deployementconfig["MessageTypes"];

      if (MessageTypeslist != undefined) {
        MessageTypeslist.forEach(element => {
          if (element.from.toLowerCase() == this.messagetype.toLowerCase()) {
            createhandlerjsonvalues.message = element.to;
          }
        });
      }
      //messagesubtype
      if (this.vendarnamevalue !== '') {
        createhandlerjsonvalues.vendorName = this.vendarnamevalue;
      }

      var MessageSubTypeslist = deployementconfig["MessageSubTypes"];
      MessageSubTypeslist.forEach(element => {
        if (element.Source.includes((this.sourceentitytype + this.sourcetype)) && element.Target.includes((this.targetentitytype + this.targettype))) {
          createhandlerjsonvalues.messageSubtype = element.Value;
        }
      });

      //active and inactive based on status of passive or active
      if (this.myFlagForSlideToggle) {
        createhandlerjsonvalues.isActive = 1;
      }
      else {
        createhandlerjsonvalues.isActive = 0;
      }
      createhandlerjsonvalues.isActive = 0;
      
      var handlerresponse = await this.service.dxpostapi('api/VitalHubDXAPI/UpdateHandlerRulename', createhandlerjsonvalues);
      if (handlerresponse['status'] && handlerresponse['statusText']) {
        this.handlerflag = false;
        this.ngxUiLoaderService.stop();
        this.service.copyableToastError('Failed to update Handler name and Rule name ' + handlerresponse['statusText']);
        return false;
      }
      else {

        if (handlerresponse['status'] == 'Success') {
          this.handlerflag = true;
          var responseaudit = await this.service.auditsave("Add", "", "Handler updates", "Pipeline", this.UniqueID, 'Handler updated successfully')
          if (responseaudit['status'] && responseaudit['statusText']) {
            this.toastr.error("Unable to Audit the transaction", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }

          if (this.isOutboundInterfaceType()) {
            responseaudit = await this.service.auditsave("Add", "", "Rule updates ", "Pipeline", this.UniqueID, 'Varule updated successfully')
            if (responseaudit['status'] && responseaudit['statusText']) {
              this.toastr.error("Unable to Audit the transaction", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
            }
          }

        }
        else {
          this.handlerflag = false;
          var responseaudit = await this.service.auditsave("Add", "", "Handler not updated ", "Pipeline", this.UniqueID, 'Handler not updated "')
          if (responseaudit['status'] && responseaudit['statusText']) {
            this.toastr.error("Unable to Audit the transaction", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }

          if (this.isOutboundInterfaceType()) {
            responseaudit = await this.service.auditsave("Add", "", "Rule not updated ", "Pipeline", this.UniqueID, 'Rule not updated "')
            if (responseaudit['status'] && responseaudit['statusText']) {
              this.toastr.error("Unable to Audit the transaction", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
            }
          }
          return true;
        }
      }
    
    }
  }
  //get the deployement configuration in the agent level
  async getdeploymentconfiguration() {
    var apiname = "api/CoreConfig/GetProcessorUIConfig?agentid=&apikey=";
    var responseconfig = await this.service.getapi(apiname);
    var configs = JSON.parse(responseconfig.responsebody);
    return configs;
  }

  //existing FTP create VB


  async createvbjobexistingftp() {
    if (this.selectedjobName == '' && this.selectedjobId == '') {
      this.sourcepath = this.modelvbftp.sourcepath;
      this.archivepath = this.modelvbftp.archivepath;
      this.errorpath = this.modelvbftp.errorpath;
      this.progresspath = this.modelvbftp.progresspath;
      var createjobresponse = await this.createvbjob();
      if (createjobresponse.status == "success") {
        this.selectedjobId = createjobresponse.jobid;
        this.selectedjobName = createjobresponse.jobname;
        this.ftpflag = false;
        this.vbflag = true;
        this.vbjobnameftp = this.selectedjobName;
        this.vbjobdisplayexftp = true;
        if (this.modelradio["option"] == 'Other') {
          this.ftpisDisabled = true;
        }
        else {
          this.ftpisDisabled = false;
        }
      }

    }


  }


  async checkvbagentexist() {

    if (Object.keys(this.modelradio).length != 0) {
      if (this.modelradio["option"] == "VB Client") {
        if (Object.keys(this.modelvbclient).length != 0) {
          if (this.modelvbclient.vbclientagnetid == '' || this.modelvbclient.vbclientagnetid == undefined || this.modelvbclient.vbclientagnetid == 'select') {

            this.toastr.warning('Agent Id is mandatory', "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
            return false;
          }
          else if (this.modelvbclient.vbclientpath == '' || this.modelvbclient.vbclientpath == undefined) {

            this.toastr.warning("Folder path is mandatory", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
            return false;
          }
          else {
            return true;
          }
        }
        else {

          this.toastr.warning("Please enter the required fields", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return false;
        }
      }
      else {
        return true;
      }
    }
    else {
      this.toastr.warning("Please enter the required fields", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
  }

  async getftppaths(path: any) {
    path = path.replace(/\//g, "");

    if (this.sourcepath == '' || this.sourcepath == undefined) {
      this.sourcepath = path;
    }

    if (this.archivepath == '' || this.archivepath == undefined) {
      this.archivepath = path + '\archive';
      if (this.modelradio["option"] === "FTPV2" || this.outboundmodelradio["option"] === 'FTPV2') {
        this.archivepath = path + '\\archive';
      }
    }

    if (this.errorpath == '' || this.errorpath == undefined) {
      this.errorpath = path + '\error';
      if (this.modelradio["option"] === "FTPV2" || this.outboundmodelradio["option"] === 'FTPV2') {
        this.errorpath = path + '\\error';
      }
    }

    if (this.progresspath == '' || this.progresspath == undefined) {
      this.progresspath = path + '\progress';
      if (this.modelradio["option"] == "FTPV2" || this.outboundmodelradio["option"] === 'FTPV2') {
        this.progresspath = path + '\\progress';
      }
    }

  }

  async getrandamusernamepassword() {

    if (this.ftpusername == '' || this.ftpusername == undefined) {
      this.ftpusername = this.sourceentitymnemonic + '-' + this.targetentitymnemonic + '-' + this.vendormnemonic + '-' + Math.floor(Math.random() * 1000 + 1000);
    }

    if (this.ftppassword == '' || this.ftppassword == undefined) {

      var lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
      var upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      var symbols = ['!', '?', '@'];

      var getRandom = function (array) {
        return array[Math.floor(Math.random() * array.length)];
      }

      var finalCharacters = "";
      finalCharacters = finalCharacters.concat(getRandom(upperCharacters));
      finalCharacters = finalCharacters.concat(getRandom(numbers));
      finalCharacters = finalCharacters.concat(getRandom(symbols));

      // Old requirement (10-char password): for (var i = 0; i < 10 - 3; i++) {
      const requiredPasswordLength = 15;
      for (let i = 0; i < requiredPasswordLength - 3; i++) {
        finalCharacters = finalCharacters.concat(getRandom(lowerCharacters));
      }

      finalCharacters.split('').sort(function () { return 0.5 - Math.random() }).join('');
      this.ftppassword = finalCharacters;
    }

  }

  async createvbjob() {
    //call the VB api to create the job
    this.vbreturndetails = {
      "status": "",
      "jobid": '',
      "jobname": ""
    };

    var extensionsmulti = '';
    this.selectedextensionItems.forEach(element => {
      extensionsmulti = element.item_text;
      this.extensions.push(extensionsmulti)
    });
    this.vbFileWatchUploadJob["routeUniqueId"] = this.UniqueID;
    this.vbFileWatchUploadJob["agentid"] = this.envSourceProxy;
    this.vbFileWatchUploadJob["status"]='active';
    this.vbFileWatchUploadJob["action"] = this.myFlagForSlideToggle ? "Start" : "Stop";
    this.vbFileWatchUploadJob["jobname"] = this.selectedrouteDisplayName;
    this.vbFileWatchUploadJob["jobtype"] = "FileWatchAndUpload";
    this.vbFileWatchUploadJob["createdby"] = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
    this.vbFileWatchUploadJob["connectivitytype"] = this.modelradio["option"];
    
    let obj={
      FileWatchPath: this.sourcepath,
      FileWatchArchivePath: this.archivepath,
      FileWatchErrorPath: this.errorpath,
      FileWatchProgressPath: this.progresspath,
      FileWatchRemotePath: this.suggestedroutename,
      RouteDefinitionId:this.selectedrouteId,
      MessageType : this.messagetype,
      SourceEntityId: this.selectedsourceaccountid,
      DestinationEntityId: this.selectedtargetaccountid
    }
    this.vbFileWatchUploadJob["connectivity"]=obj;

    let response = await this.service.postapi('api/VBJobs/SaveVBFileJob', this.vbFileWatchUploadJob);
    if (response.status == 'success') {
      this.vbreturndetails.status = 'success';
      this.vbreturndetails.jobid = response.content["jobid"];
      this.vbreturndetails.jobname = response.content["jobname"];
    }


    return this.vbreturndetails;
  }
  async validatedata() {
    let flag = true; let pflag = true;
    if ((this.ProcessorType == 'Custom' || this.ProcessorType == 'None') && Number(this.UniqueID) > 0) {
      pflag = false;
    }

    if (pflag) {
      //processor checks
      this.dynamicJSON.forEach(array => {
        if (array.formgroupname.controls[array.formcontrolname].value === '') {
          flag = false;
        }
      });
    }
    let list = [];
    if (flag) {
      this.dynamicJSON.forEach(element => {
        if (element.mapicon) {
          if (element.formgroupname.controls[element.formcontrolname].value.UniqueID == undefined) {
            list.push(this.ProcessorAllList.find(x => x.id == element.formgroupname.controls[element.formcontrolname].value.split('(')[1].split(')')[0]).UniqueID);
          }
          else {
            list.push(element.formgroupname.controls[element.formcontrolname].value.UniqueID);
          }
        }
        else {
          list.push(element.formgroupname.controls[element.formcontrolname].value.UniqueID);
        }
      });

      var filterids = list.filter((ele, indx) => indx !== list.indexOf(ele));
      if (filterids.length > 0) {
        flag = false;
      }
      else {
        flag = true;
      }
    }

    if (flag) {
      this.selectedprocessagentid = this.selectedprocessagentid == undefined ? this.reactiveFormprocess.value.namep.split('(')[1].split(')')[0] : this.selectedprocessagentid;
      this.selectedsourceaccountid = this.selectedsourceaccountid == undefined ? this.reactiveFormsource.value.name.LocationGUID : this.selectedsourceaccountid;
      this.selectedtargetaccountid = this.selectedtargetaccountid == undefined ? this.reactiveFormtarget.value.namet.LocationGUID : this.selectedtargetaccountid;

      if (this.selectedprocessagentid == '' && this.reactiveFormprocess.get('namep').value) {
        this.selectedprocessagentid = this.reactiveFormprocess.get('namep').value.id;
      }

      if (this.selectedsourceaccountid == '' && this.reactiveFormsource.get('name').value) {
        this.selectedsourceaccountid = this.reactiveFormsource.get('name').value.id;
      }

      if (this.selectedtargetaccountid == '' && this.reactiveFormtarget.get('namet').value) {
        this.selectedtargetaccountid = this.reactiveFormtarget.get('namet').value.id;
      }

      if (this.reactiveFormroute.get('routename').value) {
        const routeNameValue = this.reactiveFormroute.get('routename')?.value || '';
        const hasSpecialChars = /^[a-zA-Z0-9-_. ]+$/.test(routeNameValue); // allow letters, numbers, space, -, _, .
        if (!hasSpecialChars) {
          this.toastr.warning('Pipeline name special characters are not allowed.', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return false; // stop submission if invalid
        }
      }

      if (this.selectedprocessagentid == "") {
        this.toastr.warning('Processor is mandatory', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }

      if (this.selectedsourceaccountid == "" || this.selectedsourceaccountid == undefined) {
        this.toastr.warning('Source Entity is mandatory', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }

      if (this.selectedtargetaccountid == "" || this.selectedtargetaccountid == undefined) {
        this.toastr.warning('Target Entity is mandatory', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }

      if (this.modeSelected == "") {
        this.toastr.warning('Mode is mandatory', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }


      if (!this.reactiveFormvendar.get('namevendar').value || !this.vendarnamevalue) {
        this.toastr.warning('Vendor name is mandatory', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }


      if (this.isEllkayApiConnectivityContext() && this.getApiDirection() === 'outbound') {
        if (!this.modelelk.subscriberkey
          || !this.modelelk.servicekey) {
          this.toastr.warning('Keys are mandatory', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return false;
        }
      }
      // if (  (this.modelradio.option==='API' && (this.envSourceProxy==''|| this.envSourceProxy==null)) || (this.selectedAgentguid=='' && this.outboundmodelradio.option==='API') && !this.isshownellkykeys && this.UniqueID=='') {
      //     this.toastr.warning('Agent is mandatory', "", {
      //       timeOut: 4000,
      //       positionClass: 'toast-bottom-right'
      //     });
      //     return false;
      //   }

      if (this.selectedrouteDisplayName == "" && (this.reactiveFormroute.value.routename == null || this.reactiveFormroute.value.routename == '')) {
        this.toastr.warning('Pipeline is mandatory', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }

      if (this.ftpcheckexsting) {
        if (this.ftpexistingpath == '') {
          this.toastr.warning('FTP path is mandatory', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return false;
        }
      }


      if (this.interfacetype == "Inbound" && this.modelradio["option"] == undefined) {
        this.toastr.warning('Connectivity is mandatory', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }

      if (this.interfacetype !== "EllkayInbound" && this.interfacetype !== "EllkayOutbound") {

        if (this.modelradio["option"] == "VPN" && (!this.modelvpn.ip || !this.modelvpn.port)) {
          this.toastr.warning('VPN details are mandatory', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return false;
        }

        if (this.modelradio["option"] == "External FTP" && (!this.customftp.username || !this.customftp.password || !this.customftp.host || !this.customftp.port || !this.customftp.folder || !this.customftp.archivepath)) {
          this.toastr.warning('External Ftp details are mandatory', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return false;
        }

      }

      if (this.interfacetype == 'Inbound') {
        if (!this.selectedjobName && !this.selectedjobId) {
          return await this.checkvbagentexist();
        }
      }
      else {
        return true;
      }
      return true;
    }
    else {
      this.toastr.warning('Processor is mandatory', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
  }
  open(rowdata) {
    if (rowdata !== '') {
      var controldata = this.dynamicJSON.filter(a => a.sequence == rowdata.sequence);
      var filterdata;
      if (controldata[0].formgroupname.value[controldata[0].formcontrolname].displayname == undefined) {
        filterdata = this.ProcessorAllList.find(d => d.displayname == controldata[0].formgroupname.value[controldata[0].formcontrolname])
      }
      else {
        filterdata = this.ProcessorAllList.find(d => d.displayname == controldata[0].formgroupname.value[controldata[0].formcontrolname].displayname);
      }
      if ((filterdata.processorurl != '' || filterdata.processor) &&
        filterdata.processortype == 'General') {
        if (this.selectedrouteId) {
          
          var url = "api/GetMappings/Get?routeid=" + this.selectedrouteId + "&processorid=" + filterdata.id + "&processorapikey=" + filterdata.apikey;
          this.ngxUiLoaderService.start();
          this.service.getapiurl(url).subscribe({
            next: async (responce) => {
              await this.ensureTestOrganizationFlagsLoaded();
              this.Templatearray = responce as any[];
              var interfacetype = this.Templatearray["routeDetails"].INTERFACETYPE;


              if (interfacetype && interfacetype.trim() === "Inbound") {
                this.disableGeneratePDFButton = true;
              } else {
                this.disableGeneratePDFButton = false;
              }
              this.dataToModal = {
                lockXMLmap: this.isLocked,
                MappedXml: this.Templatearray["mappedxml"],
                routeid: this.selectedrouteId,
                processorid: filterdata.id,
                templateid: this.Templatearray["template"],
                templatelist: this.Templatearray["templatelist"],
                resultJson: this.Templatearray["resultjson"],
                routeName: this.selectedrouteDisplayName,
                ProcessorName: filterdata.name,
                processorapikey: filterdata.apikey,
                uniqueid: this.UniqueID,
                routedetails: this.Templatearray["routeDetails"],
                CoreConfigVersionList: this.Templatearray["CoreConfigVersionList"],
                interfaceType: interfacetype,
                disablePDFButton: this.disableGeneratePDFButton,
                componentname:'createpipeline',
                connectivitytype:this.modelradio["option"],
                deploymentkey:this.sourcedpkeydisplay,
                messagetype: this.messagetype ? this.messagetype.toLowerCase() : '',
                ...this.getTestOrganizationFlagsForChildDialogs(),
              };
              
              //check vendor has morethan one template

              if (this.popupflag && responce["templatelist"].filter(x => x.vendor == this.vendorid && x.direction.toLowerCase() == (this.interfacetype ? this.interfacetype.toLowerCase() : '') && x.messagetype == (this.messagetype ? this.messagetype.toLowerCase() : '')).length > 1) {
                const message = this.vendarnamevalue.toUpperCase() + ` Vendor has more than one template !!`;
                this.ngxUiLoaderService.stop();
                const dialogData = new ConfirmDialogModel("Select Template", message, 'select', responce["templatelist"].filter(x => x.vendor == this.vendorid && x.direction.toLowerCase() == (this.interfacetype ? this.interfacetype.toLowerCase() : '') && x.messagetype == (this.messagetype ? this.messagetype.toLowerCase() : '')));
                const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: "700px", data: dialogData, disableClose: true });

                dialogRef.afterClosed().subscribe(async dialogResult => {
                  if (dialogResult === false) {
                    this.ngxUiLoaderService.stop();
                    return;
                  }
                  else {

                    this.dataToModal.templateid = dialogResult;
                    this.dataToModal.MappedXml = this.Templatearray["templatelist"].find(x => x.id == dialogResult)["mappedxml"];
                    const modalRef = this.modalService.open(XmlmappingsComponent,
                      { windowClass: "myCustomModalClasscreatexml", backdropClass: "xmlmappings-backdrop", backdrop: 'static', keyboard: false });
                    modalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
                    this.trackModalRef(modalRef, "myCustomModalClasscreatexml");
                    modalRef.result.then((response) => {
                      this.untrackModalRef(modalRef);
                      if (this.ProcessorType == 'Custom' || this.ProcessorType == 'None') {
                        this.routeconfigflag = false;
                      }
                      else if(this.ProcessorType == 'General' && response){
                        this.routeconfigflag = false;
                      }
                      // this.ngxUiLoaderService.start();
                      // this.getRouteDetails().then((response) => {
                      //   this.ngxUiLoaderService.stop();
                      // });
                    }, (reason) => {
                      this.untrackModalRef(modalRef);
                    });
                  }
                });
              }
              else {
                this.ngxUiLoaderService.stop();
                if (responce["templatelist"].filter(x => x.vendor == this.vendarnamevalue && x.direction == this.interfacetype && x.messagetype == this.messagetype) > 0) {
                  if (responce["templatelist"].filter(x => x.vendor == this.vendarnamevalue && x.direction == this.interfacetype && x.messagetype == this.messagetype)[0].id !== '') {
                    this.dataToModal.templateid = responce["templatelist"].filter(x => x.vendor == this.vendarnamevalue && x.direction == this.interfacetype && x.messagetype == this.messagetype)[0].id;
                  }
                }

                if (this.Templatearray["mappedxml"] != null) {
                  const modalRef = this.modalService.open(XmlmappingsComponent,
                    { windowClass: "myCustomModalClasscreatexml", backdropClass: "xmlmappings-backdrop", backdrop: 'static', keyboard: false });
                  modalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
                  modalRef.result.then((response) => {
                    if (this.ProcessorType == 'Custom' || this.ProcessorType == 'None') {
                      this.routeconfigflag = false;
                    }
                    else if(this.ProcessorType == 'General' && response){
                      this.routeconfigflag = false;
                    }
                    // this.ngxUiLoaderService.start();
                    // this.getRouteDetails().then((response) => {
                    //   this.ngxUiLoaderService.stop();
                    // });
                  }, (reason) => {
                  });
                }
                else {
                  this.modalService.dismissAll();
                  this.toastr.warning('Template configurations are not available', "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                  });
                }
              }
            },
            error: error => {
              this.ngxUiLoaderService.stop();

              this.toastr.error('Unable to fetch Mapping Configuration', "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              });
            }
          });
        }
        else {
          this.toastr.warning('Please select the Pipeline Name', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      }
      else {
        this.toastr.warning('Mappings are not applicable for this ' + filterdata.processortype + ' processor type', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        this.getRouteDetails();
      }
    }
    else {
      this.toastr.warning('Pipeline and Processor are mandatory', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }

  //Tryitout modal start
  public dataToModal: any;
  async opentryiytout() {
    let fileUploadFTP: boolean;
    let enableAccessionSearch: boolean;
    let vaconfigdata: any;
    let interfacetype: any;
    if (this.selectedrouteId != '' && this.selectedprocessagentid != '') {

      this.ngxUiLoaderService.start();
      var response = await this.getFileConfig(this.selectedrouteId, this.selectedprocessagentid);
      if (!response?.length) {
        this.ngxUiLoaderService.stop();
        this.toastr.warning('No mapping version found.', '', { timeOut: 3500, positionClass: 'toast-bottom-right' });
        return;
      }
      const configToUse = this.service.resolveLiveConfig(response);
      if (!configToUse?.json) {
        this.ngxUiLoaderService.stop();
        this.toastr.warning('No live mapping version found for the route.', '', { timeOut: 3500, positionClass: 'toast-bottom-right' });
        return;
      }
      var jsonData = configToUse["json"];
      vaconfigdata = jsonData.processorconfig["vaconfig"];
      interfacetype = jsonData.processorconfig["interfacetype"];
      if (this.interfacetype === "Outbound" || this.interfacetype === "EllkayOutbound") {
        fileUploadFTP = false;
        enableAccessionSearch = true;
      }
      else if (this.interfacetype === "Inbound" || this.interfacetype === "EllkayInbound") {
        fileUploadFTP = true;
        enableAccessionSearch = false;
      }
      else {
        fileUploadFTP = false;
        enableAccessionSearch = false;
      }

      this.dataToModal = {
        RouteIdtry: this.selectedrouteId,
        ProcessorIdtry: this.selectedprocessagentid,
        ProcessorDisplayNametry: this.selectedprocessdisplayname,
        RouteDisplayNametry: this.selectedrouteDisplayName,
        Processorapikey: this.selectedprocessapikey,
        Popupflag: true,
        PopupSource: 'create',
        MappedXmlTemp: '',
        isFileUpload: vaconfigdata.isfileupload == 0 ? false : true,
        isfiledownload: vaconfigdata.isfiledownload == 0 ? false : true,
        interfacetype: interfacetype,
        enableAccessionSearch: enableAccessionSearch,
        fileUploadFTP: fileUploadFTP,
        sourcedeploymentkey: this.sourcedeployementkey,
        targetdeploymentkey: this.targetdeployementkey,
        sourceaccounttype: this.sourcetype,
        targetaccounttype: this.targettype,
        seguid: this.selectedsourceaccountid,
        deguid: this.selectedtargetaccountid,
        sourceagent: this.envSourceProxy,
        Uniqueid: this.UniqueID,
        collectsourceagentflag: this.isCollectSourceAgentName()
      };

      const modalRef = this.modalService.open(TryitoutComponent,
        { windowClass: "myCustomModalClasscreate", backdrop: 'static', keyboard: false });
      modalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
      this.trackModalRef(modalRef, "myCustomModalClasscreate");
      modalRef.result.then(() => {
        this.untrackModalRef(modalRef);
      }, (reason) => {
        this.untrackModalRef(modalRef);
      });
      this.ngxUiLoaderService.stop();
    }
    else {

      this.toastr.warning('Pipeline and processor are mandatory', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }

  }
  //Tryitout modal end

  searchSourceNameCleared() {
    this.reqfieldslist = []
    this.DeviceList = []
    this.vbagentlist = []
    this.selecteddevice = ''
    this.selectedvbagentname = '';
    this.selectedvbagentid = '';
    this.connectivitytypemsg = "Select the source entity";
    this.isLoadingSource = false;
    this.SourceAccountList = [];
    this.reactiveFormprojectname.setValue({ "projectname": '' });
    this.projectnamelist = [];
    this.selectedsourceaccountName = '';
    this.selectedsourceaccountid = '';
    this.sourcetypedisplay = '';
    this.sourcetypedisplayid = '';
    this.sourcedpkeydisplay = '';
    this.RouteNameSuggest[1]["value"] = '';
    let myArray = [];
    this.RouteNameSuggest.forEach(element => {
      if (element.value != '') {
        myArray.push(element.value);
      }
    });
    this.reactiveFormroute.patchValue({
      routename: myArray.map(element => element).join(".")
    });
    this.suggestedroutename = this.reactiveFormroute.value.routename;
    this.sourceentityaddress = '';
    this.sourceentityaddress1 = '';
    this.sourceentityaddress2 = '';
    this.sourcecity = '';
    this.sourcestate = '';
    this.sourcezip = '';
    this.notfounddata = false;
    this.sourcedeployementkey = '';
    this.sourceassociatedaccountids = '';
  }
  searchTargetNameCleared() {
    this.reqfieldslist = []
    this.DeviceList = []
    this.vbagentlist = []
    this.selecteddevice = ''
    this.selectedvbagentname = '';
    this.selectedvbagentid = '';
    this.reactiveFormprojectname.setValue({ "projectname": '' });
    this.isLoadingTarget = false;
    this.TargetAccountList = [];
    this.projectnamelist = [];
    this.selectedtargetaccountName = '';
    this.selectedtargetaccountid = '';
    this.targettypedisplay = '';
    this.targettypedisplayid = '';
    this.targetdpkeydisplay = '';
    this.RouteNameSuggest[2]["value"] = '';
    let myArray = [];
    this.RouteNameSuggest.forEach(element => {
      if (element.value != '') {
        myArray.push(element.value);
      }
    });
    this.reactiveFormroute.patchValue({
      routename: myArray.map(element => element).join(".")
    });
    this.suggestedroutename = this.reactiveFormroute.value.routename;
    this.targetentityaddress = '';
    this.targetentityaddress1 = '';
    this.targetentityaddress2 = '';
    this.targetcity = '';
    this.targetstate = '';
    this.targetzip = '';
    this.notfounddata = false;
    this.targetassociatedaccountids = '';
    this.targetdeployementkey = '';
  }

  async searchProcesorNameCleared(arraylist, datarow) {

    if (datarow !== null && datarow.formcontrolname === 'prop') {
      this.projectnamelist = [];
      this.reactiveFormprojectname.setValue({ "projectname": '' });
      this.interfacetype = '';
      this.isshownellkykeys = false;
      this.isLoadingProcesor = false;
      this.selectedprocessdisplayname = '';
      this.searchSourceNameCleared();
      this.searchTargetNameCleared();
      this.selectedprocessagentid = '';
      if (Object.keys(this.modelradio).length != 0) {
        this.modelradio["option"] = '';
      }
      this.VBClientmatcard = false;
      this.RouteNameSuggest[4]["value"] = '';
      this.RouteNameSuggest[5]["value"] = '';
      let myArray = [];
      this.RouteNameSuggest.forEach(element => {
        if (element.value != '') {
          myArray.push(element.value);
        }
      });
      this.reactiveFormroute.patchValue({
        routename: myArray.map(element => element).join(".")
      });
      this.suggestedroutename = this.reactiveFormroute.value.routename;
      this.vendarmsgdiv = false;
      this.ftpcheckexsting = false;
      this.ftpexistingpath = '';
      this.ftpexstingpathdiv = false;
      this.notfounddata = false;
      this.ProcessorList = this.ProcessorAllList;
      await this.searchRouteNameCleared('');
      await this.Resetalldata();
      // await this.setfirstcontrol();
    }
  }

  //vb create job integration

  togglePasswordFieldType() {
    this.show = !this.show;
  }


  copyftp() {

    if (this.modelradio["option"] == 'VB Client') {

      const ftp = 'JobName:' + this.selectedjobName + '\r\n' + 'Path:' + this.vbfolderpathdisplay;

      copyToClipboardtable(ftp)

      this.toastr.success('VB Client Details Copied ', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });

    }
    // Extended: include 'External FTPV2' so the inbound connectivity copy icon copies VA/SFTP details (same as FTPV2).
    else if (this.modelradio["option"] == 'FTP' || this.modelradio["option"] == 'FTP/VPN' || this.modelradio["option"] === 'External FTP' || this.modelradio["option"] === 'FTPV2' || this.modelradio["option"] === 'External FTPV2') {
      let ftp = ''
      if (this.isviewpasswordftp) {
        ftp = 'UserName:' + this.ftpusername + '\r\n' + 'Password:' + this.ftppassword + '\r\n' + 'Server :' + this.ftphost + '\r\n' +
          'Port :' + this.ftpport + '\r\n' + 'Remote site :' + this.remotepathdisplay;
      } else {
        ftp = 'UserName:' + this.ftpusername + '\r\n' + 'Server :' + this.ftphost + '\r\n' +
          'Port :' + this.ftpport + '\r\n' + 'Remote site :' + this.remotepathdisplay;
      }


      copyToClipboardtable(ftp)
      // External FTPV2 uses SFTP credentials; show the same success toast as FTPV2.
      if (this.modelradio["option"] == 'FTPV2' || this.modelradio["option"] === 'External FTPV2') {
        this.toastr.success('SFTP Details Copied ', "", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });
      }
      else {
        this.toastr.success('FTP Details Copied ', "", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });

      }

    }
    else if (this.modelradio["option"] == 'Device' && this.savedjobdetails) {
      const ftp = 'DeviceName:' + this.savedjobdetails['DeviceName'] + '\r\n' + 'DeviceType:' + this.savedjobdetails['DeviceType'] + '\r\n' + 'RemoteIP :' + this.savedjobdetails.ConnectivityInfo.RemoteIP + '\r\n' +
        '\r\n' + 'RemotePort :' + this.savedjobdetails.ConnectivityInfo.RemotePort + '\r\n' + 'JobName :' + this.savedjobdetails['JobName'] + '\r\n' + 'Job Status :' + this.VBJobCurrentStatus;

      copyToClipboardtable(ftp)
      this.toastr.success('Device Integration Job Details Copied ', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
  }
  copyftpoutbount() {
    // Extended: include 'External FTPV2' so the outbound connectivity copy icon copies VA/SFTP details.
    if (this.outboundmodelradio["option"] == 'FTP' || this.outboundmodelradio["option"] == 'FTP/VPN' || this.outboundmodelradio["option"] === 'External FTP' || this.outboundmodelradio["option"] === 'Other' || this.outboundmodelradio["option"] === 'FTPV2' || this.outboundmodelradio["option"] === 'External FTPV2' || this.outboundmodelradio["option"] == 'VPN') {
      let ftp = ''
      if (this.isviewpasswordftp) {
        ftp = 'UserName:' + this.ftpusername + '\r\n' + 'Password:' + this.ftppassword + '\r\n' + 'Server :' + this.ftphost + '\r\n' +
          'Port :' + this.ftpport + '\r\n' + 'Remote site :' + this.remotepathdisplay;
      } else {
        ftp = 'UserName:' + this.ftpusername + '\r\n' + 'Server :' + this.ftphost + '\r\n' +
          'Port :' + this.ftpport + '\r\n' + 'Remote site :' + this.remotepathdisplay;
      }

      copyToClipboardtable(ftp)
      if (this.FTPV2Flag) {
        this.toastr.success('SFTP Details Copied ', "", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });
      }
      else {
        this.toastr.success('FTP Details Copied ', "", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });

      }

    }
  }
  externalcopyftpoutbount() {
    // Extended: include 'External FTPV2' so the External FTPV2 card copy icon copies customftp details.
    // ADDED: also allow inbound External FTP / External FTPV2 card header copy (same customftp payload).
    if (this.outboundmodelradio["option"] == 'External FTP' || this.outboundmodelradio["option"] === 'External FTPV2'
      || this.modelradio["option"] == 'External FTP' || this.modelradio["option"] === 'External FTPV2') {
      let ftp = ''
      if (this.isviewpasswordexftp) {
        ftp = 'UserName:' + this.customftp.username + '\r\n' + 'Password:' + this.customftp.password + '\r\n' + 'Server :' + this.customftp.host + '\r\n' +
          'Port :' + this.customftp.port + '\r\n' + 'Remote site :' + this.customftp.folder;
      } else {
        ftp = 'UserName:' + this.customftp.username + '\r\n' + 'Server :' + this.customftp.host + '\r\n' +
          'Port :' + this.customftp.port + '\r\n' + 'Remote site :' + this.customftp.folder;
      }

      copyToClipboardtable(ftp)
      if (this.FTPV2Flag) {
        this.toastr.success('SFTP Details Copied ', "", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });
      }
      else {
        this.toastr.success('FTP Details Copied ', "", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });

      }

    }
  }
  copyvpn(direction: string) {
    if (direction == 'In') {
      const vpn = 'IP:' + this.modelvpn.ip + '\r\n' + 'Port:' + this.modelvpn.port + '\r\n' ;

      copyToClipboardtable(vpn)
      this.toastr.success('VPN Details Copied ', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
    else {
      const vpn = 'IP:' + this.ipvpnout + '\r\n' + 'Port:' + this.portvpnout + '\r\n'  +
        'Source Path :' + this.sourcepathvpnout + '\r\n' + 'Destination Path:' + this.archivepathvpnout + '\r\n' +
        'Customer\'s Path:' + this.vpncustomerpath;

      copyToClipboardtable(vpn)
      this.toastr.success('VPN Details Copied ', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
  }
  copyagent() {
    const agent = 'Source agent:' + this.selectedsourceagentdisplayname + '\r\n' + 'Target agent:' + this.selectedtargetagentdisplayname + '\r\n' + 'Messagetype :' + this.selectedmessagetype + '\r\n' +
      'Route policy :' + this.routepolicyselected;

    copyToClipboardtable(agent)
    this.toastr.success('Agent Details Copied ', "", {
      timeOut: 500,
      positionClass: 'toast-bottom-right'
    });
  }

  masterToggle() {
    if (this.myFlagftpchecks) {
      this.isDisabled = false;
      this.myFlagftpchecks = false;
    }
    else {
      this.isDisabled = true;
      this.myFlagftpchecks = true;
    }
  }
  connectivitytypemsg: string = '';
  VBClientmatcard: boolean = false;
  rbtn: string = ''
  async selecteedvbtype(rdbvalue) {
    this.rbtn = rdbvalue
    this.reactiveFormagent.reset();
    if (rdbvalue == 'Device' && (this.selecteddevice != '' || this.selecteddevice != undefined)) {
      this.getDevicelistbyentity();
    }
    if (rdbvalue == 'Device' && (this.selectedtargetaccountid != '' && this.selectedtargetaccountid != undefined)) {
      let returndvalue = await this.Getvbagentsdetails();
    }

    if (rdbvalue != 'FTP' || rdbvalue != 'External FTP' || rdbvalue != 'External FTPV2' || rdbvalue != 'FTPV2') {
      this.isftp = false
    }
    this.modelradio = { option: rdbvalue };
    if (this.selectedsourceaccountid == '') {
      this.array_disableradiobuttons.push("disable");
      this.connectivitytypemsg = "Select the source entity";
      this.isdevicename();
    }
    else {
      this.array_disableradiobuttons = [];
      if (rdbvalue == 'Project') {
        this.getprojectname();
      }
      if (rdbvalue == 'VB Client') {
        this.ngxUiLoaderService.start();
        this.VBClientmatcard = true;
        this.modelvbclient.vbclientagnetid = 'select';
        this.modelvbclient.vbclientpath = '';
        await this.getvbagentslist();
        this.ngxUiLoaderService.stop();
      }
      else {
        this.VBClientmatcard = false;
      }
      this.connectivitytypemsg = '';
    }
  }

  async selectedoutboundtype(rdbvalue) {
    this.outboundmodelradio = { option: rdbvalue };
    this.ftpexistingpath = '';
    this.ipvpnout = '';
    this.portvpnout = '';
    this.vpncustomerpath='';
    this.customftp = <CustomFTPDetails>{
      username: '',
      password: '',
      host: '',
      port: '',
      folder: '',
      id: '',
      archivepath: ''
    }
    if (this.selectedsourceaccountid && this.vendorid && this.outboundmodelradio['option'] == 'Project') {
      this.getprojectname();
    }
  }

  selectftp(value: boolean) {
    this.isftp = value;
  }

  /**
   * Saved pipeline (UniqueID &gt; 0): show only the connectivity type that was selected; hide other radios.
   * New / unsaved pipeline: show the full list so the user can choose.
   */
  get showOnlySelectedConnectivity(): boolean {
    const id = this.UniqueID;
    if (id === '' || id === null || id === undefined) {
      return false;
    }
    const n = Number(id);
    return !isNaN(n) && n > 0;
  }

  private mapConnectivityOptionToLabel(
    rawOption: string | undefined,
    side: 'source' | 'outbound'
  ): string {
    const m = (rawOption || '').trim();
    switch (m) {
      case 'FTP':
        return 'VA-FTP';
      case 'Other':
        return 'VA-FTP Existing Path';
      case 'External FTP':
        return 'External FTP';
      // Explicit label for External FTPV2 so saved pipelines show the correct sub-option (not External FTP) in the read-only connectivity summary.
      case 'External FTPV2':
        return 'External FTPV2';
      case 'Project':
        return side === 'source' ? 'Import FTP' : 'Import Project';
      case 'FTPV2':
        return side === 'source' ? 'FTPV2' : 'VA-FTPV2';
      default:
        return m || '—';
    }
  }

  getSelectedConnectivityLabel(side: 'source' | 'outbound'): string {
    const value =
      side === 'source' ? this.modelradio?.option : this.outboundmodelradio?.option;
    return this.mapConnectivityOptionToLabel(value, side);
  }

  async getJobName(jobname) {

    const PostFormData = {
      jobname: jobname,
      agentid: this.envSourceProxy,

      SourceEntity: this.selectedsourceaccountid,
      DestinationEntity: this.selectedtargetaccountid,
      MessageType: this.messagetype,
    }
    return await this.service.postapi("api/VBJobs/GetVbFileJob", PostFormData);
  }


  vbagentsdropdown: any = [];
  async getvbagentslist() {
    if (this.selectedsourceaccountid == '') {
      this.toastr.warning('Please select the source entity and search vb agents ', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    else {
      var apiname = 'api/VBJobs/GetVbAgnetsList?sourceentity=' + this.selectedsourceaccountid;
      var vbagnets = await this.service.getapi(apiname);
      if (vbagnets['status'] && vbagnets['statustext']) {
        this.toastr.error('Failed in the get vb agents', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      } else {
        if (vbagnets.status == "Success") {
          const results = JSON.parse(vbagnets.responsebody);
          results.forEach(element => {
            this.vbagentsdropdown.push({ displayname: element.DisplayName, VBAgentID: element.VBAgentID })
          });
          this.vbagentsdropdown.map(obj => { obj.displayname = `${obj.displayname} ${'(' + obj.VBAgentID + ')'}` });
          if (this.vbagentsdropdown.length == 1) {
            this.modelvbclient.vbclientagnetid = this.vbagentsdropdown[0].VBAgentID;
            this.reactiveFormvbagent.patchValue({
              vbagentnameauto: this.vbagentsdropdown[0].displayname
            })
          }
        }
      }
    }
  }

  onItemSelect(item: any) {
    this.selectedextensionItems = this.selectedItems;
  }

  onSelectAll(items: any) {
    this.selectedextensionItems = items;
  }

  //route Notes Popup

  openNotepopup() {

    if (this.selectedrouteId != '') {
      const noteDataToModal = {
        routeid: this.UniqueID,
        routename: this.selectedrouteDisplayName,
        userid: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
      };


      const modalRef = this.modalService.open(RouteNotesComponent,
        { windowClass: "myCustomModalClasscreate", backdrop: 'static', keyboard: false });
      modalRef.componentInstance.inputDataInModalComponent = noteDataToModal;
      this.trackModalRef(modalRef, "myCustomModalClasscreate");
      modalRef.result.then(() => {
        this.untrackModalRef(modalRef);
      }, (reason) => {
        this.untrackModalRef(modalRef);
      });
    }

  }

  //Audit Details Pop up

  openAuditPopUp() {

    if (this.selectedrouteId != '') {
      const auditDataToModal = {
        id: this.UniqueID,
        title: this.selectedrouteDisplayName,
        context: "Pipeline",
        type: "ID",
        guid: this.selectedrouteId,
        routename: this.selectedrouteDisplayName,
        userid: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
      };
      const modalRef = this.modalService.open(NewauditComponent,
        // was: windowClass: "myCustomModalClasscreate" — 60% height clipped Close with audit-toolbar
        { windowClass: "myCustomModalClasscreateaudit", backdrop: 'static', keyboard: false });
      modalRef.componentInstance.inputDataInModalComponent = auditDataToModal;
      this.trackModalRef(modalRef, "myCustomModalClasscreateaudit");
      modalRef.result.then(() => {
        this.untrackModalRef(modalRef);
      }, (reason) => {
        this.untrackModalRef(modalRef);
      });
    }

  }
  async getvendarsName(event) {
    var vendarvalue = event;
    this.vendarnamevalue = '';
    if (vendarvalue != '') {
      this.isLoadingvendar = false;
      if (this.VendarsList.length > 0) {
        this.filtervendorlist(vendarvalue);
      }
      else {
        this.VendarsList = this.VendornameBackuplist;
        this.filtervendorlist(vendarvalue);
      }
    }
  }

  searchvendarNameCleared(event) {
    this.reactiveFormprojectname.setValue({ "projectname": '' });
    this.isLoadingvendar = false;
    this.projectnamelist = [];
    this.vendarnamevalue = "";
    this.vendorid = "";
    this.VendarsList = this.VendornameBackuplist;
    this.reactiveFormvendar.setValue({ "namevendar": '', "vendorid": '' });
    this.RouteNameSuggest[3]["value"] = '';
    let myArray = [];
    this.RouteNameSuggest.forEach(element => {
      if (element.value != '') {
        myArray.push(element.value);
      }
    });
    this.reactiveFormroute.patchValue({
      routename: myArray.map(element => element).join(".")
    });
    this.suggestedroutename = this.reactiveFormroute.value.routename;
  }
  async selectedvendarEvent(event) {
    this.vendarnamevalue = event.name;
    this.vendorid = event.Id;
    if (this.interfacetype == 'Inbound' && this.selectedtargetaccountid && this.modelradio['option'] == 'Project') {
      this.getprojectname();
    }
    else if (this.interfacetype == 'Outbound' && this.selectedsourceaccountid && this.outboundmodelradio['option'] == 'Project') {
      this.getprojectname();
    }
    this.RouteNameSuggest[3]["value"] = (event.mnemonic == null || event.mnemonic == '') ? event.name : event.mnemonic;
    this.vendormnemonic = (event.mnemonic == null || event.mnemonic == '') ? event.name : event.mnemonic;
    let myArray = [];
    this.RouteNameSuggest.forEach(element => {
      if (element.value != '') {
        myArray.push(element.value);
      }
    });

    this.reactiveFormroute.patchValue({
      routename: myArray.map(element => element).join(".")
    });
    this.suggestedroutename = this.reactiveFormroute.value.routename;
    // select connectivity based on the vendor mapping
    let vendorObj = {
      name: this.vendarnamevalue,
    }
    this.ngxUiLoaderService.start();
    if (this.ProcessorType == 'None') {
      this.ngxUiLoaderService.stop();
      this.outboundmodelradio.option = 'None';
      this.modelradio.option = 'None';
    }
    else {
      await this.service.postapi("api/Routes/GetLastRouteConnectivityByVendor", vendorObj).then(Response => {
        if (Response) {
          if ((Response['status'] && Response['statusText']) || Response['statusText'] === "Unknown Error") {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          else {
            this.ngxUiLoaderService.stop();
            let response = Response as any;
            if (response['status'] == 'success' && (this.UniqueID === '' || this.UniqueID === 0 || this.UniqueID == null)) {
              // Map legacy FTP connectivity from vendor last-route to FTPV2 radio selection
              let connectivity = (response['responsebody'] || '').toString().trim();
              const connectivityLower = connectivity.toLowerCase();
              if (connectivityLower === 'ftp') {
                connectivity = 'FTPV2';
              } else if (connectivityLower === 'external ftp') {
                connectivity = 'External FTPV2';
              }
              
              //this.FTPV2Flag = connectivity === 'FTPV2' || connectivity === 'External FTPV2';
              // Native [checked] radios do not update from .option mutation alone.
              // Clear first, then re-select via the same handlers used by click so the UI rebinds.
              if (this.interfacetype == "EllkayInbound" || this.interfacetype == "Inbound") {
                this.modelradio = { option: '' };
                setTimeout(() => this.selecteedvbtype(connectivity), 0);
              }
              if (this.interfacetype == "EllkayOutbound" || this.interfacetype == "Outbound") {
                this.outboundmodelradio = { option: '' };
                setTimeout(() => this.selectedoutboundtype(connectivity), 0);
              }
            }
          }
        }
        else {
          this.ngxUiLoaderService.stop();
        }
      }, error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
      })
    }
  }

  clearftppath() {
    this.ftpexistingpath = '';
    this.resultsftpchecknone = false;
    this.apiconnectivity = false;
    this.vpncheck = false;
  }


  clearftpnonepath() {
    this.ftpexistingpath = '';
    this.ftpcheckexsting = false;
    this.apiconnectivity = false;
    this.vpncheck = false;
  }
  clearapiconnectivity() {
    this.ftpexistingpath = '';
    this.ftpcheckexsting = false;
    this.resultsftpchecknone = false;
    this.vpncheck = false;
  }
  clearvpn() {
    this.ftpcheckexsting = false;
    this.resultsftpchecknone = false;
    this.apiconnectivity = false;
  }

  interfacemappingcheck(event) {
    this.copyinterfacemappings = event.checked;
  }
  //copy pipeline enhance

  async copypipelineevent() {

    this.oldselectedrouteId = this.selectedrouteId;
    this.oldselectedprocessapikey = this.selectedprocessapikey;
    this.oldselectedprocessagentid = this.selectedprocessagentid;
    this.oldselectedprocessdisplayname = this.selectedprocessdisplayname;
    this.oldselectedrouteDisplayName = this.selectedrouteDisplayName;
    this.oldmodeSelected = this.modeSelected;
    this.oldUniqueID = this.UniqueID;
    this.olddynamicJSON = this.dynamicJSON;
    this.oldmyFlagForSlideToggle = this.myFlagForSlideToggle;
    this.oldvendarnamevalue = this.vendarnamevalue;
    this.oldvendorid = this.vendorid;
    await this.Resetalldata();
    var dataitem = {
      apikey: this.oldselectedprocessapikey,
      id: this.oldselectedprocessagentid,
      displayname: this.oldselectedprocessdisplayname,
      processortype: this.ProcessorType
    }

    await this.selectedProcessEvent(dataitem, this.olddynamicJSON[0], '');
    this.oneditftpradio = false
    this.selectedprocessapikey = this.oldselectedprocessapikey;
    this.selectedprocessagentid = this.oldselectedprocessagentid;
    this.selectedprocessdisplayname = this.oldselectedprocessdisplayname;
    this.selectedrouteDisplayName = this.oldselectedrouteDisplayName;
    this.modeSelected = this.oldmodeSelected;
    this.reactiveFormmode.patchValue({
      modename: this.modeSelected
    });
    this.UniqueID = this.oldUniqueID;
    this.dynamicJSON = this.olddynamicJSON;
    this.myFlagForSlideToggle = false;
    this.vendarnamevalue = this.oldvendarnamevalue;
    this.vendorid = this.oldvendorid;
    if (this.vendarmsgdiv) {
      this.reactiveFormvendar.patchValue({
        namevendar: this.vendarnamevalue,
        vendorid: this.vendorid
      })
    }
    this.resetflag = true;
    this.copypipelineflag = true;
  }

  clearvaluesforcopyroute() {
    this.searchSourceNameCleared();
    this.searchTargetNameCleared();
    this.reactiveFormsource.reset();
    this.reactiveFormtarget.reset();

  }
  async ResetPipelineDetails() {
    this.copypipelineflag = false;
    this.oldselectedrouteDisplayName = '';
    this.resetflag = false;
    this.copypiprlinrbutton = true;
    this.selectedrouteId = this.oldselectedrouteId;
    await this.getRouteDetails();
  }

  //va rule and handler

  /** Used by create template labels; special VA-Rules open uses lookup Mode. */
  isFaxVaRulesUi(): boolean {
    return (this.messagetype || '').toLowerCase() === 'fax';
  }

  isBatchFaxInterface(): boolean {
    return [
      this.selectedrouteDisplayName,
      this.selectedsourceagentname,
      this.selectedsourceagentdisplayname
    ].some((value) =>
      String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '').includes('batchfax')
    );
  }

 async openvarulepopup() {
    var dpkeyname = '';
    if (this.isOutboundPipelineForCreate()) {
      dpkeyname = this.sourceAgentDeploymentKey; 
      
    }
    else {
      dpkeyname = this.targetAgentDeploymentKey;
    }

    let dataToruleModal = {
      routename: this.selectedrouteDisplayName,
      groupid: this.selectedrouteId,
      islocked: this.isLocked,
      deploymentkey: dpkeyname,
      contextid: this.UniqueID
    };
    if (this.sourcetypedisplay == 'O') {
      dataToruleModal["LabOrgId"] = this.selectedsourceaccountid;
    }
    else if (this.sourcetypedisplay == 'A') {
      dataToruleModal["LabId"] = this.selectedsourceaccountid;
    }

    if (this.targettypedisplay == 'O') {
      dataToruleModal["OrdFacOrgId"] = this.selectedtargetaccountid;
    }
    else if (this.targettypedisplay == 'A') {
      dataToruleModal["OrdFacilityId"] = this.selectedtargetaccountid;
    }
    else if (this.targettypedisplay == 'F') {
      dataToruleModal["OrdFacilityId"] = this.selectedtargetaccountid;
    }

    const vaRuleFetchMode = await this.service.resolveVaRuleFetchMode(this.messagetype);
    const openVaRulesByMode = vaRuleFetchMode != null;

    if (openVaRulesByMode) {
      dataToruleModal["Mode"] = vaRuleFetchMode;
    }
    const modalRef = this.modalService.open(
      openVaRulesByMode ? FaxVarulesComponent : VarulesComponent,
      {
        windowClass: openVaRulesByMode ? 'myCustomModalClassfaxvarule' : 'myCustomModalClasscreatevarule',
        backdrop: 'static',
        keyboard: false
      });
    modalRef.componentInstance.inputDataInModalComponent = dataToruleModal;
    this.trackModalRef(modalRef, openVaRulesByMode ? 'myCustomModalClassfaxvarule' : 'myCustomModalClasscreatevarule');
    
    modalRef.result.then(() => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
    });
  }


  openFTPfilespopup() {
    const dataToFTPFilesModal = {
      routeId: this.selectedrouteId,
      sourceagent: this.envSourceProxy,
      name: this.selectRouteNameBackup,
      uniqid: this.UniqueID,
      selectflag: false,
      connectivitytype: this.connectivitytype
    };
    const modalRef = this.modalService.open(FtpfilesComponent,
      { windowClass: "myCustomModalClassFTPcreate", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.inputDataInModalComponent = dataToFTPFilesModal;
    this.trackModalRef(modalRef, "myCustomModalClassFTPcreate");
    modalRef.result.then(() => {
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.untrackModalRef(modalRef);
    });
  }


  getCustomeWidth() {
    if (this.isShown) {
      return 68;
    }
    else {
      return 80;
    }
  }
  buildpiplinetitle(name, id) {
    if (name !== undefined && name != '') {
      if (name.includes("(")) {
        return name
      } else {
        let fullname = name + '(' + id + ')';
        if (id) {
          return fullname;
        }
        else {
          return
        }
      }
    }

  }
  buildtitle(Obj: any, deployment: any) {
    if (typeof (Obj) == "object" && Obj != null) {
      let name = `(${Obj.Type}) : ${Obj.deploymentkey} : ${Obj.LocationName}
      ${Obj.Address1}
      `
      return name;
    }

    else if (typeof (Obj) == "string" && Obj != null) {
      switch (deployment) {
        case 'source':
          if (this.selectedsourceaccountName) {
            let sename = `(${this.sourcetype == 'Account' ? 'A' : this.sourcetype == 'Organization' ? 'O' : this.sourcetype}) : ${this.sourcedeployementkey} : ${this.selectedsourceaccountName}(${this.selectedsourceaccountid})
          ${this.sourceentityaddress1}
          `
            return sename;
          }
          break;
        case 'target':
          if (this.selectedtargetaccountName) {
            let dename = `(${this.targettype == 'Account' ? 'A' : this.targettype == 'Organization' ? 'O' : this.targettype}) : ${this.targetdeployementkey} : ${this.selectedtargetaccountName}(${this.selectedtargetaccountid})
        ${this.targetentityaddress1}
        `
            return dename;
          }

          break;
      }
    }
  }
  async getFileConfig(routeid: string, ProcessorId: string) {
    return await firstValueFrom(this.service.getapiurl("api/CoreConfig/GetCoreConfigVersion?routeid=" + routeid + "&agentid=" + ProcessorId + "&version="));

  }
  buildProcessorTitle(Obj: any) {
    if (typeof (Obj) == "string" && Obj != null) {
      if (Obj.includes("(")) {
        return Obj
      } else {
        return Obj + "(" + this.selectedprocessagentid + ")"
      }
    }
  }


  //////////multi processor
  getstringpipleline(value) {
    let names = value.split("(")
    value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
    return value
  }
  getstringRoute(value) {
    let names = value.split("(")
    value = `${names[0]} <br>(${names[1]}`
    return value
  }
  locationString(item, item1, item2) {
    let names = item2.split("(")
    item2 = names[2] !== 'null)' && names[2] !== undefined ? `${names[0]} <br> (${names[1]} <br> (${names[2]}` : `${names[0]} <br> (${names[1]}`
    return '(' + item + ')' + ' ' + item1 + ' : ' + item2
  }
  addcontrols(obj: inputField[]) {
    if (this.dynamicJSON.length == 1) {
      this.dynamicJSON[0].data = this.ProcessorAllList;
    }
    let controlname = "prop" + (this.dynamicJSON[this.dynamicJSON.length - 1].sequence + 1);
    let reactiveFormprocess: FormGroup = this._fb.group({ ["prop" + (this.dynamicJSON[this.dynamicJSON.length - 1].sequence + 1)]: '' });
    let inputcnt: inputField = {
      data: this.ProcessorAllList,
      formcontrolname: controlname,
      formgroupname: reactiveFormprocess,
      sequence: this.dynamicJSON.length + 1,
      mapicon: false,
      islive: false
    }
    this.dynamicJSON.push(inputcnt);
    if (!this.dynamicJSON[this.dynamicJSON.length - 1].islive) {
      this.routeconfigflag = true;
      this.myFlagForSlideToggle = false;
    }
  }

  async InitilizeProcessordata() {
    var apiname = "api/Agents/GetByDisplayName?name=" + '&agentid=0&type=Processor&filterflag=false';
    let resultset = await this.service.getapi(apiname);
    resultset.map(obj => { obj.name = obj.displayname, obj.displayname = `${obj.displayname} ${'(' + obj.id + ')'}` });
    this.ProcessorAllList = resultset;
    this.setfirstcontrol()
    return resultset;
  }

  deleteControl(array, i) {
    array.splice(i, 1);
    this.dynamicJSON = [];
    array.forEach(element => {
      let controlname = '';
      let reactiveFormprocess: FormGroup;
      if (this.dynamicJSON.length == 0) {
        controlname = "prop";
        reactiveFormprocess = this._fb.group({ ["prop"]: element.formgroupname.controls[element.formcontrolname].value });
      }
      else {
        controlname = "prop" + (this.dynamicJSON[this.dynamicJSON.length - 1].sequence + 1);

        reactiveFormprocess = this._fb.group({ ["prop" + (this.dynamicJSON[this.dynamicJSON.length - 1].sequence + 1)]: element.formgroupname.controls[element.formcontrolname].value });
      }
      let inputcnt: inputField = {
        data: this.ProcessorAllList,
        formcontrolname: controlname,
        formgroupname: reactiveFormprocess,
        sequence: this.dynamicJSON.length + 1,
        mapicon: element.mapicon,
        islive: element.islive
      }
      this.dynamicJSON.push(inputcnt);
    });
    let exists = this.dynamicJSON.filter(ele => ele.islive === false);
    if (exists.length == 0) {
      this.routeconfigflag = false;
    }
    else {
      this.routeconfigflag = true;
      this.myFlagForSlideToggle = false;
    }
  }

  async setfirstcontrol() {
    this.dynamicJSON = [];
    if (this.dynamicJSON.length == 0) {
      let reactiveFormprocess: FormGroup = this._fb.group({ "prop": '' });
      let inputcnt: inputField = {
        data: this.ProcessorAllList,
        formcontrolname: "prop",
        formgroupname: reactiveFormprocess,
        sequence: 1,
        mapicon: false,
        islive: false
      }

      this.dynamicJSON.push(inputcnt);
    }
  }
  getcoreconfigforroute() {
    this.ngxUiLoaderService.start();
    var dataPost = {
      guids: this.selectedrouteId,
      filtertype: 'Pipeline'
    };
    // this.ngxUiLoaderService.start();
    this.service.postapi("api/CoreConfig/GetCoreConfigKeys", dataPost).then(Response => {
      if (Response) {
        if ((Response['status'] && Response['statusText']) || Response['statusText'] === "Unknown Error") {
          this.ngxUiLoaderService.stop();
          this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
        }
        else {
          this.RouteConfigList = Response as any[];
          this.RouteConfigBackUpList = this.RouteConfigList;
          if (this.RouteConfigList.length > 0) {
            this.filteragentlist = [];
            this.filteragentlistbackup = [];
            this.RouteConfigList.forEach(ele => {
              ele['isLocked'] = this.isLocked;
            });
              this.RouteConfigList.forEach(ele => {
                let obj = {
                  name: ele.agentdisplayname,
                  displayname: `${ele.agentdisplayname}(${ele.agentid})`,
                  id: ele.agentid,
                };
              this.filteragentlist.push(obj);
            });
            this.filteragentlist = [...new Map(this.filteragentlist.map(item =>
              [item["id"], item])).values()];
            this.filteragentlistbackup = this.filteragentlist;
            this.reactiveFormAgentFilter.setValue({ "filteragent": "" });
            //this.editconfigjson(this.RouteConfigList[0], this.RouteConfigList)
            this.ngxUiLoaderService.stop();
          }
          // this.ngxUiLoaderService.stop();
        }
      }
    }, error => {
      this.ngxUiLoaderService.stop();
      this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
    });
  }
  registerMonacoCustomTheme() {
    monaco.editor.defineTheme("myCustomTheme", {
      base: "vs", // can also be vs or hc-black
      inherit: true, // can also be false to completely replace the builtin rules
      rules: [
        {
          token: "comment",
          foreground: "ffa500",
          fontStyle: "italic underline"
        }, {
          token: "comment.js",
          foreground: "008800",
          fontStyle: "bold"
        }, {
          token: "comment.css",
          foreground: "0000ff"
        }, // will inherit fontStyle from `comment` above
      ],
      colors: {}
    });
  }
   /** On key click: mark active and fetch config value using existing GetCoreConfig endpoint. */
  editconfigjson(data, array) {
    array.forEach(ele => {
      ele["active"] = false;
    });
    data["active"] = true;
    // this.configjson = data.json;
    // if (data.json != "{}" && data.json != '') {
    //   data["active"] = true;
    //   this.configjson = JSON.stringify(JSON.parse(data.json), null, 2);
    // }
    this.configid = data.configid;
    this.configagentid = data.agentid;
    this.configguids = data.guids;
    this.configagentapikey = data.agentapikey;
    this.configstatus = data.status;
    this.configjson = '';
    if (!data.agentid) {
      return;
    }
    this.ngxUiLoaderService.start();
    var dataPost = {
      guids: this.selectedrouteId,
      agentid: data.agentid,
      filtertype: 'Pipeline',
      configid:data.configid
    };
    this.service.postapi("api/CoreConfig/GetCoreConfig", dataPost).then(Response => {
      if (Response && Array.isArray(Response) && Response.length > 0) {
        const match = Response.find((c: any) => c.configid === data.configid) || Response[0];
        const jsonVal = match.json;
        if (jsonVal && jsonVal !== '{}' && jsonVal !== '') {
          try {
            this.configjson = JSON.stringify(JSON.parse(jsonVal), null, 2);
          } catch {
            this.configjson = jsonVal;
          }
        } else {
          this.configjson = jsonVal || '{}';
        }
      }
      this.ngxUiLoaderService.stop();
    }, () => {
      this.ngxUiLoaderService.stop();
      this.configjson = '{}';
    });
  }
  configdetails() {
    this.enableconfig = true;
    this.ngxUiLoaderService.start();
    this.getcoreconfigforroute();
    // this.ngxUiLoaderService.stop();
  }
  clearconfigdetails() {
    this.enableconfig = false;
    this.RouteConfigList = [];
    this.filteragentlist = [];
    this.filteragentlistbackup = [];
    this.RouteConfigBackUpList = [];
    this.configid = "";
    this.configjson = "";
    this.configagentid = "";
    this.configguids = '';
    this.configstatus = '';
  }
  getSourceAgentName(event: any) {
    var val = event;
    if (val) {
      this.isLoadingagent = true;

      var apiname = "api/Agents/GetByDisplayName?name=" + val + '&agentid=0&type=agent&filterflag=true';
      this.service.getapiurl(apiname).subscribe({
        next: data => {
          this.SourceAgentNameList = data as any[];
          this.SourceAgentNameList.map(obj => obj.displayname = `${obj.displayname} ${'('} ${obj.id} ${')'}`);
          this.isLoadingagent = false;
          if (data.length == 0) {
            this.notfounddata = true;
          }
          else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingagent = false;
          this.notfounddata = true;
        }
      });
    }
  }
  getTargetAgentName(event: any) {
    var val = event;
    if (val) {
      this.isLoadingTargetagent = true;

      var apiname = "api/Agents/GetByDisplayName?name=" + val + '&agentid=0&type=agent&filterflag=true';
      this.service.getapiurl(apiname).subscribe({
        next: data => {
          this.TargetAgentNameList = data as any[];
          this.TargetAgentNameList.map(obj => obj.displayname = `${obj.displayname} ${'('} ${obj.id} ${')'}`);
          this.isLoadingTargetagent = false;
          if (data.length == 0) {
            this.notfounddata = true;
          }
          else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingTargetagent = false;
          this.notfounddata = true;
        }
      });
    }
  }

  GetMessageTypes(event) {
this.ngxUiLoaderService.stop();
    if (event !== 'msgtype') {
      this.isLoadingstage = true;
      if (event == undefined) {
        this.messageTypeList = this.messageTypeAllList;
      }
      else {
        if (this.messageTypeList.length == 0) {
          this.messageTypeList = this.messageTypeAllList;
        }
        this.messageTypeList = this.messageTypeList.filter(t => t.displayname.toLowerCase().includes(event.toLowerCase()));
      }
      if (this.messageTypeList.length == 0) {
        this.notfounddata = true;
      } else {
        this.notfounddata = false;
      }
      this.isLoadingstage = false;
    }
    else {
      this.isLoadingstage = true;
      this.ngxUiLoaderService.stop();
      this.service.getapiurl("api/Lookup/GetMessageType?lookuptype=messagetype").subscribe({
        next: data => {
          data.forEach(element => {
            this.messageTypeAllList.push({ displayname: element });
          });
          this.messageTypeList = this.messageTypeAllList;

          this.isLoadingstage = false;
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingstage = false;
          this.notfounddata = true;
        }
      });
    }
  }
  selectedsourceagent(item) {
    this.selectedsourceagentid = item.id;
    this.selectedsourceapikey = item.apikey;
    this.sourceAgentDeploymentKey = item.Deployment || '';
  }
  selectedsourceagentcleared() {
    this.isLoadingTargetagent = false;
    this.SourceAgentNameList = [];
    this.selectedsourceagentid = '';
    this.selectedsourceapikey = '';
    this.sourceAgentDeploymentKey = '';
  }

  selectedtargetagent(item) {
    this.selectedtargetagentid = item.id;
    this.selectedtargetapikey = item.apikey;
    this.targetAgentDeploymentKey = item.Deployment || '';
  }
  selectedtargetagentcleared() {
    this.isLoadingagent = false;
    this.TargetAgentNameList = [];
    this.selectedsourceagentid = '';
    this.selectedsourceapikey = '';
    this.targetAgentDeploymentKey = '';
  }


  async MatchingVBJobs(JobType) {
    let obj={
      routename: this.selectedrouteDisplayName,
      JobType: JobType,
      data: JobType == 'Device' ? this.savedjobdetails : this.vbjobsdata,
    }
    const modalRef = this.modalService.open(VbjobsdisplayComponent,
      { windowClass: "myCustomModalClassVBcreate", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.inputDataInModalComponent = obj;
    this.trackModalRef(modalRef, "myCustomModalClassVBcreate");
    modalRef.result.then(() => {
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.untrackModalRef(modalRef);
    });
  }
  getVendorname() {
    this.ngxUiLoaderService.start();
    var url = "api/Vendor/GetVendorName";
    this.service.getapiurl(url).subscribe(data => {
      if (data) {
        this.VendarsList = data as any[];
        this.VendarsList = this.service.transformAlphabetically(this.VendarsList, 'name');
        this.VendornameBackuplist = this.VendarsList;
        this.ngxUiLoaderService.stop();
        this.reactiveFormvendar.setValue({ "namevendar": '', "vendorid": '' });
      }
      else {
        this.ngxUiLoaderService.stop();
      }
    })
  }
  filtervendorlist(event) {
    this.VendarsList = this.VendarsList.filter(t => t.name.toLowerCase().includes(event.toLowerCase()));
    if (this.VendarsList.length == 0) {
      this.notfounddata = true;

    } else {
      this.notfounddata = false;
    }
    this.isLoadingvendar = false;
  }
  openvendorpopup() {
    let obj = {
      data: '',
      vendornamelist: this.VendornameBackuplist,
      component: 'createpipeline',
      Type: "Add",
      vendorname: this.reactiveFormvendar.get('namevendar').value
    }

    const modalRef = this.modalService.open(SavevendorComponent,
      { windowClass: "saveVendormodalcreate", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.inputDataInModalComponent = obj;
    this.trackModalRef(modalRef, "saveVendormodalcreate");
    modalRef.result.then((data) => {
      this.untrackModalRef(modalRef);
      if (data.dataflag) {
        this.getVendorname();
        this.reactiveFormvendar.patchValue({
          namevendar: data.vendorname
        });
        this.vendarnamevalue = data.vendorname;
      }
    }, (reason) => {
      this.untrackModalRef(modalRef);
    });
  }



  selectmodeEvent(item) {
    this.modeSelected = item.name;
  }
  onFocusedmode(event) {
    this.reactiveFormmode.setValue({ "modename": '' });
    this.modeItemsList = [
      {
        id: 'Hold',
        name: 'Hold',
      },
      {
        id: 'Live',
        name: 'Live',
      },
      {
        id: 'Test Live',
        name: 'Test Live',
      }
    ];
    this.reactiveFormmode.patchValue(this.modeItemsList);
  }

  clearedmode(event) {
    this.modeSelected='';
    this.reactiveFormmode.reset();
    this.reactiveFormmode.setValue({ "modename": '' });
    this.modeItemsList = [
      {
        id: 'Live',
        name: 'Live',
      },
      {
        id: 'Test Live',
        name: 'Test Live',
      },
      {
        id: 'Hold',
        name: 'Hold',
      }
    ];
    this.reactiveFormmode.patchValue(this.modeItemsList);
  }

  selectedvbagentevent(item) {
    this.modelvbclient.vbclientagnetid = item.VBAgentID
  }
  Clearevbagent(event) {

  }
  getvbagentlist(event) {

  }
  openconfigpopup(isflag: string, type: string, item) {
    this.ngxUiLoaderService.start();
    if (isflag == "small") {
      let data = {};
      if (type == "create") {
        data = {
          pipelineid: this.selectedrouteId,
          pipelinedisplayname: this.selectedrouteDisplayName,
          editjson: "small",
          type: "create",
          configlist: this.RouteConfigBackUpList,
          disablepipeline: true,
          pipelineuniqueid: this.UniqueID,
          sourceagent:this.envSourceProxy,
          targetagent:this.envTarget,
        }
      }
      else {
        data["configid"] = item.configid;
        data["agentid"] = item.agentid;
        data["json"] = (item.configid === this.configid) ? this.configjson : (item.json || '');
        if (item["guids"]) {
          data["pipelineid"] = item.guids;
        }
        else {
          data["guids"] = '';
        }
        data["agentdisplayname"] = item.agentdisplayname;
        data["pipelinedisplayname"] = item.pipelinedisplayname;
        data["editjson"] = "small";
        data["type"] = "Edit";
        data["disablepipeline"] = true;
        data["status"] = item.status;
        data["pipelineuniqueid"] = this.UniqueID;
        data["agentapikey"] = item.agentapikey
      }
      this.modalService.dismissAll()
      const modalRef = this.modalService.open(ConfigComponent,
        { windowClass: "modalConfigcreate", backdrop: 'static', keyboard: false });
      modalRef.componentInstance.inputDataInModalComponent = data;
      this.trackModalRef(modalRef, "modalConfigcreate");
      modalRef.result.then((data) => {
        this.untrackModalRef(modalRef);
        modalRef.close()
        // if (data == "refresh") {
        this.ngxUiLoaderService.start();
        this.configagentid = "";
        this.configid = "";
        this.configjson = "";
        this.configstatus = "";
        this.configagentapikey = '';
        this.getcoreconfigforroute();
        this.ngxUiLoaderService.stop();
        // }
      }, (dat) => {
        this.untrackModalRef(modalRef);
        modalRef.close()
      });
    } else {
      let data = {
        editjson: "big",
        type: type
      }
      if (type != "create" && item == '') {
        data["configid"] = this.configid;
        data["agentid"] = this.configagentid;
        data["json"] = this.configjson;
        data["guids"] = this.configguids ? this.configguids : ''
        data["pipelineuniqueid"] = this.UniqueID;
        data["agentapikey"] = this.configagentapikey;
        data["status"] = this.configstatus;
      }
      else if (type != "create" && item != '') {
        data["configid"] = item.configid;
        data["agentid"] = item.agentid;
        data["json"] = item.json;
        data["guids"] = item.guids;
        data["pipelineuniqueid"] = this.UniqueID;
        data["agentapikey"] = item.agentapikey;
        data["status"] = item.status;
      }
      this.activeModal.close()
      const modalRef = this.modalService.open(ConfigComponent,
        { windowClass: "modalConfigJSONcreate", backdrop: 'static', keyboard: false });
      modalRef.componentInstance.inputDataInModalComponent = data;
      this.trackModalRef(modalRef, "modalConfigJSONcreate");
      modalRef.result.then((data) => {
        this.untrackModalRef(modalRef);
        this.service.configModalOpening = false;
        if (data == "refresh") {
          this.ngxUiLoaderService.start();
          this.configagentid = "";
          this.configid = "";
          this.configjson = "";
          this.configstatus = "";
          this.configagentapikey = '';
          this.configagentid = "";
          this.getcoreconfigforroute();
          this.ngxUiLoaderService.stop();
        }
      }, (resile) => {
        this.untrackModalRef(modalRef);
        this.service.configModalOpening = false;
        modalRef.close()
      });
    }
    this.ngxUiLoaderService.stop();
  }
  getFilteredValues(event) {
    if (event) {
      this.isLoadingFilteredValue = true;
      this.ngxUiLoaderService.start();
      if (this.filteragentlist.length == 0) {
        this.filteragentlist = this.filteragentlistbackup;
      }
      let isfound = false;
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
      if (regexExp.test(event)) {
        isfound = true;
        this.filteragentlist = this.filteragentlist.filter(x => x.id == event);
      }
      else {
        isfound = true;
        this.filteragentlist = this.filteragentlist.filter(x => x.name.toLowerCase().includes(event.toLowerCase()));
      }
      if (isfound) {
        this.configagentid = "";
        this.configguids = "";
        this.configid = "";
        this.configjson = "";
        this.configstatus = "";
        if (this.filteragentlist.length == 0) {
          this.notfounddata = true;
        }
        this.isLoadingFilteredValue = false;
      }
      this.ngxUiLoaderService.stop();
    }
  }
  selectedFilteredValues(item) {
    if (item) {
      this.RouteConfigList = this.RouteConfigList.filter(x => x.agentid == item.id);
    }
  }
  searchFilteredValuesCleared(item) {
    if (this.RouteConfigList.length != this.RouteConfigBackUpList.length) {
      this.configagentid = "";
      this.configguids = "";
      this.configid = "";
      this.configjson = "";
      this.configstatus = '';
      this.RouteConfigList = this.RouteConfigBackUpList;
    }
    this.filteragentlist = this.filteragentlistbackup;
    this.notfounddata = false;
    this.reactiveFormAgentFilter.reset();
    this.reactiveFormAgentFilter.setValue({ "filteragent": "" })
  }

 noSpecialCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) return null;

      const regex = /^[a-zA-Z0-9\s\-_.]*$/; // allow letters, numbers, space, -, _, .
      return regex.test(control.value) ? null : { specialChars: true };
    };
  }

  async gethandlerrulestatus() {
    if (this.deploymentsConfigurations != undefined) {
      var deploymentleveconfigs = this.deploymentsConfigurations;
      var res;
      var dpkey;
      if (this.isOutboundPipelineForCreate()) {
        res = deploymentleveconfigs[this.targetdeployementkey];
        dpkey = this.targetdeployementkey;
        if (this.sourcedeployementkey !== this.targetdeployementkey) {
          dpkey = this.sourcedeployementkey;
        }
      }
      else {
        if (deploymentleveconfigs !== undefined) {
          res = deploymentleveconfigs[this.sourcedeployementkey];
        }
        dpkey = this.sourcedeployementkey;
      }
      var api = "api/VitalHubDXAPI/gethandlerandrule?groupid=" + this.selectedrouteId;
      this.beginAdditionalInfoLoad();
      this.service.dxgetapi(api, dpkey).pipe(
        finalize(() => this.endAdditionalInfoLoad())
      ).subscribe({
        next: (data) => {
          this.additionalinfodataflag = true;
          if (this.isInboundPipelineForCreate()) {
            this.handlercreateddisplaylabel = true;
            this.rulecreateddisplaylabel = false;

            if (this.modelradio["option"] == 'FTP') {
              this.ftpcreateddisplaylabel = true;
            }
          }
          else if (this.isOutboundPipelineForCreate()) {
            this.handlercreateddisplaylabel = true;
            this.rulecreateddisplaylabel = true;
            if (this.connectivitytype == 'API') {
              this.ftpcreateddisplaylabel = false;
            }
            else {
              this.ftpcreateddisplaylabel = true;
            }
          }

          if (data["Handler"] !== '' && data["Handler"] !== null) {
            this.handlercreatedflag = true;
          }
          else {
            this.handlercreatedflag = false;
          }

          if (data["Handler"] !== '' && data["VaRule"] !== '' && data["Handler"] !== null && data["VaRule"] !== null) {
            this.rulecreatedflag = true;
          }
          else {
            this.rulecreatedflag = false;
          }
          if (data["Description"] !== '' && data["Handler"] !== null) {
            this.Descriptionflag = true;
            this.Description = data["Description"];

          }
        },
        error: error => {
          this.additionalinfodataflag = false;
          // this.toastr.error("failed to get pipeline status", "",
          //   { timeOut: 4000, positionClass: 'toast-bottom-right' });
          this.ngxUiLoaderService.stop();
        }
      });;
    }
  }
  selectedmessagetypeevent(event) {
    this.messagetype = event.displayname;
  }

  Clearemessagetype() {
    this.messagetype = '';
    this.messageTypeList = this.messageTypeAllList;
  }
  selectedRoutePolicyEvent(item) {
    this.routepolicyselected = item.value;
  }
  clearedroutepolicy() {
    this.routepolicyselected = "";
  }
  async addinterfacedescription(c) {
    if (this.selectedInterfacedescription) {
      c('close modal');
      if (this.handlerSpinner) {
        var deploymentleveconfigs = this.deploymentsConfigurations;
        this.createhandlerandrule(deploymentleveconfigs, this.targetdeployementkey, true);
        return
      }
      if (this.ruleSpinner) {
        var deploymentleveconfigs = this.deploymentsConfigurations;
        this.createhandlerandrule(deploymentleveconfigs, this.targetdeployementkey, true);
        return
      }

      await this.SaveRouteDetailstoDB();
      this.selectedInterfacedescription = "";
    }
    else {
      this.toastr.warning("Please provide the notes!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
    }
  }
  closeinterfacedescriptionpopup(c) {
    this.handlerSpinner = false;
    this.ruleSpinner = false;
    this.selectedInterfacedescription = "";
    c('close modal');
  }

  async createFTP(recreate: boolean) {
    await this.getrandamusernamepassword();

    // call create FTP credentials and update ftp config
    const postentity: any = {
      "UserName": this.ftpusername,
      "Password": this.ftppassword,
      "RemoteSitePath": this.selectedrouteDisplayName, //will create ftp folder with route name
      "FTPpath": '',
      "Deploymentkey": this.sourcedeployementkey,
      "ContextId": this.UniqueID,
      "AgentId": this.envSourceProxy,
      "ConnectivityType": this.interfacetype == "Outbound" || this.interfacetype == "EllkayOutbound" ? this.outboundmodelradio["option"] : this.modelradio["option"],
      "Context": "pipeline",
      "ModifierID": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
      "Suffix": this.suffixfromprocessor,
      "FolderWatchFlag": true,
      "MessageTypes": this.messagetype,
      "Directions": this.interfacetype,
      "TypeFlag": "Interface"
    }
    var ftpresponse = await this.service.postapi("api/FTP/CreateAndSaveFTP", postentity);
    if (ftpresponse['statusmessage'] == 'Success') {
      this.ftpcreatedflag = true;
      this.ftpSpinner = false;
      this.ftpcreateddisplaylabel=true;
      this.ftpcreatedflag=true;
      this.ftpflag = true;
      this.ftpalreadycreated = false;
      this.updateconfigflagftp = false;
      this.ftpusername = ftpresponse['UserName'];
      this.ftphost = ftpresponse['ServerDomain'];
      this.ftpport = ftpresponse['Port'];
      this.remotepathdisplay = ftpresponse['RemoteSitePath'];
      
      if (this.modelradio["option"] == "FTPV2") {
        this.ftppassword = ftpresponse['Password']
        this.ftphost = this.ensureSftpPrefix(ftpresponse['ServerDomain']);
        this.ftpcreatedflag = true;
        //ftpresponse['FullPath']=ftpresponse['RemoteSitePath'];
      }
      this.containername = ftpresponse['containername'];
      await this.getftppaths(ftpresponse['FullPath']);
      //Ftp duplicate popup issue fix.
      if (this.modelradio["option"] != "FTPV2" && recreate) {
        this.toastr.success('FTP created successfully', '', {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });
      }

    }
    else {
      this.ftpcreatedflag = false;
      this.ftpSpinner = false;
      this.ftpflag = false;
      this.ftpalreadycreated = true;
      this.updateconfigflagvb = false;
      this.ngxUiLoaderService.stop();

      this.toastr.error('Pipeline saved successfully but failed to create FTP user', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }
  }

  async SaveVbJobConfig(createjobresponse) {
    if (createjobresponse.status == "success") {
      this.vbjobcreatedflag = true;
      this.vbflag = true;
      this.updateconfigflagvb = false;
      this.selectedjobId = createjobresponse.jobid;
      this.selectedjobName = createjobresponse.jobname;
      this.isShownorderinbound = true;
      this.isShownorderinboundvb = true;
      this.isShownresultoutbound = false;
      this.VBClientmatcard = false;
      if (this.modelradio["option"] == 'VB Client') {
        this.vbfolderpathflag = true;
        this.vbfolderpathdisplay = this.modelvbclient.vbclientpath;
      }
      else {
        this.vbfolderpathflag = false;
      }
      this.toastr.success('VB job created successfully', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
    else{
      this.vbjobcreatedflag = false;
      this.vbSpinner = false;
      this.toastr.error('Failed to create VB job', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }


  async SaveUploadOrDownloadVBJob(JobType, Connectivitytype) {
      let obj={};
    //call the VB api to create the job
    this.vbreturndetails = {
      "status": "",
      "statuscode": ''
    };

    var extensionsmulti = '';
    this.selectedextensionItems.forEach(element => {
      extensionsmulti = element.item_text;
      this.extensions.push(extensionsmulti)
    });
    this.vbFTPFileJob["routeUniqueId"] = this.UniqueID;
    this.vbFTPFileJob["agentid"] = this.envSourceProxy;
    this.vbFTPFileJob["status"]='active';
    this.vbFTPFileJob["action"] = this.myFlagForSlideToggle ? "Start" : "Stop";
    this.vbFTPFileJob["jobname"] = this["selectedrouteDisplayName"] + '_External';
    this.vbFTPFileJob["jobtype"] = JobType;
    this.vbFTPFileJob["createdby"] = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
    this.vbFTPFileJob["connectivitytype"] = Connectivitytype;    

    if(this.messagetype.toLowerCase()=='networkprinting'){
      this.vbFTPFileJob["agentid"] = this.selectedVBInstance;
      let downloadSourcePath = this.remotepathdisplay.replace(/\/{2,}/g, '/');

       obj = {
        RemoteArchiveFolder:  downloadSourcePath + "archive",  
        //LocalArchiveFolder: JobType == "FTP5FileWatchUpload" ? this.archivepath + "\\" : this.customftp.archivepath,
        LocalDownloadFolder: this.customFolderPath,
        //LocalSourceFolder: this.sourcepath,
        Downloadsource: downloadSourcePath.replace(/\/$/, ""), 
        Host: this.ftphost.replace("sftp://", ""),
        Port: this.ftpport,
        Username: this.ftpusername,
        Password: this.ftppassword,
        RouteDefinitionId: this.selectedrouteId,
        MessageType: this.messagetype,
        SourceEntityId: this.selectedsourceaccountid,
        DestinationEntityId: this.selectedtargetaccountid,
        FTPProtocol: "SFTP"
      }
    }
    else{
      this.vbFTPFileJob["agentid"] = this.envSourceProxy;
      obj = {
        RemoteArchiveFolder: JobType == "FTP5FileWatchUpload" ? this.archivepath + "\\" : this.customftp.archivepath,
        LocalArchiveFolder: JobType == "FTP5FileWatchUpload" ? this.archivepath + "\\" : this.customftp.archivepath,
        LocalDownloadFolder: this.sourcepath,
        LocalSourceFolder: this.sourcepath,
        Downloadsource: this.customftp.folder,
        Host: this.customftp.host.replace("sftp://", ""),
        Port: this.customftp.port,
        Username: this.customftp.username,
        Password: this.customftp.password,
        RouteDefinitionId: this.selectedrouteId,
        MessageType: this.messagetype,
        SourceEntityId: this.selectedsourceaccountid,
        DestinationEntityId: this.selectedtargetaccountid,
        FTPProtocol: "SFTP"
      }
    }
    this.vbFTPFileJob["connectivity"]=obj;
    let response = await this.service.postapi('api/VBJobs/SaveVBFileJob', this.vbFTPFileJob);
    if (response.status == 'success') {
      this.vbflag = true;
      this.vbjobcreatedflag = true;
      this.vbreturndetails.status = 'success';
      this.vbreturndetails.jobid = response.content["jobid"];
      this.vbreturndetails.jobname = response.content["jobname"];
    }
    else{
      this.vbjobcreatedflag = false;
      this.vbSpinner = false;
      this.toastr.error('Failed to create VB job', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    return this.vbreturndetails;
  }

  async savecustomFTPDetails() {
    //this.interfacetype=this.interfacetype == 'Outbound'  ? this.outboundmodelradio["option"]: this.modelradio["option"];
     const selectedConnectivityType = (this.interfacetype || '').toLowerCase().includes('outbound')
                                        ? this.outboundmodelradio["option"]
                                        : this.modelradio["option"];
    this.ngxUiLoaderService.start();
    const ftpDetails = {
      id: this.customftp.id ? this.customftp.id : 0,
      contextId: this.UniqueID,
      context: 'pipeline-external',
      agentId: this.envSourceProxy,
      connectivityType: selectedConnectivityType, //this.interfacetype,
      connectionType: "sftp",
      host: this.customftp.host.replace('sftp://', ''),
      port: parseInt(this.customftp.port),
      server: this.customftp.host.replace('sftp://', ''),
      userName: this.customftp.username,
      password: this.customftp.password,
      remotePath: this.customftp.folder.replace('\\', '//'),
      sourcePath: this.customftp.folder,
      archivePath: this.customftp.archivepath,
      progressPath: '',
      errorPath: '',
      pipelineName: this.selectedrouteDisplayName,
      folderWatchFlag: false,
      modifierId: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
      containername: this.containername

    }

    //call ftp config update api
    var responseconfig = await this.service.postapi('api/CoreConfig/SaveFtpDetails', ftpDetails);
    if (responseconfig['status'] && responseconfig['statusText']) {
      this.updateconfigflagvb = false;
      this.ngxUiLoaderService.stop();
      this.toastr.error('Failed to Update FTP configuration in Flat Table' + responseconfig['statusText'], "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }
  }

  UpdateConnectivityDetails() {
    let apiname = 'api/Routes/UpdateConnectivityDetails?RouteId=' + this.selectedrouteId;
    this.service.getapi(apiname);
  }

  getprojectname() {
    let obj = {
      "searchinput": null,
      "vendorId": this.vendorid,
      "labGuid": this.interfacetype == 'Inbound' ? this.selectedtargetaccountid : this.selectedsourceaccountid
    }
    this.service.getprojects(obj).subscribe((data) => {
      if (data['status'].toLowerCase() == 'success' && data['statusmessage'].toLowerCase() != 'no data found') {
        this.notfounddata = false;
        this.projectnamelist = JSON.parse(data['statusmessage']);
        this.projectnamelist.map(obj => obj['displayname'] = `${obj.projectName} ${'(' + obj.projectId + ')'}`);
        this.projectnameBackuplist = this.projectnamelist;
      }
      else {
        this.notfounddata = true;
        this.toastr.warning('No projects found', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    })
  }

  inputprojectname(event: any) {
    let value;
    if (event != undefined) {
      value = event.projectName
      this.projectnamelist = this.projectnamelist.filter(t => t.displayname.toLowerCase().includes(value.toLowerCase()));
    }
    if (this.projectnamelist.length == 0) {
      this.notfounddata = true;
    } else {
      this.notfounddata = false;
    }
    this.isLoadingProject = false;
  }


  selectedprojectEvent(item) {
    this.id = item.id
    this.selectedprojectId = item.projectId;
    this.selectedprojectname = item.projectName;
    this.pipelineselectclass = 'ng-autocompleteselect';
    this.isLoadingProject = false;
  }
  async searchprojectCleared() {
    if (this.selectedprojectId !== "") {
      this.projectnamelist = []
      this.projectnamelist = this.projectnameBackuplist;
      this.isLoadingProject = false;
    }
  }
  projectfullname(id, name) {
    return '(' + id + ')' + ' ' + name
  }
  saveprojectftp(ftpprojobj: any) {
    this.service.saveprojftpdetails(ftpprojobj).subscribe((data) => {
      if (data['progressPath'] != "" || data['progressPath'] != null) {
        this.ftpflag = true;
        this.ftpalreadycreated = true;
        this.ftpusername = data['userName'];
        this.ftppassword = data['password']
        this.ftphost = data['host'];
        this.ftpport = data['port'];
        this.remotepathdisplay = data['remotePath'];
        return
      }
      else {
        this.ftpflag = false;
        return
      }
    })

  }

  sendftpmail() {
    let obj =
    {
      "projectID": '',
      "projectname": '',
      "interfaceID": this.selectedrouteId,
      "interfacename": this.selectedrouteDisplayName,
      "ftpdata": {
        "Host": this.ftphost,
        "Username": this.ftpusername,
        "Password": this.ftppassword,
        "Port": this.ftpport
      }
    }
    this.ngxUiLoaderService.start();
    this.service.pdf64(obj).subscribe((data) => {
      if (data['status'].toLowerCase() == 'success') {
        this.pdf64responsebody = data['responsebody']
        this.ftpbase64 = 'data:application/pdf;base64,' + data['responsebody'];
        this.filenamedisplay = data['statusmessage'].split(':')[1];
        this.key = data['extendedattributes']['key'];
        let authhtml
        authhtml = `<p><span style="font-size:11pt"><span style="font-family:Calibri"><span style="font-size:12.0000pt"><span style="font-family:Calibri">Hi,<br />FTP file password enclosed below.</span></span></span></span></p>
        <p><span style="font-size:11pt"><span style="font-family:Calibri"><span style="font-size:12.0000pt"><span style="font-family:Calibri">`+ this.key + `</span></span></span></span></p>
        <p><span style="font-size:11pt"><span style="font-family:Calibri"><span style="font-size:12.0000pt"><span style="font-family:Calibri">Thanks &amp; Regards<br />
        VitalAxis</span></span></span></span></p>`
        this.Subject.setValue("Password to access FTP Details for " + this.selectedrouteDisplayName + "(" + this.selectedrouteId + ")");
        this.mainSubject.setValue("FTP Details for Interface :" + this.selectedrouteDisplayName + "(" + this.selectedrouteId + ")");

        this.htmlContent = `<p><span style="font-size:11pt"><span style="font-family:Calibri"><span style="font-size:12.0000pt"><span style="font-family:Calibri">Hi,</span></span></span></span></p>
<p><span style="font-size:11pt"><span style="font-family:Calibri"><span style="font-size:12.0000pt"><span style="font-family:Calibri">Please find the attached file for FTP Information. </span></span></span></span></p>
<p>&nbsp;</p>
<p><span style="font-size:11pt"><span style="font-family:Calibri"><span style="font-size:10.0000pt"><span style="font-family:Calibri">Note: Attached file is password protected for the security purposes. Please refer to the following email to locate the password.</span></span></span></span></p>
<p>&nbsp;</p>
<p><span style="font-size:11pt"><span style="font-family:Calibri"><strong><span style="font-size:12.0000pt"><span style="font-family:Calibri"><strong>Thanks &amp; Regards</strong></span></span></strong></span></span></p>
<p><span style="font-size:11pt"><span style="font-family:Calibri"><strong><span style="font-size:12.0000pt"><span style="font-family:Calibri"><strong>VitalAxis</strong></span></span></strong></span></span></p>`;

        let attachmentobjftp = {}
        attachmentobjftp[this.filenamedisplay] = this.pdf64responsebody
        let pdfMailComponent = {
          responsebody: this.pdf64responsebody,
          base64: this.ftpbase64,
          filenamedisplay: this.filenamedisplay,
          key: this.key,
          toaddresslist: this.alltoaddressid,
          Cclist: this.allCcid,
          mainSubject: this.mainSubject.value,
          htmlContent: this.htmlContent,
          authhtml: authhtml,
          Subject: this.Subject.value,
          attachmentobj: attachmentobjftp
        }
        const modalRef = this.modalService.open(MailComponent,
          { windowClass: "myCustomModalClassFTPcreate", backdrop: 'static', keyboard: false });
        modalRef.componentInstance.inputDataInModalComponent = pdfMailComponent;
        this.trackModalRef(modalRef, "myCustomModalClassFTPcreate");
        modalRef.result.then(() => {
          this.untrackModalRef(modalRef);
        }, (reason) => {
          this.untrackModalRef(modalRef);
        });
        this.ngxUiLoaderService.stop();
      } else if (data['status'].toLowerCase() === "failure") {
        this.ngxUiLoaderService.stop();
        this.toastr.error(data.statusmessage, 'Failed', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, error => {
      this.ngxUiLoaderService.stop();
    })
  }

  isdevicename() {
    if (this.modelradio.option == "Device" && this.selectedsourceaccountid == '' && this.selectedtargetaccountid == '') {
      this.isinbounddevice = false;
    }
    else {
      this.isinbounddevice = true;
    }
  }

  isoutbounddevicename() {
    if (this.modelradio.option == "Device" && this.selectedsourceaccountid == '') {
      this.isoutbounddevice = false;
    }
    else {
      this.isoutbounddevice = true;
    }
  }

  getdeviceName(event) {
    let value = event;
    if (value != '') {
      if (this.DeviceList.length > 0) {
        this.filterdevicelist(value);
      }
    }
  }
  filterdevicelist(value) {
    this.DeviceList = this.DeviceList.filter(t => t.name.toLowerCase().includes(value.toLowerCase()));
    if (this.DeviceList.length == 0) {
      this.notfounddata = true;

    } else {
      this.notfounddata = false;
    }
  }
  devicenamecleared() {
    this.selecteddevice = ''
    this.DeviceList = this.DeviceListbackup;
    this.reqfieldslist = [];
  }

  async getdevicejobdetails(): Promise<boolean> {
    this.beginAdditionalInfoLoad();
    this.isShownorderinbound = false;
    try {
      const data: any = await firstValueFrom(
        this.service.GetJobDetails(this.envSourceProxy, this.selectedrouteId).pipe(
          finalize(() => this.endAdditionalInfoLoad())
        )
      );

      if (data?.status === 'success') {
        const obj = JSON.parse(data['responsebody']);
        if (obj && obj.length > 0) {
          this.vbjobcreatedflag = true;
          this.additionalinfodataflag = true;
          this.savedjobdetails = JSON.parse(obj[0].Json);
          this.vbjobsdata = JSON.parse(obj[0].Json);
          this.VBJobCurrentStatus = obj[0].CurrentState;
          this.isShownorderinbound = true;
          return true;
        }
        return false;
      }

      this.toastr.error("Failed to get job details", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    } catch (error) {
      this.toastr.error("Something went wrong in getting Job details", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
  }

  async Getvbagentsdetails() {
    if (this.selectedtargetaccountid != '' && this.selectedtargetaccountid != undefined) {
      this.ngxUiLoaderService.start();
      this.service.Getvbagentsdetails(this.selectedtargetaccountid).subscribe((data) => {
        let issuccess=false;
        if (data.status == 'success') {
          let obj = JSON.parse(data['responsebody']);
          this.vbagentlist = obj['content'];
          this.vbagentlistbackup = obj['content'];
          issuccess=true;
        }
        this.ngxUiLoaderService.stop();
        return issuccess;
      }, error => {
        this.ngxUiLoaderService.stop();
      })
    }
  }
  selectvbagent(value) {
    if (value != undefined) {
      this.selectedvbagentname = value.AgentName;
      this.selectedvbagentid = value.AgentID;
    }
  }
  getvbagentName(event) {
    let value = event;
    if (value != '') {
      if (this.vbagentlist.length > 0) {
        this.filtervbagentlist(value);
      }
    }
  }
  filtervbagentlist(value) {
    this.vbagentlist = this.vbagentlistbackup.filter(t => t.AgentName.toLowerCase().includes(value.toLowerCase()));
    if (this.vbagentlist.length == 0) {
      this.notfounddatavbagent = true;
    } else {
      this.notfounddatavbagent = false;
    }
  }
  vbagentnamecleared() {
    this.selectedvbagentname = ''
  }
  async getDevicelistbyentity() {
    let devicedetails = {}
    if (this.interfacetype == 'Inbound') {
      devicedetails = {
        "OrgGUID": this.targetorgguid,
        "Deploymentkey": this.targetdeployementkey,
        "Direction": this.interfacetype
      }
    }

    if (this.selectedtargetaccountid != '' && this.selectedsourceaccountid != '') {
      if (this.rbtn == 'Device') {
        this.ngxUiLoaderService.start();
        this.service.CreateDeviceConnectivity(devicedetails).subscribe((data) => {
          this.ngxUiLoaderService.stop();
          if (data.responsebody == null || data.responsebody == '') {
            this.toastr.warning("No devices", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
          else {
            this.DeviceList = []
            let dlist = JSON.parse(data.responsebody);
            this.defaultjobjson = data['extendedattributes']
            dlist.forEach(element => {
              let obj = { 'DeviceName': element }
              this.DeviceList.push(obj);
            })
            this.DeviceListbackup = JSON.parse(JSON.stringify(this.DeviceList));
            if (this.interfacetype == 'Inbound') {
              this.isdevicename();
            }
          }
        }, error => {
          this.ngxUiLoaderService.stop();
          this.toastr.error("something went wrong in getting device list", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        })
      }
    }
  }

  selectdevice(dname) {
    this.selecteddevice = dname.DeviceName;
  }
  private ensureSftpPrefix(host?: string): string {
    if (!host) {
      return "";
    }
    return host.toLowerCase().startsWith("sftp://") ? host : `sftp://${host}`;
  }
  viewpassword(isftp: boolean) {
    if (isftp && this.isviewpasswordftp) {
      this.service.auditsave("Add", "", "Viewed FTP password for pipeline :- " + this.selectedrouteDisplayName, "Pipeline", this.UniqueID, "Viewed Password (Pipeline)");
    } else if (!isftp && this.isviewpasswordexftp) {
      this.service.auditsave("Add", "", "Viewed External-FTP password for pipeline :- " + this.selectedrouteDisplayName, "Pipeline", this.UniqueID, "Viewed Password (Pipeline)");
    }
  }
  async ADTinterfaces(issave: boolean) {
    let obj = {
      routename: this.selectedroutename,
      sourceguid: this.selectedsourceaccountid,
      deploymentkey: this.sourcedeployementkey,
      oldroutename: this.selectedrname,
      accountid: ""
    }
    let actioname = issave ? "SaveADTInterfaceAccountDetails" : "GetADTInterfaceAccountDetails"
    let response = await this.service.dxpostapi("api/VitalHubDXAPI/" + actioname, obj);
    if (response['status'] == 'success') {
      this.adtflag = true;
    }
    else {
      this.adtflag = false
    }
  }
  async DFTinterface(savefalg: boolean) {
    let obj = {
      sourceguid: this.selectedsourceaccountid,
      deploymentkey: this.sourcedeployementkey,
      username: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
      contextid: this.UniqueID
    }
    let actioname = savefalg ? "SaveDftInterfaceDetails" : "GetDftInterfaceDetails"
    let response = await this.service.dxpostapi("api/VitalHubDXAPI/" + actioname, obj);
    if (response['status'] == 'success') {
      this.dftcheck = true;
      this.dftflag = true;
    }
    else {
      this.dftcheck = true;

      this.dftflag = false
    }
  }
  closeadtmodal(adt) {
    adt('close modal');
  }
  CreateSenderListener(){
if(this.vbjobsdata.length==0)
{
    let obj={
      "routeUniqueId": this.UniqueID,
      "agentid": this.envSourceProxy,
      "status": "active",
      "action": this.myFlagForSlideToggle ? "Start" : "Stop",
      "jobname": this.selectedroutename,
      "createdBy": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
    }
    obj['connectivity'] = obj['connectivity'] || {};
    if(this.interfacetype.toLowerCase() =='inbound'){
      obj['jobtype']='TCPListener';
      obj['connectivity']['ListenerRemoteIP']=this.modelvpn.ip;
      obj['connectivity']['ListenerRemotePort']=this.modelvpn.port;
      obj['connectivity']['ListenerDestinationPath']=this.sourcepath;
      obj['connectivity']['SourceEntityId']= this.selectedsourceaccountid;
      obj['connectivity']['DestinationEntityId']=this.selectedtargetaccountid;
      obj['connectivity']['RouteDefinitionId']=this.selectedrouteId;
      obj['connectivity']['MessageType']=this.messagetype;
    }
    else{
      obj['jobtype']='TCPSender';
      obj['connectivity']['SenderRemoteIP']=this.ipvpnout;
      obj['connectivity']['SenderRemotePort']=this.portvpnout;
      obj['connectivity']['SenderSourePath']=this.sourcepath;
      obj['connectivity']['SenderArchivePath']=this.archivepath;
      obj['connectivity']['RouteDefinitionId']=this.selectedrouteId;
    }
    this.service.saveVBJob(obj).subscribe((data)=>{
      if (data['status'].toLowerCase()=='success') {
        this.vbjobcreatedflag = true;
        this.toastr.success(obj['jobtype']+" Created","",{
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });
      }else{
        this.vbjobcreatedflag = false;
        this.vbSpinner = false;
        this.toastr.error(obj['jobtype']+" Not Created","",{
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    }, error => {
      this.ngxUiLoaderService.stop();
      this.toastr.error("something went wrong in getting device list", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    })
  }
  }

  vbjobsdata:any[]=[];
async getvbjobslist() {
    const PostFormData = {
      agentid: this.envSourceProxy,
      routeguid: this.selectedrouteId,
      direction: this.interfacetype,
      connectivitytype: this.connectivitytype
    }
    this.beginAdditionalInfoLoad();
    try {
      const response = await this.service.getvbjobsdetail(PostFormData).toPromise();
      if (response && response.length > 0) {
        this.vbjobcreatedflag = true;
        this.vbjobsdata = response;
      } else {
        this.vbjobcreatedflag = false;
      }
      return this.vbjobcreatedflag;
    } catch (error) {
      this.ngxUiLoaderService.stop();
      return false;
    } finally {
      this.endAdditionalInfoLoad();
    }
}
  async Resetalldata() {
    this.apiContractInitialData = null;
    this.apiContractConfig = null;
    this.apiHeadersBulkEditActive = false;
    this.apiAuthenticationType = 'token';
    this.apiConnectivityModeType = null;
    this.apiConnectivityModeSlug = null;
    this.apiContractResetVersion += 1;
    this.apiPollingJobFrequency = this.defaultApiPollJobFrequency;
    this.externalApiPollJob = null;
    this.apiPollingJobFrequencyLoaded = '';
    this.reactiveFormagent.reset();
    this.syncApiAgentFieldDisabledState();
    this.selectedAgentguid='';
    this.AgentNameList=[];
    this.adtcheck=false
    this.dftcheck=false
    this.ftpcreatedflag=false;
    this.vpncreatedflag=false
    this.additionalinfodataflag = false;
    this.additionalInfoPending = 0;
    this.adtflag=false;
    this.dftflag=false;
    this.ProcessorType='';
    this.vbjobcreatedflag=false
    this.rulecreateddisplaylabel=false;
    this.rulecreatedflag=false
    this.ftpcreateddisplaylabel=false;
    this.selectedrname = ''
    this.adtcheck = false;
    this.isviewpasswordftp = false
    this.vbagentlist = []
    this.isviewpasswordexftp = false
    this.deviceremoteip = ''
    this.deviceremoteport = ''
    this.reqfieldslist = []
    this.DeviceList = []
    this.id = ''
    this.selectedprojectId = ''
    this.selectedprojectname = ''
    this.pipelineselectclass = ''
    this.projectnamelist = [];
    this.isLocked = false;
    this.selectedprocessname = ''
    this.selectedsourcename = ''
    this.selectedtargetname = ''
    this.disableexternalftp = false;
    this.selectRouteNameBackup = "";
    this.selectedprocessagentid = '';
    this.selectedsourceaccountid = '';
    this.selectedtargetaccountid = '';
    this.selectedrouteId = "";
    this.UniqueID = '';
    this.selectedrouteDisplayName = "";
    this.selectedsourceaccountName = "";
    this.selectedtargetaccountName = "";
    this.selectedprocessdisplayname = "";
    this.btnshowtryit = false;
    this.selectedprocessapikey = "";
    this.myFlagForSlideToggle = false;
    this.isShownorderinbound = false;
    this.isShown = false;
    this.isShownresultoutbound = false;
    this.modelelk.subscriberkey = '';
    this.modelelk.servicekey = '';
    this.sourcetypedisplay = '';
    this.sourcetypedisplayid = '';
    this.targettypedisplay = '';
    this.targettypedisplayid = '';
    this.isshownellkykeys = false;
    this.remotepathdisplay = '';
    this.sourcepath = '';
    this.archivepath = '';
    this.errorpath = '';
    this.progresspath = '';
    this.ftpusername = '';
    this.ftppassword = '';
    this.ftpport = '';
    this.ftphost = '';
    this.ftpremotepath = '';
    this.interfacetype = '';
    this.selectedjobId = '';
    this.selectedjobName = '';
    this.vbjobname = '';
    this.modelradio = {};
    this.VBClientmatcard = false;
    this.array_disableradiobuttons = [];
    this.updateconfigflagftp = true;
    this.updateconfigflagvb = true;
    this.vbfolderpathdisplay = '';
    this.selectedextensionItems = [];
    this.modelvbftp = {};
    this.ftpisDisabled = false;
    this.vbjobnameftp = '';
    this.vbjobdisplayexftp = false;
    this.isRoutingInterface = false;
    this.routingConversionType = '';
    this.routingAgentId = '';
    this.oldvalue = '';
    this.newvalue = '';
    this.vendarmsgdiv = false;
    this.vendarnamevalue = '';
    this.sourcedpkeydisplay = '';
    this.targetdpkeydisplay = '';
    this.ftpcheckexsting = false;
    this.ftpexistingpath = '';
    this.isftp = false;
    this.ipvpnout = ''
    this.portvpnout = ''
    this.sourcepathvpnout = ''
    this.archivepathvpnout = ''
    this.pipelineselectclass = '';
    this.ftpexstingpathdiv = false;
    this.copypipelineflag = false;
    this.oldselectedrouteDisplayName = '';
    this.resetflag = false;
    this.copypiprlinrbutton = false;
    this.sourceentityaddress = '';
    this.sourceentityaddress1 = '';
    this.sourceentityaddress2 = '';
    this.sourcecity = '';
    this.sourcestate = '';
    this.sourcezip = '';
    this.sourcetype = '';
    this.targetentityaddress = '';
    this.targetentityaddress1 = '';
    this.targetentityaddress2 = '';
    this.targetcity = '';
    this.targetstate = '';
    this.targetzip = '';
    this.targettype = '';
    this.modeSelected = '';
    this.rulebuttonshow = false;
    this.auditbuttonflag = false;
    this.notebuttonflag = false;
    this.configid = "";
    this.configjson = "";
    this.routeconfigflag = true;
    this.enableconfig = false;
    this.configagentid = "";

    this.SourceAgentNameList = [];
    this.TargetAgentNameList = [];
    this.selectedsourceagentid = "";
    this.selectedtargetagentid = "";
    this.isLoadingagent = false;
    this.isLoadingTargetagent = false;
    this.selectedsourceagentname = "";
    this.selectedtargetagentname = "";
    this.selectedsourceapikey = "";
    this.selectedtargetapikey = "";
    this.messagetypeselected = "";
    this.routepolicyselected = "";
    this.additionalinfoflag = false;
    this.VendarsList = this.VendornameBackuplist;
    this.connectivitytypemsg = '';

    this.modelvpn.ip = "";
    this.modelvpn.port = "";
    this.modelvpn.sourcepath = "";
    this.modelvpn.archivepath = "";
    this.destinationinbound = "";
    this.showdestin = false;
    this.modelvpn.vpninputdisabled = false;
    this.vpncreatedflag = false;
    this.selectedInterfacedescription = "";
    this.configagentapikey = "";
    this.apiconnectivity = false;
    this.vendorid = "";
    this.vpndetails = false;
    this.customftp = <CustomFTPDetails>{
      username: '',
      password: '',
      host: '',
      port: '',
      folder: '',
      id: '',
      archivepath: ''
    }
    this.oneditftpradio = false;
    this.outboundmodelradio = {};
    this.vpnflag = false;
    this.vbjobalreadycreated = false;
    this.dftcheck = false;
    this.dftflag = false;
    this.savedjobdetails = "";
    this.reactiveFormsource.reset();
    this.reactiveFormtarget.reset();
    this.reactiveFormvbjob.reset();
    this.reactiveFormroute.reset();
    this.reactiveFormvendar.reset();
    this.reactiveFormmode.reset();
    this.reactiveFormsourceagent.reset();
    this.reactiveFormTargetagent.reset();
    this.reactiveFormroutepolicy.reset();
    this.reactiveFormmsgtype.reset();
    this.reactiveFormprojectname.setValue({ "projectname": '' });
    this.RouteNameSuggest.forEach(element => {
      element.value = '';
    });
this.isRuleEngine = false;
    this.RuleConfig = "";
    this.isView = false;
    this.RuleConfigJson = [];
    this.ruleConfigVersionsList = [];
    this.isRuleConfigEmptyOrNull = true;

    this.customFolderPathDataInputFlag = true;
    this.customFolderPath = "";
    this.vbInstances=[];
    this.selectedVBInstance="";
  };

  hasMethodTypeRule() {
    return !this.RuleConfig[0].rules.some((rule: any) => rule?.ruletype?.toLowerCase() === 'method');
  }

  showWarningForMethodTypeRule(){
    this.toastr.warning("Contains method type. Unable to display Rule Config", "", {
      timeOut: 4000,
      positionClass: "toast-bottom-right",
    });
  }
 async openRuleConfigDialog(triggeredByButton: boolean = false): Promise<void> {
    if (triggeredByButton) {
      this.isView = true;
      this.RuleConfigJson = this.RuleConfig;
    } 
    else {
      let RuleConfigRequest: RuleConfigRequest[] = [
        {
          "Type": "SE",
          "EntityType": this.sourceentitytype,
          "TypeName": this.sourcetype,
          "Guid": this.selectedsourceaccountid
        }
      ];
      if (this.selectedsourceaccountid && this.selectedtargetaccountid && this.selectedsourceaccountid !== this.selectedtargetaccountid) {
        RuleConfigRequest.push({
          "Type": "DE",
          "EntityType": this.targetentitytype,
          "TypeName": this.targettype,
          "Guid": this.selectedtargetaccountid
        });
      }
      this.RuleConfigJson = RuleConfigRequest;
     
    }
  
    await this.ensureTestOrganizationFlagsLoaded();

    const dialogRef = this.dialog.open(RuleConfigComponentComponent, {
      maxWidth: '95vw',
      height: '96%',
      width: '100%',
      data: {
        data: this.RuleConfigJson,
        isView: this.isView,
        routeGuid: this.selectedrouteId,
        routeName: this.selectedrouteDisplayName,
        routeUniqueID: this.UniqueID,
        ruleConfigVersions: this.ruleConfigVersionsList,
        ruleExecutionStage: 'Validation',
        componentname: 'createpipeline',
        dialogTitle: 'Pipeline Rules',
        ...this.getTestOrganizationFlagsForChildDialogs(),
      },
      autoFocus: false,
      disableClose: true,
      panelClass: 'rule-config-dialog-container'
    });
  
    
  
    try {
      const result = await dialogRef.afterClosed().toPromise(); // Wait for dialog to close
  
      // if (result) {
      //   this.RuleConfig = result;
      
      //   if (this.RuleConfig && this.UniqueID) {
      //     const objRuleConfig = {
      //       "RuleConfig": JSON.stringify(this.RuleConfig),
      //       "UniqueID": this.UniqueID,
      //       "RouteID": this.selectedrouteId,
      //       "ModifierID": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
      //     };
      //     this.ngxUiLoaderService.start();
      //     const responseConfigdata = await this.service.postapi('api/Routes/UpdateRuleConfig', objRuleConfig);
  
      //     if ((responseConfigdata['status'] && responseConfigdata['statusText']) || responseConfigdata['statusText'] === "Unknown Error") {
      //       this.ngxUiLoaderService.stop();
      //       this.toastr.error("Unable to update RuleConfig", "", {
      //         timeOut: 4000,
      //         positionClass: 'toast-bottom-right'
      //       });
      //     } else {
      //       this.ngxUiLoaderService.stop();
      //       this.toastr.success("RuleConfig saved successfully", "", {
      //         timeOut: 500,
      //         positionClass: 'toast-bottom-right'
      //       });
      //     }
      //   }
      // }
    } catch (error) {
      this.toastr.error("An unexpected error occurred", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    } 
  }

  async openModal(modalTemplate: any) {
    await this.refreshAckToggleVisibility();
    this.originalValues = {
      ShowMessage: this.ShowMessage,
      IsValidationAck: this.IsValidationAck,
      IsRuleEngineAck: this.IsRuleEngineAck,
      DuplicateFileFlag: this.DuplicateFileFlag,
      ShowLog: this.ShowLog,
      PreDeliveryFlag: this.PreDeliveryFlag
    };
    const modalRef = this.modalService.open(modalTemplate, { windowClass: "additionalsettingmodal", backdrop: 'static', keyboard: false });
    this.trackModalRef(modalRef, "additionalsettingmodal");
    modalRef.result.then((result) => {
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.untrackModalRef(modalRef);
    });
  }
  dismissModal(modal: any) {
    this.ShowMessage = this.originalValues.ShowMessage;
    this.IsValidationAck = this.originalValues.IsValidationAck;
    this.IsRuleEngineAck = this.originalValues.IsRuleEngineAck;
    this.DuplicateFileFlag = this.originalValues.DuplicateFileFlag;
    this.ShowLog = this.originalValues.ShowLog;
    this.PreDeliveryFlag = this.originalValues.PreDeliveryFlag;
    this.refreshAckToggleVisibility();
    modal.dismiss();
  }
  applyChanges(modal: any) {
    const settingsChanges = this.analyzeAdditionalSettingsChanges();
    const ackOn = this.showRuleEngineAckToggle ? this.IsRuleEngineAck : this.IsValidationAck;
    if (!ackOn) {
      if (this.showRuleEngineAckToggle) {
        this.IsValidationAck = false;
      } else {
        this.IsRuleEngineAck = false;
      }
    } else if (this.showRuleEngineAckToggle) {
      this.IsValidationAck = false;
      this.IsRuleEngineAck = true;
    } else {
      this.IsRuleEngineAck = false;
      this.IsValidationAck = true;
    }
    this.persistAdditionalSettings(modal, settingsChanges);
  }

  /** Detects which Additional Settings toggles changed in the current modal session. */
  private analyzeAdditionalSettingsChanges(): {
    preValidationTurnedOn: boolean;
    preDeliveryTurnedOn: boolean;
    preValidationChanged: boolean;
    preDeliveryChanged: boolean;
    otherSettingsChanged: boolean;
  } {
    const original = this.originalValues ?? {};
    const ackNow = this.showRuleEngineAckToggle ? this.IsRuleEngineAck : this.IsValidationAck;
    const ackOriginal = this.showRuleEngineAckToggle ? original.IsRuleEngineAck : original.IsValidationAck;

    const showMessageChanged = original.ShowMessage !== this.ShowMessage;
    const duplicateFileChanged = original.DuplicateFileFlag !== this.DuplicateFileFlag;
    const showLogChanged = original.ShowLog !== this.ShowLog;
    const preDeliveryChanged = original.PreDeliveryFlag !== this.PreDeliveryFlag;

    return {
      preValidationTurnedOn: !ackOriginal && ackNow,
      preDeliveryTurnedOn: !original.PreDeliveryFlag && this.PreDeliveryFlag,
      preValidationChanged: ackOriginal !== ackNow,
      preDeliveryChanged,
      otherSettingsChanged: showMessageChanged || duplicateFileChanged || showLogChanged,
    };
  }

  /** Single-toggle enable: only pre-validation or only pre-delivery changed in this apply. */
  private getSingleToggleRedirectTarget(changes: {
    preValidationTurnedOn: boolean;
    preDeliveryTurnedOn: boolean;
    preValidationChanged: boolean;
    preDeliveryChanged: boolean;
    otherSettingsChanged: boolean;
  }): 'preValidation' | 'preDelivery' | null {
    if (changes.preValidationTurnedOn && !changes.preDeliveryChanged && !changes.otherSettingsChanged) {
      return 'preValidation';
    }
    if (changes.preDeliveryTurnedOn && !changes.preValidationChanged && !changes.otherSettingsChanged) {
      return 'preDelivery';
    }
    return null;
  }

  /** Pre-validation enabled together with other flags — manual configuration only. */
  private shouldShowManualPreValidationToast(changes: {
    preValidationTurnedOn: boolean;
    preDeliveryChanged: boolean;
    otherSettingsChanged: boolean;
  }): boolean {
    if (!changes.preValidationTurnedOn) {
      return false;
    }
    return changes.preDeliveryChanged || changes.otherSettingsChanged;
  }

  private syncAckDisplayFlags(): void {
    this.isvalidationack = this.IsValidationAck;
    this.isruleengineack = this.IsRuleEngineAck;
  }

  private async hasLivePreValidationVersion(): Promise<boolean> {
    if (!this.UniqueID || this.UniqueID === '' || this.UniqueID === 0) {
      return false;
    }
    try {
      const raw = await this._ruleEngineService.GetRuleConfigVersions(this.UniqueID, 'PreValidation').toPromise();
      const list = Array.isArray(raw) ? raw : [];
      const hasLiveRule = list.some(
        (v: any) => (v.VersionStatus ?? '').toString().toLowerCase() === 'live'
      );
      if (hasLiveRule) {
        return true;
      }
      if (!this.showRuleEngineAckToggle && this.selectedrouteId && this.selectedprocessagentid) {
        const url = 'api/GetMappings/Get?routeid=' + this.selectedrouteId
          + '&processorid=' + this.selectedprocessagentid
          + '&processorapikey=' + this.selectedprocessapikey + '&prevalidation=true';
        const response = await this.service.getapiurl(url).toPromise();
        return this.hasLegacyValidationConfig(response);
      }
      return false;
    } catch {
      return false;
    }
  }

  private async hasLivePreDeliveryVersion(): Promise<boolean> {
    if (!this.UniqueID || this.UniqueID === '' || this.UniqueID === 0) {
      return false;
    }
    try {
      const raw = await this._ruleEngineService.GetRuleConfigVersions(this.UniqueID, 'Delivered').toPromise();
      const list = Array.isArray(raw) ? raw : [];
      return list.some(
        (v: any) => (v.VersionStatus ?? '').toString().toLowerCase() === 'live'
      );
    } catch {
      return false;
    }
  }

  /** After Apply: auto-open rule config for single-toggle enables; toast when multiple flags changed. */
  private async handlePostAdditionalSettingsApply(changes: {
    preValidationTurnedOn: boolean;
    preDeliveryTurnedOn: boolean;
    preValidationChanged: boolean;
    preDeliveryChanged: boolean;
    otherSettingsChanged: boolean;
  }): Promise<void> {
    if (this.shouldShowManualPreValidationToast(changes)) {
      this.toastr.info(
        'Pre-validation has been enabled. Please configure pre-validation rules manually from the Additional Info section.',
        '',
        { timeOut: 5000, positionClass: 'toast-bottom-right' }
      );
      return;
    }

    const redirectTarget = this.getSingleToggleRedirectTarget(changes);
    if (redirectTarget === 'preValidation') {
      const hasLive = await this.hasLivePreValidationVersion();
      if (!hasLive) {
        await this.openPreValidationMapping();
      }
      return;
    }

    if (redirectTarget === 'preDelivery') {
      const hasLive = await this.hasLivePreDeliveryVersion();
      if (!hasLive) {
        this.openPreDeliveryValidationMapping();
      }
    }
  }

  private persistAdditionalSettings(
    modal: any,
    settingsChanges?: {
      preValidationTurnedOn: boolean;
      preDeliveryTurnedOn: boolean;
      preValidationChanged: boolean;
      preDeliveryChanged: boolean;
      otherSettingsChanged: boolean;
    }
  ) {
    var dpkey: string = "";
    if (this.interfacetype == "Inbound" || this.interfacetype == "EllkayInbound") { 
      dpkey = this.targetdeployementkey;
    }
    else if (this.interfacetype == "Outbound" || this.interfacetype == "EllkayOutbound") {
      dpkey = this.sourcedeployementkey;
    }
    const requestBody = {
      RouteId: this.selectedrouteId,
      ShowMessage: this.ShowMessage,
      IsValidationAck: this.IsValidationAck,
      IsRuleEngineAck: this.IsRuleEngineAck,
      DuplicateFileFlag: this.DuplicateFileFlag,
      ShowLog: this.ShowLog,
      PreDeliveryFlag: this.PreDeliveryFlag,
      UserID: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
      UniqueId: this.UniqueID,
      deploymentkey: dpkey,
    };
    const changes = settingsChanges ?? this.analyzeAdditionalSettingsChanges();
    const singleRedirectTarget = this.getSingleToggleRedirectTarget(changes);

    this.service.UpdateValidateField(requestBody).subscribe({
      next: async (response: any) => {
        const status = (response?.Status ?? response?.status ?? '').toString();
        const message = (response?.Message ?? response?.message ?? '').toString();
        if (status.toLowerCase() === 'success') {
          this.syncAckDisplayFlags();
          this.toastr.success(message || 'Additional Settings Updated', '', {
            timeOut: 500,
            positionClass: 'toast-bottom-right'
          });
          modal.close();
          await this.handlePostAdditionalSettingsApply(changes);
          return;
        }
        if (status === 'NoLivePreValidation' || status.toLowerCase() === 'noliveprevalidation') {
          if (singleRedirectTarget === 'preValidation') {
            this.syncAckDisplayFlags();
            modal.close();
            await this.openPreValidationMapping();
            return;
          }
          if (this.showRuleEngineAckToggle) {
            this.IsRuleEngineAck = false;
          } else {
            this.IsValidationAck = false;
          }
          this.syncAckDisplayFlags();
          this.toastr.warning(message || 'No live version found', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return;
        }
        this.toastr.error(message || 'Additional settings update failed', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      },
      error: () => {
        this.toastr.error('Additional settings update failed', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }

  getAgentNames(event: any) {
    var val = event;
    if (val) {
      this.isLoadingagent1=true;

      var apiname = "api/Agents/GetByDisplayName?name=" + val + '&agentid=0&type=&filterflag=true';
      this.service.getapiurl(apiname).subscribe({
        next: data => {
          if ((data['status'] && data['statusText']) || data['statusText'] === "Unknown Error") {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          else {
            this.AgentNameList = data as any[];
            this.AgentNameList = this.service.transformAlphabetically(this.AgentNameList, 'displayname');
            this.AgentNameList.map(obj => obj.displayname = `${obj.displayname} ${'('} ${obj.id} ${')'} ${'('} ${obj.apikey} ${')'}`);
            this.isLoadingagent1=false;
            if (data.length == 0) {
              this.notfounddataagent = true;
            }
            else {
              this.notfounddataagent = false;
            }
          }
        },
        error: error => {
          this.isLoadingagent1=true;
          this.notfounddataagent = true;
        }
      });
    }
  }
  selectedAgent(data) {
    this.selectedAgentguid = data.id;
    this.reactiveFormagent.patchValue({ agentname: data.displayname || data.id });
  }
  searchAgentNameCleared() {
    this.reactiveFormagent.reset();
    this.isLoadingagent1 = false;
    this.AgentNameList = [];
    this.selectedAgentguid = '';
    this.notfounddataagent = false;
  }

  private hideModals() {
    const ownedClasses = (this.modalRefsTracked || []).map(m => m.windowClass).filter(Boolean);
    const tryitoutPopup = document.querySelector('.modal.myCustomModalViewfilehl7ViewerFromCreate') as HTMLElement;
    const tryitoutOpen = !!(tryitoutPopup && this.modalTabVisibility.isModalVisuallyOpen(tryitoutPopup));
    const result = this.modalTabVisibility.hideOwned('data-create-modal', {
      hasOpenRefs: (this.currentModalRefs?.length > 0 && this.modalRefsTracked?.length > 0) || tryitoutOpen,
      windowClasses: ownedClasses.length ? ownedClasses : undefined,
      extraSelectors: ['.modal.myCustomModalViewfilehl7ViewerFromCreate'],
      nestedOwnerAttrs: ['data-varules-modal', 'data-ftpfiles-hl7viewer-modal'],
    });
    this.modalWasOpen = result.modalWasOpen;
  }

  private showModals() {
    const ownedClasses = (this.modalRefsTracked || []).map(m => m.windowClass).filter(Boolean);
    const tryitoutPopup = document.querySelector('.modal.myCustomModalViewfilehl7ViewerFromCreate') as HTMLElement;
    this.modalTabVisibility.showOwned('data-create-modal', {
      modalWasOpen: this.modalWasOpen,
      hasOpenRefs: this.currentModalRefs?.length > 0 || !!tryitoutPopup,
      windowClasses: ownedClasses.length ? ownedClasses : undefined,
      extraSelectors: ['.modal.myCustomModalViewfilehl7ViewerFromCreate'],
      nestedOwnerAttrs: ['data-varules-modal', 'data-ftpfiles-hl7viewer-modal'],
    });
  }
  async openPreValidationMapping(): Promise<void> {
    if (!this.selectedrouteId || !this.selectedprocessagentid) {
      this.toastr.error("Pipeline and Processor are mandatory", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    try {
      this.ngxUiLoaderService.start();
      const raw = await this._ruleEngineService.GetRuleConfigVersions(this.UniqueID, 'PreValidation').toPromise();
      const list = Array.isArray(raw) ? raw : [];

      if (list.length > 0) {
        this.ngxUiLoaderService.stop();
        await this.openPreValidationRuleConfig();
        return;
      }

      const url = 'api/GetMappings/Get?routeid=' + this.selectedrouteId
        + '&processorid=' + this.selectedprocessagentid
        + '&processorapikey=' + this.selectedprocessapikey + '&prevalidation=true';
      const response = await this.service.getapiurl(url).toPromise();
      this.ngxUiLoaderService.stop();

      if (this.hasLegacyValidationConfig(response)) {
        this.openLegacyPreValidationMappingModal(response);
      } else {
        await this.openPreValidationRuleConfig();
      }
    } catch {
      this.ngxUiLoaderService.stop();
      this.toastr.error("Unable to fetch the Validation Mappings", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }

  private async openPreValidationRuleConfig(): Promise<void> {
    try {
      this.ngxUiLoaderService.start();
      const raw = await this._ruleEngineService.GetRuleConfigVersions(this.UniqueID, 'PreValidation').toPromise();
      this.ngxUiLoaderService.stop();

      const list = Array.isArray(raw) ? raw : [];
      const { ruleData, hasExistingRules } = this.extractRuleConfigFromVersions(list);
      const finalRuleData = hasExistingRules ? ruleData : [];

      await this.ensureTestOrganizationFlagsLoaded();

      const dialogRef = this.dialog.open(RuleConfigComponentComponent, {
        maxWidth: '95vw',
        height: '96%',
        width: '100%',
        data: {
          data: finalRuleData,
          isView: hasExistingRules,
          routeGuid: this.selectedrouteId,
          routeName: this.selectedrouteDisplayName,
          routeUniqueID: this.UniqueID,
          ruleConfigVersions: list,
          ruleExecutionStage: 'PreValidation',
          componentname: 'createpipeline',
          dialogTitle: 'Pre-Validation Rules',
          deliveryTemplateKey: this.getPreValidationTemplateKeyForCreate(),
          ...this.getTestOrganizationFlagsForChildDialogs(),
        },
        autoFocus: false,
        disableClose: true,
        panelClass: 'rule-config-dialog-container'
      });
      dialogRef.afterClosed().subscribe(() => {
        this.getRouteDetails();
      });
    } catch {
      this.ngxUiLoaderService.stop();
      this.toastr.error('An unexpected error occurred', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
    }
  }

  private async openLegacyPreValidationMappingModal(response: any): Promise<void> {
    await this.ensureTestOrganizationFlagsLoaded();
    this.Templatearray = response as any;
    const coreConfigVersionList = this.Templatearray['CoreConfigVersionList'] || [];
    const liveConfig = this.getLiveCoreConfigFromMappingsResponse(response);

    let mappedXml = this.Templatearray['mappedxml'];
    if (liveConfig?.json?.processorconfig?.validationconfig?.mappedxml) {
      mappedXml = liveConfig.json.processorconfig.validationconfig.mappedxml;
    }

    this.dataToModal = {
      lockXMLmap: this.isLocked,
      templateid: this.Templatearray['template'],
      templatelist: this.Templatearray['templatelist'],
      MappedXml: mappedXml,
      resultJson: this.Templatearray['resultjson'],
      routeid: this.selectedrouteId,
      processorid: this.selectedprocessagentid,
      processorapikey: this.selectedprocessapikey,
      routeName: this.selectedrouteDisplayName,
      ProcessorName: this.selectedprocessdisplayname,
      uniqueid: this.UniqueID,
      routedetails: this.Templatearray['routeDetails'],
      CoreConfigVersionList: coreConfigVersionList,
      isValidation: true,
      componentname: 'createpipeline',
      connectivitytype: this.modelradio ? this.modelradio['option'] : '',
      deploymentkey: this.sourcedpkeydisplay,
      messagetype: this.messagetype ? this.messagetype.toLowerCase() : '',
      ...this.getTestOrganizationFlagsForChildDialogs(),
    };

    const modalRef = this.modalService.open(XmlmappingsComponent,
      { windowClass: 'myCustomModalClasscreatexml', backdropClass: 'xmlmappings-backdrop', backdrop: 'static', keyboard: false });
    modalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
    this.trackModalRef(modalRef, 'myCustomModalClasscreatexml');
    modalRef.result.then(() => {
      this.untrackModalRef(modalRef);
      this.ngxUiLoaderService.start();
      this.getRouteDetails().then(() => {
        this.ngxUiLoaderService.stop();
      });
    }, () => {
      this.untrackModalRef(modalRef);
    });
  }

  openPreDeliveryValidationMapping(): void {
    if (!this.selectedrouteId || !this.UniqueID) {
      this.toastr.error("Pipeline is mandatory", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    this.ngxUiLoaderService.start();
    this._ruleEngineService.GetRuleConfigVersions(this.UniqueID, 'Delivered').subscribe({
      next: (raw: any) => {
        const list = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : Array.isArray(raw?.Data) ? raw.Data : [];
        const { ruleData, hasExistingRules } = this.extractRuleConfigFromVersions(list);
        const finalRuleData = hasExistingRules ? ruleData : [];
        this.resolvePreDeliveryTemplateContext().then(async (templateContext) => {
          await this.ensureTestOrganizationFlagsLoaded();
          this.ngxUiLoaderService.stop();
          const dialogRef = this.dialog.open(RuleConfigComponentComponent, {
            maxWidth: '95vw',
            height: '96%',
            width: '100%',
            data: {
              data: finalRuleData,
              isView: hasExistingRules,
              routeGuid: this.selectedrouteId,
              routeName: this.selectedrouteDisplayName,
              routeUniqueID: this.UniqueID,
              ruleConfigVersions: list,
              ruleExecutionStage: 'Delivered',
              componentname: 'createpipeline',
              dialogTitle: 'Pre-Delivery Validation Rules',
              deliveryTemplateKey: this.getPreDeliveryTemplateKeyForCreate(),
              detectedOutputFormat: templateContext.detectedOutputFormat,
              defaultTemplateXml: templateContext.defaultTemplateXml,
              defaultTemplateId: templateContext.defaultTemplateId,
              defaultTemplateName: templateContext.defaultTemplateName,
              ...this.getTestOrganizationFlagsForChildDialogs(),
            },
            autoFocus: false,
            disableClose: true,
            panelClass: 'rule-config-dialog-container'
          });
          dialogRef.afterClosed().subscribe(() => {
            this.getRouteDetails();
          });
        });
      },
      error: () => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("An unexpected error occurred", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }

  private async resolvePreDeliveryTemplateContext(): Promise<{
    detectedOutputFormat: string;
    defaultTemplateXml: string;
    defaultTemplateId: string;
    defaultTemplateName: string;
  }> {
    const emptyContext = {
      detectedOutputFormat: '',
      defaultTemplateXml: '',
      defaultTemplateId: '',
      defaultTemplateName: ''
    };

    if (!this.selectedrouteId || !this.selectedprocessagentid || !this.selectedprocessapikey) {
      return emptyContext;
    }

    try {
      const url = "api/GetMappings/Get?routeid=" + this.selectedrouteId + "&processorid=" + this.selectedprocessagentid + "&processorapikey=" + this.selectedprocessapikey;
      const response: any = await new Promise((resolve, reject) => {
        this.service.getapiurl(url).subscribe({
          next: (data: any) => resolve(data),
          error: (err: unknown) => reject(err instanceof Error ? err : new Error(String(err)))
        });
      });

      const detectedOutputFormat = this.detectOutputFormatFromResponse(response);
      if (!detectedOutputFormat) {
        return emptyContext;
      }

      const templateList = Array.isArray(response?.templatelist) ? response.templatelist : [];
      const defaultTemplate = templateList.find((item: any) => {
        const templateFormat = this.normalizeFormatLabel(
          item?.inputFormat || item?.mappedFormat || item?.outputFormat || item?.format || ''
        );
        return this.isDefaultTemplate(item) && templateFormat === detectedOutputFormat;
      });

      if (!defaultTemplate?.templatexml) {
        return {
          detectedOutputFormat,
          defaultTemplateXml: '',
          defaultTemplateId: '',
          defaultTemplateName: ''
        };
      }

      return {
        detectedOutputFormat,
        defaultTemplateXml: defaultTemplate.templatexml,
        defaultTemplateId: (defaultTemplate.id ?? '').toString(),
        defaultTemplateName: (defaultTemplate.name ?? '').toString()
      };
    } catch {
      return emptyContext;
    }
  }

  private detectOutputFormatFromResponse(response: any): string {
    const explicitFormat = this.normalizeFormatLabel(
      response?.resultFormat ||
      response?.outputFormat ||
      response?.format ||
      response?.routeDetails?.OutputFormat ||
      response?.routeDetails?.outputFormat ||
      response?.routeDetails?.format
    );

    const payloadCandidates = [response?.resultjson, response?.mappedxml];
    const payloadFormats: string[] = [];
    payloadCandidates.forEach((candidate) => {
      const detected = this.detectOutputFormat(candidate);
      if (detected) {
        payloadFormats.push(detected);
      }
    });
    const payloadPreferred = this.pickPreferredFormat(payloadFormats);

    // Payload evidence is more reliable than stale metadata in this pre-delivery flow.
    return payloadPreferred || explicitFormat || '';
  }

  private normalizeFormatLabel(value: any): string {
    const raw = (value || '').toString().trim().toLowerCase();
    if (!raw) {
      return '';
    }
    if (raw.includes('hl7')) {
      return 'hl7';
    }
    if (raw.includes('xml')) {
      return 'xml';
    }
    if (raw.includes('json')) {
      return 'json';
    }
    return '';
  }

  private isDefaultTemplate(item: any): boolean {
    const raw = item?.IsDefault ?? item?.isDefault;
    if (raw === true || raw === 1) {
      return true;
    }
    const normalized = (raw ?? '').toString().trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'y';
  }

  private pickPreferredFormat(formats: string[]): string {
    if (!Array.isArray(formats) || formats.length === 0) {
      return '';
    }
    if (formats.includes('hl7')) {
      return 'hl7';
    }
    if (formats.includes('xml')) {
      return 'xml';
    }
    if (formats.includes('json')) {
      return 'json';
    }
    return '';
  }

  private detectOutputFormat(value: any): string {
    const raw = (value || '').toString().trim();
    if (!raw) {
      return '';
    }
    if (/\bMSH\|/i.test(raw)) {
      return 'hl7';
    }
    const normalizedFormat = this.normalizeFormatLabel(raw);
    if (normalizedFormat) {
      return normalizedFormat;
    }
    if (raw.startsWith('{') || raw.startsWith('[')) {
      try {
        const parsed = JSON.parse(raw);
        const nestedFormat = this.extractFormatFromJsonPayload(parsed);
        if (nestedFormat) {
          return nestedFormat;
        }
      } catch {
        // ignore parse errors and continue fallback checks
      }
    }
    if (raw.startsWith('<')) {
      return 'hl7';
    }
    if (raw.startsWith('{') || raw.startsWith('[')) {
      return 'json';
    }
    return '';
  }

  private extractFormatFromJsonPayload(payload: any): string {
    if (payload == null) {
      return '';
    }
    if (typeof payload === 'string') {
      return this.detectOutputFormat(payload);
    }
    if (Array.isArray(payload)) {
      return this.extractFormatFromJsonArray(payload);
    }
    if (typeof payload === 'object') {
      return this.extractFormatFromJsonObject(payload);
    }
    return '';
  }

  private extractFormatFromJsonArray(payload: any[]): string {
    for (const item of payload) {
      const nested = this.extractFormatFromJsonPayload(item);
      if (nested) {
        return nested;
      }
    }
    return '';
  }

  private extractFormatFromJsonObject(payload: Record<string, any>): string {
    for (const key of Object.keys(payload)) {
      const format = this.extractFormatFromJsonObjectKey(payload, key);
      if (format) {
        return format;
      }
    }
    return '';
  }

  private extractFormatFromJsonObjectKey(payload: Record<string, any>, key: string): string {
    const keyHint = this.normalizeFormatLabel(key);
    if (keyHint) {
      const valueHint = this.normalizeFormatLabel(payload[key]);
      if (valueHint) {
        return valueHint;
      }
    }
    return this.extractFormatFromJsonPayload(payload[key]);
  }

  private extractRuleConfigFromVersions(list: any[]): { ruleData: any; hasExistingRules: boolean } {
    if (!list || list.length === 0) {
      return { ruleData: null, hasExistingRules: false };
    }
    const latest = list[list.length - 1];
    const configData = latest?.RuleConfig ?? latest?.ruleConfig;
    if (!configData) {
      return { ruleData: null, hasExistingRules: false };
    }
    const savedRuleConfig = this.parseRuleConfig(configData);
    if (!savedRuleConfig) {
      return { ruleData: null, hasExistingRules: false };
    }
    const asArray = Array.isArray(savedRuleConfig) ? savedRuleConfig : [savedRuleConfig];
    const hasExistingRules = this.validateExistingRules(asArray);
    return { ruleData: asArray, hasExistingRules };
  }

  private parseRuleConfig(configData: any): any {
    try {
      if (typeof configData === 'string') {
        configData = JSON.parse(configData);
      }
      if (configData && typeof configData === 'object' && configData['RuleConfig']) {
        const nestedConfig = configData['RuleConfig'];
        return typeof nestedConfig === 'string' ? JSON.parse(nestedConfig) : nestedConfig;
      }
      return configData;
    } catch {
      return null;
    }
  }

  private validateExistingRules(savedRuleConfig: any): boolean {
    if (!Array.isArray(savedRuleConfig) || savedRuleConfig.length === 0) {
      return false;
    }
    const firstRule = savedRuleConfig[0];
    return !!(firstRule &&
      Array.isArray(firstRule.rules) &&
      firstRule.rules.length > 0 &&
      typeof firstRule.ruleSatisfaction === 'string');
  }
  private normalizeTestOrgFlagValue(value: unknown): string {
    return value != null && String(value).trim() === '1' ? '1' : '0';
  }

  private getTestOrganizationFlagsForChildDialogs(): {
    sourceIsTestOrganization: string;
    destinationIsTestOrganization: string;
  } {
    return {
      sourceIsTestOrganization: this.sourceIsTestOrganization || '0',
      destinationIsTestOrganization: this.destinationIsTestOrganization || '0',
    };
  }

  private entityMatchesGuidForTestOrg(item: any, entityGuid: string): boolean {
    const targetGuid = (entityGuid || '').toString().trim().toLowerCase();
    if (!targetGuid) {
      return false;
    }
    const candidateGuids = [
      item?.LocationGUID,
      item?.locationGUID,
      item?.orgguid,
      item?.orgGUID,
      item?.entityguid,
      item?.EntityGUID,
    ];
    return candidateGuids.some((guid) => (guid || '').toString().trim().toLowerCase() === targetGuid);
  }

  private resolveTestOrganizationFromSearchResults(list: any[], entityGuid: string): string {
    if (!list?.length || !entityGuid) {
      return '0';
    }
    const matchingEntities = list.filter((item: any) => this.entityMatchesGuidForTestOrg(item, entityGuid));
    if (!matchingEntities.length) {
      return '0';
    }
    const isTest = matchingEntities.some((item: any) =>
      this.normalizeTestOrgFlagValue(item?.istestorganization) === '1'
    );
    return isTest ? '1' : '0';
  }

  private toEntitySearchList(response: any): any[] {
    return Array.isArray(response) ? response : (response?.data || []);
  }

  async ensureTestOrganizationFlagsLoaded(
    sourceGuid?: string,
    destinationGuid?: string
  ): Promise<void> {
    const seguid = (sourceGuid || this.selectedsourceaccountid || '').toString().trim();
    const deguid = (destinationGuid || this.selectedtargetaccountid || '').toString().trim();
    if (!seguid || !deguid) {
      return;
    }
    if (
      this.testOrgFlagsLoadedForSourceGuid === seguid &&
      this.testOrgFlagsLoadedForDestGuid === deguid &&
      this.sourceIsTestOrganization !== '' &&
      this.destinationIsTestOrganization !== ''
    ) {
      return;
    }

    try {
      const response: any = await firstValueFrom(
        forkJoin({
          source: this.service.GetAccountNamesListAsync({ lsearch: seguid, lSearch: seguid }),
          destination: this.service.GetAccountNamesListAsync({ lsearch: deguid, lSearch: deguid }),
        })
      );
      const sourceList = this.toEntitySearchList(response?.source);
      const destinationList = this.toEntitySearchList(response?.destination);
      this.sourceIsTestOrganization = this.resolveTestOrganizationFromSearchResults(sourceList, seguid);
      this.destinationIsTestOrganization = this.resolveTestOrganizationFromSearchResults(destinationList, deguid);
      if (!this.sourceentityprimaryid || !this.selectedsourceorgid) {
        this.applySourceEntityIdsFromAccount(
          this.findAccountMatchInList(sourceList, seguid, this.sourcedeployementkey)
        );
      }
      if (!this.targetentityprimaryid || !this.selectedtargetorgid) {
        this.applyTargetEntityIdsFromAccount(
          this.findAccountMatchInList(destinationList, deguid, this.targetdeployementkey)
        );
      }
    } catch {
      this.sourceIsTestOrganization = '0';
      this.destinationIsTestOrganization = '0';
    }
    this.testOrgFlagsLoadedForSourceGuid = seguid;
    this.testOrgFlagsLoadedForDestGuid = deguid;
  }

   /** Same Look Ups modal as Mapping screen (InterfacemappingComponent / XMLMappings lookups). */
openLookupsModal(): void {
  if (!this.selectedrouteId || !this.UniqueID) {
    this.toastr.warning('Save the pipeline first to manage lookups.', '', {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
    return;
  }
  const dataToModal = {
    routeid: this.selectedrouteId,
    routename: this.selectedrouteDisplayName,
    uniqueid: this.UniqueID,
    templateid: '',
    templatename: '',
    LockInterfaceUpload: !!this.isLocked
  };
  const modalRef = this.modalService.open(InterfacemappingComponent, {
    windowClass: 'myCustomModalClasslookup',
    backdrop: 'static',
    keyboard: false
  });
  modalRef.componentInstance.inputDataInModalComponent = dataToModal;
  this.trackModalRef(modalRef, 'myCustomModalClasslookup');
  modalRef.result.then(
    () => this.untrackModalRef(modalRef),
    () => this.untrackModalRef(modalRef)
  );
  }
/** True when source agent display name contains "collect" (case-insensitive). Sent with GetInputXML as collectsourceagentflag. */
private isCollectSourceAgentName(): boolean {
  const name = (this.selectedsourceagentname ?? '').toString().toLowerCase();
  const display = (this.selectedsourceagentdisplayname ?? '').toString().toLowerCase();
  return name.includes('collect') || display.includes('collect');
}

openRoutingRulesMapping(isTriggeredByButton = false): void {
  if (!this.selectedrouteId || !this.UniqueID) {
    this.toastr.error("Pipeline is mandatory", "", {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
    return;
  }

  if (isTriggeredByButton) {
    this.ngxUiLoaderService.start();
    this._ruleEngineService.GetRuleConfigVersions(this.UniqueID, 'RoutingRuleQualification').subscribe({
      next: async (raw: any) => {
        this.ngxUiLoaderService.stop();
        await this.ensureTestOrganizationFlagsLoaded();
        const list = Array.isArray(raw) ? raw : [];
        const { ruleData, hasExistingRules } = this.extractRuleConfigFromVersions(list);
        const dialogData = {
          routingRuleConfig: hasExistingRules ? ruleData : [],
          ruleConfigVersions: list,
          conversionType: this.routingConversionType,
          routeGuid: this.selectedrouteId,
          routeName: this.selectedrouteDisplayName,
          routeUniqueID: this.UniqueID,
          routingAgentID: this.routingAgentId,
          ruleExecutionStage: 'RoutingRuleQualification',
          componentname: 'createpipeline',
          ...this.getTestOrganizationFlagsForChildDialogs(),
        };
        const dialogConfig = {
          maxWidth: '88vw',
          height: '93vh',
          width: '85vw',
          data: dialogData,
          autoFocus: false,
          disableClose: true,
          panelClass: 'routing-ruleconfig-dialog-container',
        };
        import('../routing-ruleconfig1/routing-ruleconfig1.component').then(
          ({ RoutingRuleconfig1Component }) => {
            this.dialog.open(RoutingRuleconfig1Component, dialogConfig);
          }
        );
      },
      error: () => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("An unexpected error occurred", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }
}

 /**
   * Reads `conversiontype` from processor `jsonconfig` via `api/Agents/GetSearchDetails`.
   * Uses destination-agent match between route data and processor jsonconfig
   * (`destinationagentid`) instead of comparing with a hardcoded routing agent id.
   */
  private async applyRoutingConversionTypeFromAgentSearch(data: any): Promise<void> {
    this.routingConversionType = '';
    this.isRoutingInterface = false;
    this.routingAgentId = '';
    const routeDestinationAgentId = (data?.['destinationagentid'] ?? '').toString().trim().toUpperCase();
    const processorId = (data?.['PAID'] ?? '').toString().trim();
    try {
      const response: any = await this.service.searchpostapi('api/Agents/GetSearchDetails', {
        id: processorId,
        type: 'Processor',
      });
      const resultset = Array.isArray(response) ? response : [];
      const first: any = resultset[0];
      let jsonconfig: any;
      try {
        jsonconfig = typeof first.jsonconfig === 'string' ? JSON.parse(first.jsonconfig) : first.jsonconfig;
        const isValidRoutingInterface = (jsonconfig?.isRoutingInterface ?? false);
        if (isValidRoutingInterface) {
          this.routingConversionType = (jsonconfig?.conversiontype ?? '').toString().trim();
          this.routingAgentId = routeDestinationAgentId;
          this.isRoutingInterface = true;
        }
      } catch {
        this.routingConversionType = '';
        this.isRoutingInterface = false;
        this.routingAgentId = '';
      }
    }catch {
      this.routingConversionType = '';
      this.isRoutingInterface = false;
      this.routingAgentId = '';
    }
  }
}

export interface inputField {
  data: any;
  formgroupname: FormGroup,
  formcontrolname: string;
  sequence: number;
  mapicon: boolean;
  islive: boolean;
}
export interface CustomFTPDetails {
  username: string;
  password: string;
  host: string;
  port: string;
  folder: string;
  id: string;
  archivepath: string;
}

export interface RuleConfigRequest {
  Type:string;
  EntityType:string;
  TypeName:string
  Guid:string
}
